<template>
  <el-container class="sideBar" id="RightSideBar">
    <el-main class="el-side-bar" v-loading.fullscreen.lock="fullscreenLoading">
      <div class="side-menu-top">
        <ul>
          <li class="lbl-top">
            <span>テーマ</span>
          </li>
          <li>
            <ul class="nested-list">
              <li v-if="display_today_article_link_flag" @click="todayArticleLoading" :class="{ activeList: 0 === activeTodayArticleLabel}">{{getTodayArticleLabel}}</li>
              <li v-for="(item, i) in getthemetopics"
                :key="item.id"
                :label="item.label"
                :value="item.value"
                :class="{ activeList: i === activeItemTopics}"
                @click="handleTopicsValue(item.value, item.id, i, item.label, item.news_article_count, item.web_article_count,item.magazine_article_count, item.sc_search_condition_defined_flag, item.web_news_search_condition_defined_flag, item.magazine_search_condition_defined_flag)">
                <span>{{item.value}}</span>
              </li>
              <li class="el-tree-list" v-if="defaultNodeExpansion">
                <div class="caretIcon">
                  <el-tree :data="getthemegrouptopics" @node-click="handleNodeClick" node-key="tree_key" :props="defaultProps" :highlight-current="true" class="subTreeOpen topTree Nullhandle" :default-expand-all="true" ref="themegrouptree" ></el-tree>
                </div>
              </li>
              <li class="el-tree-list" v-else>
                <div class="caretIcon">
                  <el-tree :data="getthemegrouptopics" node-key="tree_key" @node-click="handleNodeClick" :props="defaultProps" :highlight-current="true" class="subTreeOpen topTree Nullhandle" ref="themegrouptree" ></el-tree>
                </div>
              </li>
              <li v-for="(item, i) in gettheme"
                :key="item.id"
                :label="item.label"
                :value="item.value"
                :class="{ activeList: i === activeItem}"
                @click="handleThemeValue(item.value, item.id, i, item.label, item.news_article_count, item.web_article_count,item.magazine_article_count, item.sc_search_condition_defined_flag, item.web_news_search_condition_defined_flag,item.magazine_search_condition_defined_flag)">
                <span>{{item.value}}</span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <el-divider class="sidebar-divider"></el-divider>
      <div class="side-menu-middle">
        <ul>
          <li v-if="sendMailValue == 0 && display_theme_mail_link_flag == 1">
            <div class="ico_mail_up iconMailEnvalop" tabindex="0"></div>
            <span class="ReceiveEmailTheme" @click="sendTo0003Page">表示中のテーマをメール受信</span>
          </li>
          <li class="lbl-bottom">
            <span>その他</span>
          </li>
          <el-tree :data="data" class="subTreeOpen customTree" :expand-on-click-node="false">
            <span class="custom-tree-node" slot-scope="{ data }">
              <span v-if="data.id == '1'" class="treeFirstChild">
                <li class="searchBox">
                  <el-input v-model="input1" id="SearchBoxInput" @keyup.enter.native="articleSearch" :disabled="articleMedia == 1"></el-input>
                  <img src="../../assets/image/ico_search_up.svg" alt="search" class="searchIcon" @click="articleSearch" />
                </li>
              </span>
              <div v-if="data.id == '2'" type="primary" class="customDivNode">
                <div class="selectDivFirst">
                  <span class="leftDiv">
                    <el-label>検索条件</el-label>
                  </span>
                  <span class="rightDiv">
                    <el-select v-model="form.region" placeholder="" @change="searchConditionChange($event)">
                      <el-option
                        v-for="item in getsearchCondition"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </span>
                </div>
                <div class="selectDivThree">
                  <span class="leftDiv">
                    <el-label>記事の期間</el-label>
                  </span>
                  <span class="rightDiv">
                    <v-date-picker mode="range" :masks="{ title: 'YYYY年MMM' }" v-model="range"  locale="ja" :popover="{  visibility: 'click' }"/>
                  </span>
                </div>
                <div class="selectDivFour">
                  <span class="leftDiv">
                    <el-label>媒体名で検索</el-label>
                  </span>
                  <span class="rightDiv">
                    <el-input v-model="form.SearchMediaName" :disabled="articleMedia == 1"></el-input>
                  </span>
                </div>
                <div class="selectDivFour">
                  <span>
                    <el-button type="primary" class="searchConditionButton" @click="articleSearch">検索</el-button>
                  </span>
                </div>
              </div>
            </span>
          </el-tree>
          <li class="otherSpan">
            <router-link :to="{ name: '0011'}">
              <span>検索条件登録</span>
            </router-link>
          </li>
          <li class="otherSpan" v-if="pdf_usage_display_flag">
            <router-link :to="{ name: 'SID0014'}">
              <span>原文利用実績照会</span>
            </router-link>
          </li>
          <li class="otherSpan" v-if="external_link_flag">
            <div class="dataBase">
              <a :href=externalDbUrl target="_blank">
                データベース
              </a>
            </div>
            <div class="ico_link_up" tabindex="0"></div>
          </li>
        </ul>
      </div>
      <el-divider class="sidebar-divider" v-if="currentPath == 1"></el-divider>
    
     <!-- <el-footer>  -->
      <div class="buttonDiv" v-if="currentPath == 1">
        <el-button class="cal-top-btn" type="primary" @click="loadLatestDateArticle" round>最新日</el-button>
      </div>
      <div class="calenderDiv" v-if="currentPath == 1">
        <v-date-picker 
          class="custom-calender" 
          mode="range" 
          :masks="{ title: 'YYYY年MMM' }"
          :attributes="attributes"
          locale="ja" 
          :min-date="new Date(new Date().getFullYear(), new Date().getMonth() - 2, 1)" 
          :max-date="new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)" 
          v-model="date" 
          ref="calendar"
          is-inline 
          @input="selectDateForSearch">
          
        </v-date-picker>
      </div>
      <el-divider class="sidebar-divider"></el-divider>
      <div class="side-menu-bottom">
        <ul v-if="userAuthority == 1 && topics_creation_flag == false && news_administrator_menu_flag == true">
          <li class="">
            <router-link :to="{ name: '1002',params: {fromTopPage:'1'}}">
              <span>メール送信先選択画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1007'}">
              <span>メール配信先一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1003'}">
              <span>管理者からのお知らせ：登録画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1004'}">
              <span>テーマグループ一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1010'}">
              <span>ユーザーグループ一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: 'UserGroupList'}">
              <span>ユーザー一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1016'}">
              <span>トピックス情報一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1019-001'}">
              <span>トピックス作成画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1021'}">
              <span>記事件数確認条件設定画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1023'}">
              <span>記事メンテナンス画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1044'}">
              <span>メールテンプレート管理画面</span>
            </router-link>
          </li>
          <li class="" v-if="display_multiple_print_link_flag == 1">
            <router-link :to="{ name: '1043'}">
              <span>複数部印刷画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1040'}">
              <span>検索記事追加画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1035'}">
              <span>原文利用実績照会条件設定画面</span>
            </router-link>
          </li>
        </ul>
        <ul v-else-if="userAuthority == 1 && topics_creation_flag == true && news_administrator_menu_flag == true">
          <li class="">
            <router-link :to="{ name: '1002',params: {fromTopPage:'1'}}">
              <span>メール送信先選択画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1007'}">
              <span>メール配信先一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1003'}">
              <span>管理者からのお知らせ：登録画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1004'}">
              <span>テーマグループ一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1010'}">
              <span>ユーザーグループ一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: 'UserGroupList'}">
              <span>ユーザー一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1016'}">
              <span>トピックス情報一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1019-001'}">
              <span>トピックス作成画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1021'}">
              <span>記事件数確認条件設定画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1023'}">
              <span>記事メンテナンス画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1044'}">
              <span>メールテンプレート管理画面</span>
            </router-link>
          </li>
          <li class="" v-if="display_multiple_print_link_flag == 1">
            <router-link :to="{ name: '1043'}">
              <span>複数部印刷画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1040'}">
              <span>検索記事追加画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1035'}">
              <span>原文利用実績照会条件設定画面</span>
            </router-link>
          </li>
        </ul>
        <ul v-else-if="userAuthority == 1 && topics_creation_flag == false && web_administrator_menu_flag == true">
          <li class="">
            <router-link :to="{ name: '1002',params: {fromTopPage:'1'}}">
              <span>メール送信先選択画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1007'}">
              <span>メール配信先一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1003'}">
              <span>管理者からのお知らせ：登録画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1004'}">
              <span>テーマグループ一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1010'}">
              <span>ユーザーグループ一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: 'UserGroupList'}">
              <span>ユーザー一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1016'}">
              <span>トピックス情報一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1019-001'}">
              <span>トピックス作成画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1021'}">
              <span>記事件数確認条件設定画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1023'}">
              <span>記事メンテナンス画面</span>
            </router-link>
          </li>
          <li class="" v-if="magazine_administrator_menu_flag == true">
            <router-link :to="{ name: '1040'}">
              <span>検索記事追加画面</span>
            </router-link>
          </li>
        </ul>
        <ul v-else-if="userAuthority == 1 && topics_creation_flag == true && web_administrator_menu_flag == true">
          <li class="">
            <router-link :to="{ name: '1002',params: {fromTopPage:'1'}}">
              <span>メール送信先選択画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1007'}">
              <span>メール配信先一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1003'}">
              <span>管理者からのお知らせ：登録画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1004'}">
              <span>テーマグループ一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1010'}">
              <span>ユーザーグループ一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: 'UserGroupList'}">
              <span>ユーザー一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1016'}">
              <span>トピックス情報一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1019-001'}">
              <span>トピックス作成画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1021'}">
              <span>記事件数確認条件設定画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1023'}">
              <span>記事メンテナンス画面</span>
            </router-link>
          </li>
          <li class="" v-if="magazine_administrator_menu_flag == true">
            <router-link :to="{ name: '1040'}">
              <span>検索記事追加画面</span>
            </router-link>
          </li>
        </ul>
        <ul v-else-if="userAuthority == 1 && topics_creation_flag == false && magazine_administrator_menu_flag == true">
          <li class="">
            <router-link :to="{ name: '1002',params: {fromTopPage:'1'}}">
              <span>メール送信先選択画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1007'}">
              <span>メール配信先一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1003'}">
              <span>管理者からのお知らせ：登録画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1004'}">
              <span>テーマグループ一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1010'}">
              <span>ユーザーグループ一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: 'UserGroupList'}">
              <span>ユーザー一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1016'}">
              <span>トピックス情報一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1019-001'}">
              <span>トピックス作成画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1021'}">
              <span>記事件数確認条件設定画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1023'}">
              <span>記事メンテナンス画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1040'}">
              <span>検索記事追加画面</span>
            </router-link>
          </li>
        </ul>
        <ul v-else-if="userAuthority == 1 && topics_creation_flag == true && magazine_administrator_menu_flag == true">
          <li class="">
            <router-link :to="{ name: '1002',params: {fromTopPage:'1'}}">
              <span>メール送信先選択画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1007'}">
              <span>メール配信先一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1003'}">
              <span>管理者からのお知らせ：登録画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1004'}">
              <span>テーマグループ一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1010'}">
              <span>ユーザーグループ一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: 'UserGroupList'}">
              <span>ユーザー一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1016'}">
              <span>トピックス情報一覧画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1019-001'}">
              <span>トピックス作成画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1021'}">
              <span>記事件数確認条件設定画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1023'}">
              <span>記事メンテナンス画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1040'}">
              <span>検索記事追加画面</span>
            </router-link>
          </li>
        </ul>
        <ul v-else-if="userAuthority == 2 && topics_creation_flag == true">
          <li class="">
            <router-link :to="{ name: '1002',params: {fromTopPage:'1'}}">
              <span>メール送信先選択画面</span>
            </router-link>
          </li>
          <li class="">
            <router-link :to="{ name: '1019-001'}">
              <span>トピックス作成画面</span>
            </router-link>
          </li>
        </ul>
      </div>
      <el-dialog
        title
        :visible.sync="dialogVisible "
        :show-close="true"
        :close-on-click-modal="false"
        class="SID0003_Container"
        >
        <el-container class="SID0003__emailsecurity">
          <div class="SID0003__Container">
            <el-container>
              <el-form
                ref="form"
                :rules="rules"
                :model="Dialogform"
                class="div-form formMailVaidate"
                label-width="auto"
              >
                <el-form-item label="設定対象テーマ" class="label-emailform0003">
                  <span id="label-left-align">{{setMailThemeValue}}</span>
                </el-form-item>
                  <el-form-item label="媒体" class="emailform0003" prop="medium">
                  <el-checkbox-group v-model="Dialogform.medium" v-if="elnet_user == 0">
                    <el-checkbox label='1' class="checkbox0003" v-if="news_article_flag && user_group_news_article_flag" :disabled="sc_search_condition_flag">新聞</el-checkbox>
                    <el-checkbox label='2' class="checkbox0003" v-if="magazine_article_flag && user_group_magazine_article_flag" :disabled="magazine_search_condition_flag">雑誌/WEB</el-checkbox>
                    <el-checkbox label='3'  v-if="web_news_article_flag && user_group_web_news_article_flag" :disabled="web_news_search_condition_flag">WEB</el-checkbox>
                  </el-checkbox-group>
                   <el-checkbox-group v-model="Dialogform.medium" v-else>
                    <el-checkbox label='1' class="checkbox0003" :disabled="sc_search_condition_flag">新聞</el-checkbox>
                    <el-checkbox label='2' class="checkbox0003" :disabled="magazine_search_condition_flag">雑誌/WEB</el-checkbox>
                    <el-checkbox label='3' :disabled="web_news_search_condition_flag">WEB</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="配信先メールアドレス" class="emailform0003 formheight"  prop="Emailinput1">
                  <el-input v-model="Dialogform.Emailinput1"></el-input>
                </el-form-item>
                <el-form-item label="配信先メールアドレス(確認用)" class="emailform0003 formheight" prop="Emailinput2">
                  <el-input v-model="Dialogform.Emailinput2"></el-input>
                </el-form-item>
                <span class="emailsecurity0003">メール配信停止をご希望の方は、本サービスの管理者に連絡してください。</span>
                <el-row class="ButtonDiv">
                  <!-- 2021/08/02  #11641  START -->
                  <el-button type="primary" plain @click="open('form')" :disabled="Buttonpressed == 1">登録</el-button>
                  <!-- 2021/08/02  #11641  END -->
                  <el-button type="info" plain @click="gototop('form')">戻る</el-button>
                </el-row>
              </el-form>
            </el-container>
          </div>
        </el-container>
      </el-dialog>
                      
                <!-- newly Added  Ending ******   -->
    </el-main>
  </el-container>
</template>

<script>
import json from "../../components/config.json";
import Vue from "vue";
import VCalendar from "v-calendar-ie11";
import { mapGetters } from "vuex";
import router from '../../router';
import Common from '../../common/CommonFunc.js'
Vue.use(VCalendar);
var CurrentYear = new Date().getFullYear();
var CurrentMonth = new Date().getMonth();
var CurrentDay = new Date().getDate();
var FifteendaysBefore = CurrentDay - 14;
export default {
  name: "Side-Bar",
  data() {
    var confirmEmail = (rules, value, callback) => {
        var emailConfirm = this.Dialogform.Emailinput1;
        var sympattern= /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/
        var emailPattern = /^[a-zA-Z0-9@._+-]+$/
        var regex = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g;
        var chksym= value;
        if(regex.test(chksym))
        {
          callback(new Error("メールアドレスは半角英数字を入力してください。"));
        }
        else if (!chksym.match(emailPattern)) 
        {
          callback(new Error('メールアドレスに使用できない文字が含まれています。'));
        }
        else if (!chksym.match(sympattern)) 
        {
          callback(new Error('メールアドレスを正しく入力してください。'));
        }
        else if (value != emailConfirm) 
        {
          callback(new Error("メールアドレスがメールアドレス（確認用）と一致しないので、再入力してください。"));
        }
        else
        {
          callback();
        }
    };

    return {
      defaultProps: {
          children: 'children',
          label: 'label',
          id:'id'
      },
      // 2021/08/02  #11641  START
      Buttonpressed: 0,
      // 2021/08/02  #11641  END
      fullscreenLoading: false,
      defaultDateLoading: 0,
      pdf_usage_display_flag: false,
      subtheme_display_flag: 0,
      defaultNodeExpansion: false,
      display_today_article_link_flag: false,
      date: {
        start: new Date(CurrentYear, CurrentMonth, FifteendaysBefore), // Jan 16th, 2018
        end: new Date(CurrentYear, CurrentMonth, CurrentDay) // Jan 19th, 2018
      },
      attributes: [
        {
          bar: {
            color: 'purple',
            class: 'my-dot-class',
          },
          dates: [],
        },
        {
          bar: 'purple',
          dates: [],
        },
        {
          bar: 'purple',
          dates: [],
        },
        {
          bar: 'purple',
          dates: [],
        },
      ],
      dialogVisible:false,
      Dialogform:{
      medium:[],
      Emailinput1:'',
      Emailinput2:''
      },
      addressvalue:'',
      type: [],
      themevalue:'',
      setMailTheme: '',
      currentPath: 0,
      rules: {
        Emailinput1: [
          {required: true,message: 'メールアドレスを入力して下さい。'},
          {validator: confirmEmail,trigger:'blur'},
          { max:256, message: 'メールアドレスは256文字以下を入力してください。' }
        ],
        Emailinput2: [
          {required: true,message: 'メールアドレス(確認用)を入力してください。'},
          {validator: confirmEmail, trigger:'blur'},
          { max:256, message: 'メールアドレスは256文字以下を入力してください。' },
        ],
        medium: [
          {
            required:true,
            message:'媒体が1つ以上を選択してください。',
            trigger:'change'
          }
        ]
      },
       activeItem: null,
       activeItemTopics: null,
       activeTodayArticleLabel: null,
       setMailThemeValue: '',
       setMailThemeId: '',
       data_kbn: 3,
      form: {
        user: "",
        region: '',
        SearchMediaName: ''
      },
      value: "",
      input1: "",
      userAuthority: '',
      userId: '',
      contractId: '',
      theme_browsing: '',
      select_search_value: '',
      articleMedia: 0,
      sendMailValue: 1,
      startDateResult: '',
      endDateResult: '',
      refreshing: false,
      themeValueDate: '',
      scroll_sort_date: '',
      scroll_sort_title: '',
      topics_creation_flag: '',
      external_link_flag: false,
      display_theme_mail_link_flag: '0',
      display_multiple_print_link_flag: '0',
      web_administrator_menu_flag: false,
      news_administrator_menu_flag: false,
      magazine_administrator_menu_flag: false,
      news_article_flag: false,
      web_news_article_flag: false,
      magazine_article_flag: false,
      user_group_news_article_flag: false,
      user_group_web_news_article_flag: false,
      user_group_magazine_article_flag: false,
      elnet_user:'0',
      today_article_label: "",
      articleDate: '',
      restrictDateFunction: 0,
      themeValueAfterLogin: '',
      themeIdAfterLogin: '',
      themeLabelAfterLogin: '',
      themeNewsCountAfterLogin: '',
      themeWebCountAfetrLogin: '',
      flagForSetDefaultCount: 0,
      restrictThemeApiCall: 1,
      sc_search_condition_flag: true,
      web_news_search_condition_flag: true,
      magazine_search_condition_flag: true,
      externalDbUrl: '',
      request_count: 0,
      range: {
        start: new Date(CurrentYear, CurrentMonth, FifteendaysBefore), // Jan 16th, 2018
        end: new Date(CurrentYear, CurrentMonth, CurrentDay) // Jan 19th, 2018
      },
      data: [
        {
          id: 1,
          label: "Level one 1",
          children: [
            {
              id: 2,
              label: "記事の検索"
            }
          ]
        }
      ],
    };
  },
  watch:{
    request_count: function (val){
      if(val > 0){
        this.$store.commit('situation/setIsTopPageInitialLoading', true);
      }else{
        this.$store.commit('situation/setIsTopPageInitialLoading', false);
      }
    }
  },
  methods: {
    //methods for moving calender month based on given input dates
    calendarmove(loadingmonth, loadingyear){
      if(document.getElementsByClassName("vc-arrows-container").length == 1 && document.getElementsByClassName("vc-arrows-container").length != 0)
      {
        var frontarrow = document.getElementsByClassName("vc-arrows-container")[0].children[1]
        var backarrow = document.getElementsByClassName("vc-arrows-container")[0].children[0]
        var getcurrentmonth = document.getElementsByClassName("vc-title")[0].innerText;
        var fullyear = getcurrentmonth.slice(0 , 4)
        var fullmonth = getcurrentmonth.slice(5 , -1)
        var d1 = new Date(loadingyear, loadingmonth)
        var d2 = new Date(fullyear, fullmonth)
        if(d1 < d2)
        {
          var months;
          months = (d2.getFullYear() - d1.getFullYear()) * 12;
          months -= d1.getMonth();
          months += d2.getMonth();
          for(var i=0;i<months;i++)
          {
            if(d1 < d2)
            {
              backarrow.click();
            }
            else
            {
              frontarrow.click();
            }
          } 
        }
        else
        {
          var monthsnew;
          monthsnew = (d1.getFullYear() - d2.getFullYear()) * 12;
          monthsnew -= d2.getMonth();
          monthsnew += d1.getMonth();
          for(var j=0;j<monthsnew;j++)
          {
            if(d1 > d2)
            {
              frontarrow.click();
            }
            else
            {
              backarrow.click();
            }
          } 
        }
      }
      else
      {
        //console.log("Calender function called in screen other than top page")
      }
      
    },
    //method for load the article based on today's date
    todayArticleLoading(){
      this.$LogButtonEvent("side-bar","TodayArticle");
      this.$LogMethodIN("side-bar","todayArticleLoading");

      if(this.currentPath != 1)
      {
        this.$store.commit('situation/setThemeloadFlagFromOtherScreen', true);
        this.$store.commit('situation/setTodayArticleFlag', true);
        Vue.prototype.$session.set('defaultSearchLoadFlag', false);
        Vue.prototype.$session.set('defaultThemeLoadFlag', true);
        router.push('/0002');
      }
      else
      {
        // If selected date in main calendar is empty, then loading previously selected value in main calendar
        if(this.date.start == '' && this.date.end == '')
        {
          this.restrictThemeApiCall = 1
          this.setPreviouslySelectedDate();
        }
        //2020/11/30  BT08460_EXTERNAL-1849  START
        this.$store.commit("situation/setSelectedTheme", [{value: "TodayArticle", id: null}]);
        //2020/11/30  BT08460_EXTERNAL-1849  END
        //hide the mail link when today article link is displayed
        this.sendMailValue = 1;
        var inputParam;
        var totalNewsLabel;
        var webinputParam;
        var webNewsLabel;
        this.request_count++;
        this.$store.dispatch('communication/resetAllArticleValues').then(() => {

          this.$store.commit('situation/setSearchConditionKey', 0);
          this.$store.commit('situation/setTodayArticleFlag', true);

          /*Reset the highlight of theme group selection */
          var theme_group_key = this.$refs.themegrouptree.getCurrentKey();
          if(theme_group_key != null){
            this.$refs.themegrouptree.setCurrentKey(null);
          }
          /*Reset the highlight of theme group selection */

          this.activeItem = null;
          this.activeItemTopics = null;

          //Highlight the today article label
          this.activeTodayArticleLabel = 0;

          this.restrictThemeApiCall = 0;
          this.restrictDateFunction = 0;
          //parameter for api AID0005
          inputParam ={
            contract_id: this.contractId,
            process_date_start: this.startDateResult,
            process_date_end: this.endDateResult,
            sort_date: '',
            sort_title:'',
            start_num:1,
            load_num:10
          }
          
          this.articleDate = this.startDateResult + ' ' + '-' + ' ' + this.endDateResult;
          this.$store.commit('situation/setDefaultThemeStartDate', this.startDateResult);
          this.$store.commit('situation/setDefaultThemeEndDate', this.endDateResult);

          this.$store.commit('situation/setThemeIdForPdfSuccess', null);
          this.$store.commit('situation/setThemeGroupIdForPdfSuccess', null);
          this.$store.commit('situation/setTopicsIdForPdfSuccess', null);

          
          this.$store.commit('situation/setScRegisterFlag', true);
          this.$store.commit('situation/setWebregisterFlag', true);
          this.$store.commit('situation/setMagazineregisterFlag', true);
          Vue.prototype.$session.set('InputParameterFor0006',inputParam);
          Vue.prototype.$session.set('CurrentAID',"0005");
          
          //Api call for get the news article
          this.fullscreenLoading = true;
          this.request_count++;
          this.$store.dispatch('communication/getNewspaperArticles', inputParam).then(() => {
            this.fullscreenLoading = false;
            totalNewsLabel = "新聞(" + this.getTodayArticleNewsCount + "件)";
            Vue.prototype.$session.set('CurrentNewsCount',this.getTodayArticleNewsCount);
            this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
            this.$store.commit('situation/setArticleDate', this.articleDate);
            this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
            this.$store.commit("situation/setThemeNewsCount", this.getTodayArticleNewsCount);
            this.request_count--;
          }).catch(()=>{
            this.fullscreenLoading = false;
            totalNewsLabel = "新聞(" + this.getTodayArticleNewsCount + "件)";
            Vue.prototype.$session.set('CurrentNewsCount',this.getTodayArticleNewsCount);
            this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
            this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
            this.$store.commit('situation/setArticleDate', this.articleDate);
            this.$store.commit("situation/setThemeNewsCount", this.getTodayArticleNewsCount);
            this.request_count--;
          })
        
          //parameter for api AID0005
          webinputParam ={
            contract_id: this.contractId,
            data_section: 3,
            process_date_start:this.startDateResult,
            process_date_end:this.endDateResult,
            sort_date:'',
            sort_title:'',
            start_num:1,
            load_num:10
          }
          
          this.fullscreenLoading = true;
          //Api call to get web article
          this.request_count++;
          this.$store.dispatch('communication/getWebArticles', webinputParam).then(() => {
            this.fullscreenLoading = false;
            webNewsLabel = "WEB(" + this.getTodayArticleWebNewsCount + "件)";
            this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
            this.fullscreenLoading = false;
            this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
            this.$store.commit('situation/setArticleDate', this.articleDate);
            this.$store.commit("situation/setThemeWebCount", this.getTodayArticleWebNewsCount);
            this.request_count--;
          }).catch(()=>{
            this.fullscreenLoading = false;
            webNewsLabel = "WEB(" + this.getTodayArticleWebNewsCount + "件)";
            this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
            this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
            this.$store.commit('situation/setArticleDate', this.articleDate);
            this.$store.commit("situation/setThemeWebCount", this.getTodayArticleWebNewsCount);
            this.request_count--;
          })

          let magazineinputParam ={
            contract_id: this.contractId,
            data_section: 5,
            process_date_start:this.startDateResult,
            process_date_end:this.endDateResult,
            sort_date:'',
            sort_title:'',
            start_num:1,
            load_num:10
          }

          this.fullscreenLoading = true;
          //Api call to get magazine article
          this.request_count++;
          this.$store.dispatch('communication/getMagazineArticles', magazineinputParam).then(() => {
            this.fullscreenLoading = false;
            let magazineNewsLabel = "雑誌(" + this.getTodayArticleMagazineNewsCount + "件)";
            this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
            this.fullscreenLoading = false;
            this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
            this.$store.commit('situation/setArticleDate', this.articleDate);
            this.$store.commit("situation/setThemeMagazineCount", this.getTodayArticleMagazineNewsCount);
            this.request_count--;
          }).catch(()=>{
            this.fullscreenLoading = false;
            let magazineNewsLabel = "雑誌(" + this.getTodayArticleMagazineNewsCount + "件)";
            this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
            this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
            this.$store.commit('situation/setArticleDate', this.articleDate);
            this.$store.commit("situation/setThemeMagazineCount", this.getTodayArticleMagazineNewsCount);
            this.request_count--;
          })

          this.request_count--;
        })
        this.$LogMethodOut("side-bar","todayArticleLoading");
      }
    },
    //methods for hide mail sent link
    hideThememailLink(){
      this.sendMailValue = 1
    },
    //method for load the article based on latest date
    loadLatestDateArticle(){
      this.$LogButtonEvent("side-bar","LatestDay");
      this.$LogMethodIN("side-bar","loadLatestDateArticle");
      if(this.date){
        this.date.start = ''
        this.date.end = ''
      }
      
      this.restrictDateFunction = 1;

      this.$store.dispatch('communication/resetAllArticleValues').then(() => {

        this.restrictThemeApiCall = 1;

        var latestNewsDate = this.getSortedElArticleDate[this.getSortedElArticleDate.length - 1]

        var sdate = new Date(latestNewsDate),
        smnth = ("0" + (sdate.getMonth() + 1)).slice(-2),
        sday = ("0" + (sdate.getDate())).slice(-2);
        //convert the date format
        var startResult = [sdate.getFullYear(), smnth, sday].join("/");

        this.date = {
          start: new Date(startResult),
          end: new Date(startResult)
        }

        this.articleDate = startResult + ' ' + '-' + ' ' + startResult;

        this.startDateResult = startResult;
        this.endDateResult = startResult;

        // 2023/04/09  #14188  START
        Vue.prototype.$session.set('SelectStartDate', this.startDateResult);
        Vue.prototype.$session.set('SelectEndDate', this.endDateResult );
        // 2023/04/09  #14188  END

        this.$store.commit('situation/setSearchConditionKey', 0);

        this.$store.commit('situation/setDefaultThemeStartDate', this.startDateResult);
        this.$store.commit('situation/setDefaultThemeEndDate', this.endDateResult);

        //call the calender move function based on given input dates
        this.calendarmove(smnth, sdate.getFullYear());

        var themeDetails = {
          contract_id: this.contractId,
          theme_browsing: this.theme_browsing,
          user_id: this.userId,
          display_id: "SID0002",
          process_date_start: startResult,
          process_date_end: startResult
        };

        var existingArticleDetails = [];

        existingArticleDetails = [...existingArticleDetails, themeDetails, this.themeValueDate, this.setMailThemeId];
        this.fullscreenLoading = true;
        //Api call to get article theme values
        this.$store.dispatch('communication/getTheme', existingArticleDetails).then(() => {
          this.fullscreenLoading = false;
          // var serchResultLabel;
          var inputParam;
          var webinputParam;
          var magazineinputParam;
          var totalNewsLabel;
          var webNewsLabel;
          if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)//if date is changed for themes
          {
            //make the mail transition link as clickable
            this.sendMailValue = 0;

            //condition for sc_search_condition_defined_flag
            if(this.getScRegisterFlag == true)
            {
              this.sc_search_condition_flag = false;
            }
            else
            {
              this.sc_search_condition_flag = true;
            }
            //condition for web_news_search_condition_defined_flag
            if(this.getWebRegisterFlag == true)
            {
              this.web_news_search_condition_flag = false;
            }
            else
            {
              this.web_news_search_condition_flag = true;
            }
            if(this.getMagazineRegisterFlag == true){
              this.magazine_search_condition_flag = false;
            }
            else
            {
              this.magazine_search_condition_flag = true;
            }
            //Highlight in side bar
            if(this.themeValueDate == "Theme")
            {
              //Search theme index in theme group
              var theme_index = -1;
              var themes = this.gettheme;
              
              for(var i=0; i<themes.length;i++)
              {
                var current_theme_id = themes[i].id
                if(this.setMailThemeId == current_theme_id)
                {
                  theme_index = i;
                  break;
                }
              }

              var theme_group_tree_key = -1;
              if(theme_index == -1)
              {
                var theme_groups_themes = this.getthemegrouptopics
                loop1:
                for(var tgi=0; tgi<theme_groups_themes.length;tgi++)
                {
                  var themes_children = theme_groups_themes[tgi].children;  
                  for(var j=0; j<themes_children.length;j++)
                  {
                    var current_themechildren_id = themes_children[j].id
                    if(this.setMailThemeId == current_themechildren_id)
                    {
                      
                      theme_group_tree_key = themes_children[j].tree_key;
                      break loop1;
                    }
                  }
                }

              }

              if(theme_index > -1)
              {
                
                //Highlight first theme
                this.activeItem = theme_index;
                this.$refs.themegrouptree.setCurrentKey(null)
              }
              else if(theme_group_tree_key > -1)
              {
              
                //Highlight first theme
                this.activeItem = null;
                this.$refs.themegrouptree.setCurrentKey(theme_group_tree_key)
              }
              else
              {
                
                this.activeItem = null;
                this.$refs.themegrouptree.setCurrentKey(null)
              }
              
              //Disable highlight others
              this.activeItemTopics = null;
              
            }
            else if(this.themeValueDate == "Theme Group")
            {
              var theme_group_index = -1
              var theme_groups = this.getthemegrouptopics
              for(var k=0; k<theme_groups.length;k++)
              {
              
                var current_themegroup_id = theme_groups[k].id
                if(this.setMailThemeId == current_themegroup_id)
                {
                  theme_group_index = theme_groups[k].tree_key;
                  break;
                }
              }
              if(theme_group_index == -1)
              {
              
                this.$refs.themegrouptree.setCurrentKey(null)
              }
              else
              {
                //Highlight  theme group
                this.$refs.themegrouptree.setCurrentKey(theme_group_index)
              }
              
              //Disable highlight others
              this.activeItem = null;
              this.activeItemTopics = null;
            }
            else if(this.themeValueDate == "Topics")
            {
              var topics_index = -1
              var topics = this.getthemetopics
              for(var l=0; l<topics.length;l++)
              {
              
                var current_topics_id = topics[l].id
                if(this.setMailThemeId == current_topics_id)
                {
                  topics_index = l;
                  break;
                }
              }
              if(topics_index == -1)
              {
                this.activeItemTopics = null;
                
              }
              else
              {
                //Highlight  topics
                this.activeItemTopics = topics_index;
              }
              
              //Disable highlight others
              this.$refs.themegrouptree.setCurrentKey(null)
              this.activeItem = null;
            }
            else
            {
              //No action required
            }

            if(this.themeValueDate == "Theme")
            {

              inputParam ={
                contract_id: this.contractId,
                process_date_start:startResult,
                process_date_end:startResult,
                sort_date: '',
                sort_title:'',
                start_num:1,
                load_num:10,
                theme_id:this.setMailThemeId
              }

              webinputParam ={
                contract_id: this.contractId,
                data_section: 3,
                process_date_start:startResult,
                process_date_end:startResult,
                sort_date:'',
                sort_title:'',
                start_num:1,
                load_num:10,
                theme_id:this.setMailThemeId
              }

              magazineinputParam ={
                contract_id: this.contractId,
                data_section: 5,
                process_date_start:startResult,
                process_date_end:startResult,
                sort_date:'',
                sort_title:'',
                start_num:1,
                load_num:10,
                theme_id:this.setMailThemeId
              }
            }
            else if(this.themeValueDate == "Theme Group")
            {
              
              inputParam ={
                contract_id: this.contractId,
                process_date_start:startResult,
                process_date_end:startResult,
                sort_date: '',
                sort_title:'',
                start_num:1,
                load_num:10,
                theme_group_id:this.setMailThemeId
              }

              webinputParam ={
                contract_id: this.contractId,
                data_section: 3,
                process_date_start:startResult,
                process_date_end:startResult,
                sort_date:'',
                sort_title:'',
                start_num:1,
                load_num:10,
                theme_group_id:this.setMailThemeId
              }

              magazineinputParam ={
                contract_id: this.contractId,
                data_section: 5,
                process_date_start:startResult,
                process_date_end:startResult,
                sort_date:'',
                sort_title:'',
                start_num:1,
                load_num:10,
                theme_group_id:this.setMailThemeId
              }
            }
            else if(this.themeValueDate == "Topics")
            {

              inputParam ={
                contract_id: this.contractId,
                process_date_start:startResult,
                process_date_end:startResult,
                sort_date: '',
                sort_title:'',
                start_num:1,
                load_num:10,
                topics_id:this.setMailThemeId
              }

              webinputParam ={
                contract_id: this.contractId,
                data_section: 3,
                process_date_start:startResult,
                process_date_end:startResult,
                sort_date:'',
                sort_title:'',
                start_num:1,
                load_num:10,
                topics_id:this.setMailThemeId
              }

              magazineinputParam ={
                contract_id: this.contractId,
                data_section: 5,
                process_date_start:startResult,
                process_date_end:startResult,
                sort_date:'',
                sort_title:'',
                start_num:1,
                load_num:10,
                topics_id:this.setMailThemeId
              }
            }
            else
            {
              //no action needed
            }

            if(this.getThemeNewsCount != 0)
            {
              this.fullscreenLoading = true;
              this.$store.commit('situation/setIsTopPageInitialLoading', true);
              Vue.prototype.$session.set('InputParameterFor0006',inputParam);
              Vue.prototype.$session.set('CurrentAID',"0005");
              //Api call for displaying the News article based on selected theme
              this.$store.dispatch('communication/getNewspaperArticles', inputParam).then(() => {
                this.$store.commit('situation/setArticleDate', this.articleDate);
                this.restrictDateFunction = 0;
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
                totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)"
                Vue.prototype.$session.set('CurrentNewsCount',this.getThemeNewsCount);
                this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
                this.fullscreenLoading = false;
              })
              .catch(() => {
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
                totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)"
                Vue.prototype.$session.set('CurrentNewsCount',this.getThemeNewsCount);
                this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
                this.fullscreenLoading = false;
                this.restrictDateFunction = 0;
              })
            }
            else
            {
              this.$store.commit('situation/setArticleDate', this.articleDate);
              this.restrictDateFunction = 0
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)"
              this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
            }
        
            if(this.getThemeWebCount != 0)
            {
              this.fullscreenLoading = true
              this.$store.commit('situation/setIsTopPageInitialLoading', true);
              //Api call to get web article based on selected theme
              this.$store.dispatch('communication/getWebArticles', webinputParam).then(() => {
                this.$store.commit('situation/setArticleDate', this.articleDate);
                this.restrictDateFunction = 0
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
                webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                this.fullscreenLoading = false;
              })
              .catch(() => {
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
                webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                this.fullscreenLoading = false;
              })
            }
            else
            {
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
              this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
              this.$store.commit('situation/setArticleDate', this.articleDate);
            }

            if(this.getThemeMagazineCount != 0)
            {
              this.fullscreenLoading = true
              this.$store.commit('situation/setIsTopPageInitialLoading', true);
              //Api call to get web article based on selected theme
              this.$store.dispatch('communication/getMagazineArticles', magazineinputParam).then(() => {
                this.$store.commit('situation/setArticleDate', this.articleDate);
                this.restrictDateFunction = 0
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
                let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                this.fullscreenLoading = false;
              })
                  .catch(() => {
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                    this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                    this.fullscreenLoading = false;
                  })
            }
            else
            {
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
              this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
              this.$store.commit('situation/setArticleDate', this.articleDate);
            }
          }
          else if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == true)//if date is changed for today's article link
          {
            this.$store.dispatch('communication/resetAllArticleValues').then(() => {
              //make the mail transition link as disable
              this.sendMailValue = 1;

              //Highlight the today article label
              this.activeTodayArticleLabel = 0;

              //parameter for api AID0005
              inputParam ={
                contract_id: this.contractId,
                process_date_start: this.startDateResult,
                process_date_end: this.endDateResult,
                sort_date: '',
                sort_title:'',
                start_num:1,
                load_num:10
              }
              Vue.prototype.$session.set('InputParameterFor0006',inputParam);
              Vue.prototype.$session.set('CurrentAID',"0005");
              //Api call for get the news article
              this.$store.commit('situation/setIsTopPageInitialLoading', true);
              this.$store.dispatch('communication/getNewspaperArticles', inputParam).then(() => {
                totalNewsLabel = "新聞(" + this.getTodayArticleNewsCount + "件)";
                Vue.prototype.$session.set('CurrentNewsCount',this.getTodayArticleNewsCount);
                this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
                this.$store.commit('situation/setArticleDate', this.articleDate);
                this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                this.$store.commit("situation/setThemeNewsCount", this.getTodayArticleNewsCount);
              }).catch(()=>{
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
                totalNewsLabel = "新聞(" + this.getTodayArticleNewsCount + "件)";
                Vue.prototype.$session.set('CurrentNewsCount',this.getTodayArticleNewsCount);
                this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
                this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                this.$store.commit('situation/setArticleDate', this.articleDate);
                this.$store.commit("situation/setThemeNewsCount", this.getTodayArticleNewsCount);
              })
            
              //parameter for api AID0005
              webinputParam ={
                contract_id: this.contractId,
                data_section: 3,
                process_date_start:this.startDateResult,
                process_date_end:this.endDateResult,
                sort_date:'',
                sort_title:'',
                start_num:1,
                load_num:10
              }
              
              //Api call to get web article
              this.$store.commit('situation/setIsTopPageInitialLoading', true);
              this.$store.dispatch('communication/getWebArticles', webinputParam).then(() => {
                webNewsLabel = "WEB(" + this.getTodayArticleWebNewsCount + "件)";
                this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
                this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                this.$store.commit('situation/setArticleDate', this.articleDate);
                this.$store.commit("situation/setThemeWebCount", this.getTodayArticleWebNewsCount);
              }).catch(()=>{
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
                webNewsLabel = "WEB(" + this.getTodayArticleWebNewsCount + "件)";
                this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                this.$store.commit('situation/setArticleDate', this.articleDate);
                this.$store.commit("situation/setThemeWebCount", this.getTodayArticleWebNewsCount);
              })

              let magazineinputParam ={
                contract_id: this.contractId,
                data_section: 5,
                process_date_start:this.startDateResult,
                process_date_end:this.endDateResult,
                sort_date:'',
                sort_title:'',
                start_num:1,
                load_num:10
              }
              this.$store.commit('situation/setIsTopPageInitialLoading', true);
              this.$store.dispatch('communication/getMagazineArticles', magazineinputParam).then(() => {
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
                let magazineNewsLabel = "雑誌(" + this.getTodayArticleMagazineNewsCount + "件)";
                this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                this.$store.commit('situation/setArticleDate', this.articleDate);
                this.$store.commit("situation/setThemeMagazineCount", this.getTodayArticleMagazineNewsCount);
              }).catch(()=>{
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
                let magazineNewsLabel = "雑誌(" + this.getTodayArticleMagazineNewsCount + "件)";
                this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                this.$store.commit('situation/setArticleDate', this.articleDate);
                this.$store.commit("situation/setThemeMagazineCount", this.getTodayArticleMagazineNewsCount);
              })
            })
          }
          else
          {
            //no action needed
          }

          this.$store.commit('situation/setCsvSearchDownload', 0);
          this.restrictThemeApiCall = 0;
        }).catch(() => {
          this.fullscreenLoading = false;
        })
      })
      this.$LogMethodOut("side-bar","loadLatestDateArticle");
    },
    //method for load the article based on date selected in calender
    selectDateForSearch(){
      this.$LogButtonEvent("side-bar","SelectDate");
      this.$LogMethodIN("side-bar","selectDateForSearch");
      // 2023/04/23  #14188  START
      if(this.getThemeloadFlagFromOtherScreen){
        return
      }
      // 2023/04/23  #14188  END
      console.log('this.restrictThemeApiCall: ', this.restrictThemeApiCall);
      if(this.restrictThemeApiCall != 1)
      {
        this.$store.commit('situation/setSearchConditionKey', 0);

        this.$store.commit('situation/setArticleDetails', []);
        this.$store.commit('situation/setSecondTabArticleDetails', []);
        this.$store.commit('situation/setAllCheckboxSelectDetails', false);
        this.$store.commit('situation/setNewsTabCheckboxSelectDetails', false);
        this.$store.commit('situation/setSortDateText', false);
        this.$store.commit('situation/setSortTitleText', false);
        this.$store.commit('situation/setSortDateTextForNewsTab', false);
        this.$store.commit('situation/setSortTitleTextForNewsTab', false);

        this.$store.commit('situation/setWebCsvDetails', []);
        this.$store.commit('situation/setWebSecondTabCsvDetails', []);
        this.$store.commit('situation/setWebSecondTabCheckboxSelect', false);
        this.$store.commit('situation/setWebCheckboxSelect', false);

        this.$store.commit('situation/setMagazineCsvDetails', []);
        this.$store.commit('situation/setMagazineSecondTabCsvDetails', []);
        this.$store.commit('situation/setMagazineSecondTabCheckboxSelect', false);
        this.$store.commit('situation/setMagazineCheckboxSelect', false);

        this.$store.commit("situation/setNewsFirstTabCheckboxValue", 0);
        this.$store.commit("situation/setNewsSecondTabCheckboxValue", 0);
        this.$store.commit("situation/setWebFirstTabCheckboxValue", 0);
        this.$store.commit("situation/setWebSecondTabCheckboxValue", 0);
        this.$store.commit("situation/setMagazineFirstTabCheckboxValue", 0);
        this.$store.commit("situation/setMagazineSecondTabCheckboxValue", 0);

        //get the start date from the selected date
        var startDate = this.date.start;
        var sdate = new Date(startDate),
        smnth = ("0" + (sdate.getMonth() + 1)).slice(-2),
        sday = ("0" + sdate.getDate()).slice(-2);
        //convert the date format
        var startResult = [sdate.getFullYear(), smnth, sday].join("/");
        //get the end date from the selected date
        var endDate = this.date.end;
        var edate = new Date(endDate),
        emnth = ("0" + (edate.getMonth() + 1)).slice(-2),
        eday = ("0" + edate.getDate()).slice(-2);
        //convert the date format
        // 2021/01/18 #10355 START
        //var endResult = [sdate.getFullYear(), emnth, eday].join("/");
        var endResult = [edate.getFullYear(), emnth, eday].join("/");
        // 2021/01/18 #10355 END

        this.startDateResult = startResult;
        this.endDateResult = endResult;

        // 2023/04/09  #14188  START
        Vue.prototype.$session.set('SelectStartDate', this.startDateResult);
        Vue.prototype.$session.set('SelectEndDate', this.endDateResult );
        // 2023/04/09  #14188  END

        this.articleDate = startResult + ' ' + '-' + ' ' + endResult;

        this.$store.dispatch('communication/resetAllArticleValues').then(() => {

          var themeDetails = {
            contract_id: this.contractId,
            theme_browsing: this.theme_browsing,
            user_id: this.userId,
            display_id: "SID0002",
            process_date_start: startResult,
            process_date_end: endResult
          };
          
          var existingArticleDetails = [];

          existingArticleDetails = [...existingArticleDetails, themeDetails, this.themeValueDate, this.setMailThemeId, this.getTodayArticleFlag]
          this.fullscreenLoading = true;
          //Api call to get article theme values
          this.request_count++;
          this.$store.dispatch('communication/getTheme', existingArticleDetails).then(() => {
            this.fullscreenLoading = false;
            // 2023/03/29  #14733  START
            //this.themeValueDate = this.getSelectedTheme[0].value;
            //this.setMailThemeValue = this.getDefaultMailTheme;
            //this.setMailThemeId = this.getSelectedTheme[0].id;
            this.setMailThemeValue = this.getDefaultMailTheme;
            if (this.getSelectedTheme[0]) {
              this.themeValueDate = this.getSelectedTheme[0].value;
              this.setMailThemeId = this.getSelectedTheme[0].id;
            }
            // 2023/03/29  #14733  END
            if(this.getDefaultDateLoading != 0 && this.restrictDateFunction == 0)
            {
              var inputParam;
              var webinputParam;
              var totalNewsLabel;
              var webNewsLabel;
              var magazineinputParam;
              if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)//if date is changed for themes
              {
                //make the mail transition link as clickable
                this.sendMailValue = 0
                this.articleMedia = 0;


                //condition for sc_search_condition_defined_flag
                if(this.getScRegisterFlag == true)
                {
                  this.sc_search_condition_flag = false;
                }
                else
                {
                  this.sc_search_condition_flag = true;
                }
                //condition for web_news_search_condition_defined_flag
                if(this.getWebRegisterFlag == true)
                {
                  this.web_news_search_condition_flag = false;
                }
                else
                {
                  this.web_news_search_condition_flag = true;
                }
                if(this.getMagazineRegisterFlag == true){
              this.magazine_search_condition_flag = false;
            }
            else
            {
              this.magazine_search_condition_flag = true;
            }
                //Highlight in side bar
                if(this.themeValueDate == "Theme")
                {
                  //Search theme index in theme group
                  var theme_index = -1;
                  var themes = this.gettheme;
                  for(var i=0; i<themes.length;i++)
                  {
                    var current_theme_id = themes[i].id
                    if(this.setMailThemeId == current_theme_id)
                    {
                      theme_index = i;
                      break;
                    }
                  }

                  var theme_group_tree_key = -1;
                  if(theme_index == -1)
                  {
                    var theme_groups_themes = this.getthemegrouptopics
                    loop1:
                    for(var tgi=0; tgi<theme_groups_themes.length;tgi++)
                    {
                      var themes_children = theme_groups_themes[tgi].children;  
                      for(var j=0; j<themes_children.length;j++)
                      {
                        var current_themechildren_id = themes_children[j].id
                        if(this.setMailThemeId == current_themechildren_id)
                        {

                          theme_group_tree_key = themes_children[j].tree_key;
                          break loop1;
                        }
                      }
                    }

                  }

                  if(theme_index > -1)
                  {

                    //Highlight first theme
                    this.activeItem = theme_index;
                    this.$refs.themegrouptree.setCurrentKey(null)
                  }
                  else if(theme_group_tree_key > -1)
                  {

                    //Highlight first theme
                    this.activeItem = null;
                    this.$refs.themegrouptree.setCurrentKey(theme_group_tree_key)
                  }
                  else
                  {

                    this.activeItem = null;
                    this.$refs.themegrouptree.setCurrentKey(null)
                  }

                  //Disable highlight others
                  this.activeItemTopics = null;

                }
                else if(this.themeValueDate == "Theme Group")
                {
                  var theme_group_index = -1
                  var theme_groups = this.getthemegrouptopics
                  for(var k=0; k<theme_groups.length;k++)
                  {
                  
                    var current_themegroup_id = theme_groups[k].id
                    if(this.setMailThemeId == current_themegroup_id)
                    {
                      theme_group_index = theme_groups[k].tree_key;
                      break;
                    }
                  }
                  if(theme_group_index == -1)
                  {
                  
                    this.$refs.themegrouptree.setCurrentKey(null)
                  }
                  else
                  {
                    //Highlight  theme group
                    this.$refs.themegrouptree.setCurrentKey(theme_group_index)
                  }
                  
                  //Disable highlight others
                  this.activeItem = null;
                  this.activeItemTopics = null;
                }
                else if(this.themeValueDate == "Topics")
                {
                  var topics_index = -1
                  var topics = this.getthemetopics
                  for(var l=0; l<topics.length;l++)
                  {
                  
                    var current_topics_id = topics[l].id
                    if(this.setMailThemeId == current_topics_id)
                    {
                      topics_index = l;
                      break;
                    }
                  }
                  if(topics_index == -1)
                  {
                    this.activeItemTopics = null;
                    
                  }
                  else
                  {
                    //Highlight  topics
                    this.activeItemTopics = topics_index;
                  }
                  
                  //Disable highlight others
                  this.$refs.themegrouptree.setCurrentKey(null)
                  this.activeItem = null;
                }
                else
                {
                  //No action required
                }

                if(this.themeValueDate == "Theme")
                {

                  inputParam ={
                    contract_id: this.contractId,
                    process_date_start:startResult,
                    process_date_end:endResult,
                    sort_date: '',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    theme_id:this.setMailThemeId
                  }

                  webinputParam ={
                    contract_id: this.contractId,
                    data_section: 3,
                    process_date_start:startResult,
                    process_date_end:endResult,
                    sort_date:'',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    theme_id:this.setMailThemeId
                  }

                  magazineinputParam ={
                    contract_id: this.contractId,
                    data_section: 5,
                    process_date_start:startResult,
                    process_date_end:endResult,
                    sort_date:'',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    theme_id:this.setMailThemeId
                  }
                }
                else if(this.themeValueDate == "Theme Group")
                {
                  
                  inputParam ={
                    contract_id: this.contractId,
                    process_date_start:startResult,
                    process_date_end:endResult,
                    sort_date: '',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    theme_group_id:this.setMailThemeId
                  }

                  webinputParam ={
                    contract_id: this.contractId,
                    data_section: 3,
                    process_date_start:startResult,
                    process_date_end:endResult,
                    sort_date:'',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    theme_group_id:this.setMailThemeId
                  }

                  magazineinputParam ={
                    contract_id: this.contractId,
                    data_section: 5,
                    process_date_start:startResult,
                    process_date_end:endResult,
                    sort_date:'',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    theme_group_id:this.setMailThemeId
                  }
                }
                else if(this.themeValueDate == "Topics")
                {

                  inputParam ={
                    contract_id: this.contractId,
                    process_date_start:startResult,
                    process_date_end:endResult,
                    sort_date: '',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    topics_id:this.setMailThemeId
                  }

                  webinputParam ={
                    contract_id: this.contractId,
                    data_section: 3,
                    process_date_start:startResult,
                    process_date_end:endResult,
                    sort_date:'',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    topics_id:this.setMailThemeId
                  }

                  magazineinputParam ={
                    contract_id: this.contractId,
                    data_section: 5,
                    process_date_start:startResult,
                    process_date_end:endResult,
                    sort_date:'',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    topics_id:this.setMailThemeId
                  }
                }
                else
                {
                  //no action needed
                }

                if(this.getThemeNewsCount != 0)
                {
                  this.fullscreenLoading = true;
                  this.$store.commit('situation/setIsTopPageInitialLoading', true);
                  Vue.prototype.$session.set('InputParameterFor0006',inputParam);
                  Vue.prototype.$session.set('CurrentAID',"0005");
                  //Api call for displaying the News article based on selected theme
                  this.request_count++;
                  this.$store.dispatch('communication/getNewspaperArticles', inputParam).then(() => {
                    totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)"
                    Vue.prototype.$session.set('CurrentNewsCount',this.getThemeNewsCount);
                    this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
                    this.$store.commit('situation/setArticleDate', this.articleDate);
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                    this.request_count--;
                  })
                  .catch(() => {
                    this.request_count--;
                    this.fullscreenLoading = false;
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  })
                }
                else
                {
                  totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)";
                  this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
                  this.$store.commit('situation/setArticleDate', this.articleDate);
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                }

                if(this.getThemeMagazineCount != 0)
                {
                  this.fullscreenLoading = true;
                  this.$store.commit('situation/setIsTopPageInitialLoading', true);
                  //Api call to get magazine article based on selected theme
                  this.request_count++;
                  this.$store.dispatch('communication/getMagazineArticles', magazineinputParam).then(() => {
                    let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                    this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                    this.$store.commit('situation/setArticleDate', this.articleDate);
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                    this.request_count--;
                  })
                  .catch(() => {
                    let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                    this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                    this.request_count--;
                  })
                }
                else
                {
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                  this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                }

                if(this.getThemeWebCount != 0)
                {
                  this.fullscreenLoading = true;
                  this.$store.commit('situation/setIsTopPageInitialLoading', true);
                  //Api call to get web article based on selected theme
                  this.request_count++;
                  this.$store.dispatch('communication/getWebArticles', webinputParam).then(() => {
                    webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                    this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                    this.$store.commit('situation/setArticleDate', this.articleDate);
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                    this.request_count--;
                  })
                      .catch(() => {
                        webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                        this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                        this.$store.commit('situation/setIsTopPageInitialLoading', false);
                        this.fullscreenLoading = false;
                        this.request_count--;
                      })
                }
                else
                {
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                  this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                }
              }
              else if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == true)//if date is changed for today's article link
              {
                // this.$store.dispatch('communication/resetAllArticleValues').then(() => {

                  this.$store.commit('situation/setScRegisterFlag', true);
                  this.$store.commit('situation/setWebregisterFlag', true);
                  this.$store.commit('situation/setMagazineregisterFlag', true);
                  //make the mail transition link as disable
                  this.sendMailValue = 1;

                  //Highlight the today article label
                  this.activeTodayArticleLabel = 0;

                  //parameter for api AID0005
                  inputParam ={
                    contract_id: this.contractId,
                    process_date_start: this.startDateResult,
                    process_date_end: this.endDateResult,
                    sort_date: '',
                    sort_title:'',
                    start_num:1,
                    load_num:10
                  }
                    Vue.prototype.$session.set('InputParameterFor0006',inputParam);    
                    Vue.prototype.$session.set('CurrentAID',"0005");          
                  //Api call for get the news article
                  this.$store.commit('situation/setIsTopPageInitialLoading', true);
                  this.request_count++;
                  this.$store.dispatch('communication/getNewspaperArticles', inputParam).then(() => {
                    totalNewsLabel = "新聞(" + this.getTodayArticleNewsCount + "件)";
                    Vue.prototype.$session.set('CurrentNewsCount',this.getTodayArticleNewsCount);
                    this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    this.$store.commit('situation/setArticleDate', this.articleDate);
                    this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                    this.$store.commit("situation/setThemeNewsCount", this.getTodayArticleNewsCount);
                    this.request_count--;
                  }).catch(()=>{
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    totalNewsLabel = "新聞(" + this.getTodayArticleNewsCount + "件)";
                    Vue.prototype.$session.set('CurrentNewsCount',this.getTodayArticleNewsCount);
                    this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
                    this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                    this.$store.commit('situation/setArticleDate', this.articleDate);
                    this.$store.commit("situation/setThemeNewsCount", this.getTodayArticleNewsCount);
                  })
                
                  //parameter for api AID0005
                  webinputParam ={
                    contract_id: this.contractId,
                    data_section: 3,
                    process_date_start:this.startDateResult,
                    process_date_end:this.endDateResult,
                    sort_date:'',
                    sort_title:'',
                    start_num:1,
                    load_num:10
                  }
                  
                  //Api call to get web article
                  this.$store.commit('situation/setIsTopPageInitialLoading', true);
                  this.request_count++;
                  this.$store.dispatch('communication/getWebArticles', webinputParam).then(() => {
                    webNewsLabel = "WEB(" + this.getTodayArticleWebNewsCount + "件)";
                    this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                    this.$store.commit('situation/setArticleDate', this.articleDate);
                    this.$store.commit("situation/setThemeWebCount", this.getTodayArticleWebNewsCount);
                    this.request_count--;
                  }).catch(()=>{
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    webNewsLabel = "WEB(" + this.getTodayArticleWebNewsCount + "件)";
                    this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                    this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                    this.$store.commit('situation/setArticleDate', this.articleDate);
                    this.$store.commit("situation/setThemeWebCount", this.getTodayArticleWebNewsCount);
                    this.request_count--;
                  })

                let magazineinputParam ={
                  contract_id: this.contractId,
                  data_section: 5,
                  process_date_start:this.startDateResult,
                  process_date_end:this.endDateResult,
                  sort_date:'',
                  sort_title:'',
                  start_num:1,
                  load_num:10
                }
                this.$store.commit('situation/setIsTopPageInitialLoading', true);
                this.request_count++;
                this.$store.dispatch('communication/getMagazineArticles', magazineinputParam).then(() => {
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  let magazineNewsLabel = "雑誌(" + this.getTodayArticleMagazineNewsCount + "件)";
                  this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                  this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                  this.$store.commit('situation/setArticleDate', this.articleDate);
                  this.$store.commit("situation/setThemeMagazineCount", this.getTodayArticleMagazineNewsCount);
                  this.request_count--;
                }).catch(()=>{
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  let magazineNewsLabel = "雑誌(" + this.getTodayArticleMagazineNewsCount + "件)";
                  this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                  this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                  this.$store.commit('situation/setArticleDate', this.articleDate);
                  this.$store.commit("situation/setThemeMagazineCount", this.getTodayArticleMagazineNewsCount);
                  this.request_count--;
                })
              }
              else
              {
                //no action needed
              }
              
              this.$store.commit('situation/setSearchConditionKey', 0);
              this.$store.commit('situation/setDefaultThemeStartDate', this.startDateResult);
              this.$store.commit('situation/setDefaultThemeEndDate', this.endDateResult);

              this.$store.commit('situation/setCsvSearchDownload', 0);
            }
            else
            {
              //console.log("line no 1128 date function");
            }
            this.request_count--;
          })
          .catch(() => {
            this.fullscreenLoading = false;
            this.request_count--;
          })
        })

      }
      else
      {
        //console.log("restrictThemeApiCall");
        // 2022/08/02  #12275  START
        //閲覧できるテーマ、テーマグループ、トピックスがないが、本日の記事がある分岐
        if(this.display_today_article_link_flag && this.gettheme.length==0 && this.getthemetopics.length==0 && this.getthemegrouptopics.length==0)
        {
          this.$store.commit('situation/setSearchConditionKey', 0);
          this.$store.commit('situation/setArticleDetails', []);
          this.$store.commit('situation/setSecondTabArticleDetails', []);
          this.$store.commit('situation/setAllCheckboxSelectDetails', false);
          this.$store.commit('situation/setNewsTabCheckboxSelectDetails', false);
          this.$store.commit('situation/setSortDateText', false);
          this.$store.commit('situation/setSortTitleText', false);
          this.$store.commit('situation/setSortDateTextForNewsTab', false);
          this.$store.commit('situation/setSortTitleTextForNewsTab', false);

          this.$store.commit('situation/setWebCsvDetails', []);
          this.$store.commit('situation/setWebSecondTabCsvDetails', []);
          this.$store.commit('situation/setWebSecondTabCheckboxSelect', false);
          this.$store.commit('situation/setWebCheckboxSelect', false);

          this.$store.commit('situation/setMagazineCsvDetails', []);
          this.$store.commit('situation/setMagazineSecondTabCsvDetails', []);
          this.$store.commit('situation/setMagazineSecondTabCheckboxSelect', false);
          this.$store.commit('situation/setMagazineCheckboxSelect', false);

          this.$store.commit("situation/setNewsFirstTabCheckboxValue", 0);
          this.$store.commit("situation/setNewsSecondTabCheckboxValue", 0);
          this.$store.commit("situation/setWebFirstTabCheckboxValue", 0);
          this.$store.commit("situation/setWebSecondTabCheckboxValue", 0);
          this.$store.commit("situation/setMagazineFirstTabCheckboxValue", 0);
          this.$store.commit("situation/setMagazineSecondTabCheckboxValue", 0);

          var startDate1 = this.date.start;
          var sdate1 = new Date(startDate1),
          smnth1 = ("0" + (sdate1.getMonth() + 1)).slice(-2),
          sday1 = ("0" + sdate1.getDate()).slice(-2);
          var startResult1 = [sdate1.getFullYear(), smnth1, sday1].join("/");
          var endDate1 = this.date.end;
          var edate1 = new Date(endDate1),
          emnth1 = ("0" + (edate1.getMonth() + 1)).slice(-2),
          eday1 = ("0" + edate1.getDate()).slice(-2);
          var endResult1 = [edate1.getFullYear(), emnth1, eday1].join("/");
          this.startDateResult = startResult1;
          this.endDateResult = endResult1;

          // 2023/04/09  #14188  START
          Vue.prototype.$session.set('SelectStartDate', this.startDateResult);
          Vue.prototype.$session.set('SelectEndDate', this.endDateResult );
          // 2023/04/09  #14188  END

          this.$store.commit('situation/setDefaultThemeStartDate', this.startDateResult);
          this.$store.commit('situation/setDefaultThemeEndDate', this.endDateResult);
          this.$store.commit('situation/setScRegisterFlag', true);
          this.$store.commit('situation/setWebregisterFlag', true);
          this.$store.commit('situation/setMagazineregisterFlag', true);
          this.$store.dispatch('communication/resetAllArticleValues').then(() => {
            var themeDetails = {
            contract_id: this.contractId,
            theme_browsing: this.theme_browsing,
            user_id: this.userId,
            display_id: "SID0002",
            process_date_start: startResult1,
            process_date_end: endResult1
          };

          var existingArticleDetails = [];
          existingArticleDetails = [...existingArticleDetails, themeDetails, this.themeValueDate, this.setMailThemeId, this.getTodayArticleFlag]
          this.fullscreenLoading = true;
          //Api call to get article theme values
          this.request_count++;
          this.$store.dispatch('communication/getTheme', existingArticleDetails).then(() => {
            this.fullscreenLoading = false;
            this.themeValueDate = this.getSelectedTheme[0].value;
            this.setMailThemeValue = this.getDefaultMailTheme;
            this.setMailThemeId = this.getSelectedTheme[0].id;
            if(this.getDefaultDateLoading != 0 && this.restrictDateFunction == 0)
            {
              var inputParam;
              var webinputParam;
              var totalNewsLabel;
              var webNewsLabel;
              var magazineinputParam;
              if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)//if date is changed for themes
              {
                //make the mail transition link as clickable
                this.sendMailValue = 0
                this.articleMedia = 0;


                //condition for sc_search_condition_defined_flag
                if(this.getScRegisterFlag == true)
                {
                  this.sc_search_condition_flag = false;
                }
                else
                {
                  this.sc_search_condition_flag = true;
                }
                //condition for web_news_search_condition_defined_flag
                if(this.getWebRegisterFlag == true)
                {
                  this.web_news_search_condition_flag = false;
                }
                else
                {
                  this.web_news_search_condition_flag = true;
                }
                if(this.getMagazineRegisterFlag == true){
              this.magazine_search_condition_flag = false;
            }
            else
            {
              this.magazine_search_condition_flag = true;
            }
                //Highlight in side bar
                if(this.themeValueDate == "Theme")
                {
                  //Search theme index in theme group
                  var theme_index = -1;
                  var themes = this.gettheme;
                  for(var i=0; i<themes.length;i++)
                  {
                    var current_theme_id = themes[i].id
                    if(this.setMailThemeId == current_theme_id)
                    {
                      theme_index = i;
                      break;
                    }
                  }

                  var theme_group_tree_key = -1;
                  if(theme_index == -1)
                  {
                    var theme_groups_themes = this.getthemegrouptopics
                    loop1:
                    for(var tgi=0; tgi<theme_groups_themes.length;tgi++)
                    {
                      var themes_children = theme_groups_themes[tgi].children;  
                      for(var j=0; j<themes_children.length;j++)
                      {
                        var current_themechildren_id = themes_children[j].id
                        if(this.setMailThemeId == current_themechildren_id)
                        {
                          theme_group_tree_key = themes_children[j].tree_key;
                          break loop1;
                        }
                      }
                    }

                  }

                  if(theme_index > -1)
                  {
                    //Highlight first theme
                    this.activeItem = theme_index;
                    this.$refs.themegrouptree.setCurrentKey(null)
                  }
                  else if(theme_group_tree_key > -1)
                  {
                    //Highlight first theme
                    this.activeItem = null;
                    this.$refs.themegrouptree.setCurrentKey(theme_group_tree_key)
                  }
                  else
                  {
                    this.activeItem = null;
                    this.$refs.themegrouptree.setCurrentKey(null)
                  }

                  //Disable highlight others
                  this.activeItemTopics = null;

                }
                else if(this.themeValueDate == "Theme Group")
                {
                  var theme_group_index = -1
                  var theme_groups = this.getthemegrouptopics
                  for(var k=0; k<theme_groups.length;k++)
                  {

                    var current_themegroup_id = theme_groups[k].id
                    if(this.setMailThemeId == current_themegroup_id)
                    {
                      theme_group_index = theme_groups[k].tree_key;
                      break;
                    }
                  }
                  if(theme_group_index == -1)
                  {

                    this.$refs.themegrouptree.setCurrentKey(null)
                  }
                  else
                  {
                    //Highlight  theme group
                    this.$refs.themegrouptree.setCurrentKey(theme_group_index)
                  }

                  //Disable highlight others
                  this.activeItem = null;
                  this.activeItemTopics = null;
                }
                else if(this.themeValueDate == "Topics")
                {
                  var topics_index = -1
                  var topics = this.getthemetopics
                  for(var l=0; l<topics.length;l++)
                  {

                    var current_topics_id = topics[l].id
                    if(this.setMailThemeId == current_topics_id)
                    {
                      topics_index = l;
                      break;
                    }
                  }
                  if(topics_index == -1)
                  {
                    this.activeItemTopics = null;

                  }
                  else
                  {
                    //Highlight  topics
                    this.activeItemTopics = topics_index;
                  }

                  //Disable highlight others
                  this.$refs.themegrouptree.setCurrentKey(null)
                  this.activeItem = null;
                }
                else
                {
                  //No action required
                }

                if(this.themeValueDate == "Theme")
                {

                  inputParam ={
                    contract_id: this.contractId,
                    process_date_start:startResult1,
                    process_date_end:endResult1,
                    sort_date: '',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    theme_id:this.setMailThemeId
                  }

                  webinputParam ={
                    contract_id: this.contractId,
                    data_section: 3,
                    process_date_start:startResult1,
                    process_date_end:endResult1,
                    sort_date:'',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    theme_id:this.setMailThemeId
                  }

                  magazineinputParam ={
                    contract_id: this.contractId,
                    data_section: 5,
                    process_date_start:startResult1,
                    process_date_end:endResult1,
                    sort_date:'',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    theme_id:this.setMailThemeId
                  }
                }
                else if(this.themeValueDate == "Theme Group")
                {

                  inputParam ={
                    contract_id: this.contractId,
                    process_date_start:startResult1,
                    process_date_end:endResult1,
                    sort_date: '',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    theme_group_id:this.setMailThemeId
                  }

                  webinputParam ={
                    contract_id: this.contractId,
                    data_section: 3,
                    process_date_start:startResult1,
                    process_date_end:endResult1,
                    sort_date:'',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    theme_group_id:this.setMailThemeId
                  }

                  magazineinputParam ={
                    contract_id: this.contractId,
                    data_section: 5,
                    process_date_start:startResult1,
                    process_date_end:endResult1,
                    sort_date:'',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    theme_group_id:this.setMailThemeId
                  }
                }
                else if(this.themeValueDate == "Topics")
                {

                  inputParam ={
                    contract_id: this.contractId,
                    process_date_start:startResult1,
                    process_date_end:endResult1,
                    sort_date: '',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    topics_id:this.setMailThemeId
                  }

                  webinputParam ={
                    contract_id: this.contractId,
                    data_section: 3,
                    process_date_start:startResult1,
                    process_date_end:endResult1,
                    sort_date:'',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    topics_id:this.setMailThemeId
                  }

                  magazineinputParam ={
                    contract_id: this.contractId,
                    data_section: 5,
                    process_date_start:startResult1,
                    process_date_end:endResult1,
                    sort_date:'',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    topics_id:this.setMailThemeId
                  }
                }
                else
                {
                  //no action needed
                }

                if(this.getThemeNewsCount != 0)
                {
                  this.fullscreenLoading = true;
                  this.$store.commit('situation/setIsTopPageInitialLoading', true);
                  Vue.prototype.$session.set('InputParameterFor0006',inputParam);
                  Vue.prototype.$session.set('CurrentAID',"0005");
                  //Api call for displaying the News article based on selected theme
                  this.request_count++;
                  this.$store.dispatch('communication/getNewspaperArticles', inputParam).then(() => {
                    totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)"
                    Vue.prototype.$session.set('CurrentNewsCount',this.getThemeNewsCount);
                    this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
                    this.$store.commit('situation/setArticleDate', this.articleDate);
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                    this.request_count--;
                  })
                  .catch(() => {
                    this.request_count--;
                    this.fullscreenLoading = false;
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  })
                }
                else
                {
                  totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)";
                  this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
                  this.$store.commit('situation/setArticleDate', this.articleDate);
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                }

                if(this.getThemeMagazineCount != 0)
                {
                  this.fullscreenLoading = true;
                  this.$store.commit('situation/setIsTopPageInitialLoading', true);
                  //Api call to get magazine article based on selected theme
                  this.request_count++;
                  this.$store.dispatch('communication/getMagazineArticles', magazineinputParam).then(() => {
                    let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                    this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                    this.$store.commit('situation/setArticleDate', this.articleDate);
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                    this.request_count--;
                  })
                  .catch(() => {
                    let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                    this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                    this.request_count--;
                  })
                }
                else
                {
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                  this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                }

                if(this.getThemeWebCount != 0)
                {
                  this.fullscreenLoading = true;
                  this.$store.commit('situation/setIsTopPageInitialLoading', true);
                  //Api call to get web article based on selected theme
                  this.request_count++;
                  this.$store.dispatch('communication/getWebArticles', webinputParam).then(() => {
                    webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                    this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                    this.$store.commit('situation/setArticleDate', this.articleDate);
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                    this.request_count--;
                  })
                      .catch(() => {
                        webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                        this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                        this.$store.commit('situation/setIsTopPageInitialLoading', false);
                        this.fullscreenLoading = false;
                        this.request_count--;
                      })
                }
                else
                {
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                  this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                }
              }
              else if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == true)//if date is changed for today's article link
              {
                // this.$store.dispatch('communication/resetAllArticleValues').then(() => {

                  this.$store.commit('situation/setScRegisterFlag', true);
                  this.$store.commit('situation/setWebregisterFlag', true);
                  this.$store.commit('situation/setMagazineregisterFlag', true);
                  //make the mail transition link as disable
                  this.sendMailValue = 1;

                  //Highlight the today article label
                  this.activeTodayArticleLabel = 0;

                  //parameter for api AID0005
                  inputParam ={
                    contract_id: this.contractId,
                    process_date_start: this.startDateResult,
                    process_date_end: this.endDateResult,
                    sort_date: '',
                    sort_title:'',
                    start_num:1,
                    load_num:10
                  }
                    Vue.prototype.$session.set('InputParameterFor0006',inputParam);    
                    Vue.prototype.$session.set('CurrentAID',"0005");          
                  //Api call for get the news article
                  this.$store.commit('situation/setIsTopPageInitialLoading', true);
                  this.request_count++;
                  this.$store.dispatch('communication/getNewspaperArticles', inputParam).then(() => {
                    totalNewsLabel = "新聞(" + this.getTodayArticleNewsCount + "件)";
                    Vue.prototype.$session.set('CurrentNewsCount',this.getTodayArticleNewsCount);
                    this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    this.$store.commit('situation/setArticleDate', this.articleDate);
                    this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                    this.$store.commit("situation/setThemeNewsCount", this.getTodayArticleNewsCount);
                    this.request_count--;
                  }).catch(()=>{
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    totalNewsLabel = "新聞(" + this.getTodayArticleNewsCount + "件)";
                    Vue.prototype.$session.set('CurrentNewsCount',this.getTodayArticleNewsCount);
                    this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
                    this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                    this.$store.commit('situation/setArticleDate', this.articleDate);
                    this.$store.commit("situation/setThemeNewsCount", this.getTodayArticleNewsCount);
                  })
                
                  //parameter for api AID0005
                  webinputParam ={
                    contract_id: this.contractId,
                    data_section: 3,
                    process_date_start:this.startDateResult,
                    process_date_end:this.endDateResult,
                    sort_date:'',
                    sort_title:'',
                    start_num:1,
                    load_num:10
                  }
                  
                  //Api call to get web article
                  this.$store.commit('situation/setIsTopPageInitialLoading', true);
                  this.request_count++;
                  this.$store.dispatch('communication/getWebArticles', webinputParam).then(() => {
                    webNewsLabel = "WEB(" + this.getTodayArticleWebNewsCount + "件)";
                    this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                    this.$store.commit('situation/setArticleDate', this.articleDate);
                    this.$store.commit("situation/setThemeWebCount", this.getTodayArticleWebNewsCount);
                    this.request_count--;
                  }).catch(()=>{
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    webNewsLabel = "WEB(" + this.getTodayArticleWebNewsCount + "件)";
                    this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                    this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                    this.$store.commit('situation/setArticleDate', this.articleDate);
                    this.$store.commit("situation/setThemeWebCount", this.getTodayArticleWebNewsCount);
                    this.request_count--;
                  })

                let magazineinputParam ={
                  contract_id: this.contractId,
                  data_section: 5,
                  process_date_start:this.startDateResult,
                  process_date_end:this.endDateResult,
                  sort_date:'',
                  sort_title:'',
                  start_num:1,
                  load_num:10
                }
                this.$store.commit('situation/setIsTopPageInitialLoading', true);
                this.request_count++;
                this.$store.dispatch('communication/getMagazineArticles', magazineinputParam).then(() => {
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  let magazineNewsLabel = "雑誌(" + this.getTodayArticleMagazineNewsCount + "件)";
                  this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                  this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                  this.$store.commit('situation/setArticleDate', this.articleDate);
                  this.$store.commit("situation/setThemeMagazineCount", this.getTodayArticleMagazineNewsCount);
                  this.request_count--;
                }).catch(()=>{
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  let magazineNewsLabel = "雑誌(" + this.getTodayArticleMagazineNewsCount + "件)";
                  this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                  this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                  this.$store.commit('situation/setArticleDate', this.articleDate);
                  this.$store.commit("situation/setThemeMagazineCount", this.getTodayArticleMagazineNewsCount);
                  this.request_count--;
                })
              }
              else
              {
                //no action needed
              }
              
              this.$store.commit('situation/setSearchConditionKey', 0);
              this.$store.commit('situation/setDefaultThemeStartDate', this.startDateResult);
              this.$store.commit('situation/setDefaultThemeEndDate', this.endDateResult);

              this.$store.commit('situation/setCsvSearchDownload', 0);
            }
            else
            {
              //console.log("line no 1128 date function");
            }
            this.request_count--;
          })
          .catch(() => {
            this.fullscreenLoading = false;
            this.request_count--;
          })
        })

        }
        // 2023/04/25  #15063  START
        //閲覧できるテーマ、テーマグループ、本日の記事がないが、ある日トピックスがある分岐
        else
        {
          this.$store.commit('situation/setSearchConditionKey', 0);
          this.$store.commit('situation/setArticleDetails', []);
          this.$store.commit('situation/setSecondTabArticleDetails', []);
          this.$store.commit('situation/setAllCheckboxSelectDetails', false);
          this.$store.commit('situation/setNewsTabCheckboxSelectDetails', false);
          this.$store.commit('situation/setSortDateText', false);
          this.$store.commit('situation/setSortTitleText', false);
          this.$store.commit('situation/setSortDateTextForNewsTab', false);
          this.$store.commit('situation/setSortTitleTextForNewsTab', false);

          this.$store.commit('situation/setWebCsvDetails', []);
          this.$store.commit('situation/setWebSecondTabCsvDetails', []);
          this.$store.commit('situation/setWebSecondTabCheckboxSelect', false);
          this.$store.commit('situation/setWebCheckboxSelect', false);

          this.$store.commit('situation/setMagazineCsvDetails', []);
          this.$store.commit('situation/setMagazineSecondTabCsvDetails', []);
          this.$store.commit('situation/setMagazineSecondTabCheckboxSelect', false);
          this.$store.commit('situation/setMagazineCheckboxSelect', false);

          this.$store.commit("situation/setNewsFirstTabCheckboxValue", 0);
          this.$store.commit("situation/setNewsSecondTabCheckboxValue", 0);
          this.$store.commit("situation/setWebFirstTabCheckboxValue", 0);
          this.$store.commit("situation/setWebSecondTabCheckboxValue", 0);
          this.$store.commit("situation/setMagazineFirstTabCheckboxValue", 0);
          this.$store.commit("situation/setMagazineSecondTabCheckboxValue", 0);

          var startDate2 = this.date.start;
          var sdate2 = new Date(startDate2),
          smnth2 = ("0" + (sdate2.getMonth() + 1)).slice(-2),
          sday2 = ("0" + sdate2.getDate()).slice(-2);
          var startResult2 = [sdate2.getFullYear(), smnth2, sday2].join("/");
          var endDate2 = this.date.end;
          var edate2 = new Date(endDate2),
          emnth2 = ("0" + (edate2.getMonth() + 1)).slice(-2),
          eday2 = ("0" + edate2.getDate()).slice(-2);
          var endResult2 = [edate2.getFullYear(), emnth2, eday2].join("/");
          this.startDateResult = startResult2;
          this.endDateResult = endResult2;

          // 2023/04/09  #14188  START
          Vue.prototype.$session.set('SelectStartDate', this.startDateResult);
          Vue.prototype.$session.set('SelectEndDate', this.endDateResult );
          // 2023/04/09  #14188  END

          this.$store.commit('situation/setDefaultThemeStartDate', this.startDateResult);
          this.$store.commit('situation/setDefaultThemeEndDate', this.endDateResult);
          this.$store.commit('situation/setScRegisterFlag', true);
          this.$store.commit('situation/setWebregisterFlag', true);
          this.$store.commit('situation/setMagazineregisterFlag', true);
          this.$store.dispatch('communication/resetAllArticleValues').then(() => {
            var themeDetails = {
            contract_id: this.contractId,
            theme_browsing: this.theme_browsing,
            user_id: this.userId,
            display_id: "SID0002",
            process_date_start: startResult2,
            process_date_end: endResult2
          };

          var existingArticleDetails = [];
          existingArticleDetails = [...existingArticleDetails, themeDetails, this.themeValueDate, this.setMailThemeId, this.getTodayArticleFlag]
          this.fullscreenLoading = true;
          //Api call to get article theme values
          this.request_count++;
          this.$store.dispatch('communication/getTheme', existingArticleDetails).then(() => {
            this.fullscreenLoading = false;
            //this.themeValueDate = this.getSelectedTheme[0].value;
            this.setMailThemeValue = this.getDefaultMailTheme;
            //this.setMailThemeId = this.getSelectedTheme[0].id;
            if(this.getSelectedTheme[0]){
              this.themeValueDate = this.getSelectedTheme[0].value;
              this.setMailThemeId = this.getSelectedTheme[0].id;
            }
            console.log('this.themeValueDate: ', this.themeValueDate);
            if(this.getDefaultDateLoading != 0 && this.restrictDateFunction == 0)
            {
              var inputParam;
              var webinputParam;
              var totalNewsLabel;
              var webNewsLabel;
              var magazineinputParam;
              if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == false)//if date is changed for themes
              {
                //make the mail transition link as clickable
                this.sendMailValue = 0
                this.articleMedia = 0;


                //condition for sc_search_condition_defined_flag
                if(this.getScRegisterFlag == true)
                {
                  this.sc_search_condition_flag = false;
                }
                else
                {
                  this.sc_search_condition_flag = true;
                }
                //condition for web_news_search_condition_defined_flag
                if(this.getWebRegisterFlag == true)
                {
                  this.web_news_search_condition_flag = false;
                }
                else
                {
                  this.web_news_search_condition_flag = true;
                }
                if(this.getMagazineRegisterFlag == true){
              this.magazine_search_condition_flag = false;
            }
            else
            {
              this.magazine_search_condition_flag = true;
            }
            //Highlight in side bar
            if(this.themeValueDate == "Theme")
            {
              //Search theme index in theme group
              var theme_index = -1;
              var themes = this.gettheme;
              for(var i=0; i<themes.length;i++)
              {
                var current_theme_id = themes[i].id
                if(this.setMailThemeId == current_theme_id)
                {
                  theme_index = i;
                  break;
                }
              }

              var theme_group_tree_key = -1;
              if(theme_index == -1)
              {
                var theme_groups_themes = this.getthemegrouptopics
                loop1:
                for(var tgi=0; tgi<theme_groups_themes.length;tgi++)
                {
                  var themes_children = theme_groups_themes[tgi].children;  
                  for(var j=0; j<themes_children.length;j++)
                  {
                    var current_themechildren_id = themes_children[j].id
                    if(this.setMailThemeId == current_themechildren_id)
                    {
                      theme_group_tree_key = themes_children[j].tree_key;
                      break loop1;
                    }
                  }
                }

              }

              if(theme_index > -1)
              {
                //Highlight first theme
                this.activeItem = theme_index;
                this.$refs.themegrouptree.setCurrentKey(null)
              }
              else if(theme_group_tree_key > -1)
              {
                //Highlight first theme
                this.activeItem = null;
                this.$refs.themegrouptree.setCurrentKey(theme_group_tree_key)
              }
              else
              {
                this.activeItem = null;
                this.$refs.themegrouptree.setCurrentKey(null)
              }

              //Disable highlight others
              this.activeItemTopics = null;

            }
            else if(this.themeValueDate == "Theme Group")
            {
              var theme_group_index = -1
              var theme_groups = this.getthemegrouptopics
              for(var k=0; k<theme_groups.length;k++)
              {

                var current_themegroup_id = theme_groups[k].id
                if(this.setMailThemeId == current_themegroup_id)
                {
                  theme_group_index = theme_groups[k].tree_key;
                  break;
                }
              }
              if(theme_group_index == -1)
              {

                this.$refs.themegrouptree.setCurrentKey(null)
              }
              else
              {
                //Highlight  theme group
                this.$refs.themegrouptree.setCurrentKey(theme_group_index)
              }

              //Disable highlight others
              this.activeItem = null;
              this.activeItemTopics = null;
            }
            else if(this.themeValueDate == "Topics")
            {
              var topics_index = -1
              var topics = this.getthemetopics
              for(var l=0; l<topics.length;l++)
              {

                var current_topics_id = topics[l].id
                if(this.setMailThemeId == current_topics_id)
                {
                  topics_index = l;
                  break;
                }
              }
              if(topics_index == -1)
              {
                this.activeItemTopics = null;

              }
              else
              {
                //Highlight  topics
                this.activeItemTopics = topics_index;
              }

              //Disable highlight others
              this.$refs.themegrouptree.setCurrentKey(null)
              this.activeItem = null;
            }
            else
            {
              //No action required
            }

            if(this.themeValueDate == "Theme")
            {

              inputParam ={
                contract_id: this.contractId,
                process_date_start:startResult2,
                process_date_end:endResult2,
                sort_date: '',
                sort_title:'',
                start_num:1,
                load_num:10,
                theme_id:this.setMailThemeId
              }

              webinputParam ={
                contract_id: this.contractId,
                data_section: 3,
                process_date_start:startResult2,
                process_date_end:endResult2,
                sort_date:'',
                sort_title:'',
                start_num:1,
                load_num:10,
                theme_id:this.setMailThemeId
              }

              magazineinputParam ={
                contract_id: this.contractId,
                data_section: 5,
                process_date_start:startResult2,
                process_date_end:endResult2,
                sort_date:'',
                sort_title:'',
                start_num:1,
                load_num:10,
                theme_id:this.setMailThemeId
              }
            }
            else if(this.themeValueDate == "Theme Group")
            {

              inputParam ={
                contract_id: this.contractId,
                process_date_start:startResult2,
                process_date_end:endResult2,
                sort_date: '',
                sort_title:'',
                start_num:1,
                load_num:10,
                theme_group_id:this.setMailThemeId
              }

              webinputParam ={
                contract_id: this.contractId,
                data_section: 3,
                process_date_start:startResult2,
                process_date_end:endResult2,
                sort_date:'',
                sort_title:'',
                start_num:1,
                load_num:10,
                theme_group_id:this.setMailThemeId
              }

              magazineinputParam ={
                contract_id: this.contractId,
                data_section: 5,
                process_date_start:startResult2,
                process_date_end:endResult2,
                sort_date:'',
                sort_title:'',
                start_num:1,
                load_num:10,
                theme_group_id:this.setMailThemeId
              }
            }
            else if(this.themeValueDate == "Topics")
            {

              inputParam ={
                contract_id: this.contractId,
                process_date_start:startResult2,
                process_date_end:endResult2,
                sort_date: '',
                sort_title:'',
                start_num:1,
                load_num:10,
                topics_id:this.setMailThemeId
              }

              webinputParam ={
                contract_id: this.contractId,
                data_section: 3,
                process_date_start:startResult2,
                process_date_end:endResult2,
                sort_date:'',
                sort_title:'',
                start_num:1,
                load_num:10,
                topics_id:this.setMailThemeId
              }

              magazineinputParam ={
                contract_id: this.contractId,
                data_section: 5,
                process_date_start:startResult2,
                process_date_end:endResult2,
                sort_date:'',
                sort_title:'',
                start_num:1,
                load_num:10,
                topics_id:this.setMailThemeId
              }
            }
            else
            {
              //no action needed
            }

            if(this.getThemeNewsCount != 0)
            {
              this.fullscreenLoading = true;
              this.$store.commit('situation/setIsTopPageInitialLoading', true);
              Vue.prototype.$session.set('InputParameterFor0006',inputParam);
              Vue.prototype.$session.set('CurrentAID',"0005");
              //Api call for displaying the News article based on selected theme
              this.request_count++;
              console.log('11111111111')
              this.$store.dispatch('communication/getNewspaperArticles', inputParam).then(() => {
                totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)"
                Vue.prototype.$session.set('CurrentNewsCount',this.getThemeNewsCount);
                this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
                this.$store.commit('situation/setArticleDate', this.articleDate);
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
                this.fullscreenLoading = false;
                this.request_count--;
              })
              .catch(() => {
                this.request_count--;
                this.fullscreenLoading = false;
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
              })
            }
            else
            {
              totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)";
              this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
              this.$store.commit('situation/setArticleDate', this.articleDate);
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
            }

            if(this.getThemeMagazineCount != 0)
            {
              this.fullscreenLoading = true;
              this.$store.commit('situation/setIsTopPageInitialLoading', true);
              //Api call to get magazine article based on selected theme
              this.request_count++;
              this.$store.dispatch('communication/getMagazineArticles', magazineinputParam).then(() => {
                let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                this.$store.commit('situation/setArticleDate', this.articleDate);
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
                this.fullscreenLoading = false;
                this.request_count--;
              })
              .catch(() => {
                let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
                this.fullscreenLoading = false;
                this.request_count--;
              })
            }
            else
            {
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
              this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
            }

            if(this.getThemeWebCount != 0)
            {
              this.fullscreenLoading = true;
              this.$store.commit('situation/setIsTopPageInitialLoading', true);
              //Api call to get web article based on selected theme
              this.request_count++;
              this.$store.dispatch('communication/getWebArticles', webinputParam).then(() => {
                webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                this.$store.commit('situation/setArticleDate', this.articleDate);
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
                this.fullscreenLoading = false;
                this.request_count--;
              })
                  .catch(() => {
                    webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                    this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                    this.request_count--;
                  })
            }
            else
            {
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
              this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
            }
          }
          else if(this.getSearchConditionKey == 0 && this.getTodayArticleFlag == true)//if date is changed for today's article link
          {
            // this.$store.dispatch('communication/resetAllArticleValues').then(() => {

              this.$store.commit('situation/setScRegisterFlag', true);
              this.$store.commit('situation/setWebregisterFlag', true);
              this.$store.commit('situation/setMagazineregisterFlag', true);
              //make the mail transition link as disable
              this.sendMailValue = 1;

              //Highlight the today article label
              this.activeTodayArticleLabel = 0;

              //parameter for api AID0005
              inputParam ={
                contract_id: this.contractId,
                process_date_start: this.startDateResult,
                process_date_end: this.endDateResult,
                sort_date: '',
                sort_title:'',
                start_num:1,
                load_num:10
              }
                Vue.prototype.$session.set('InputParameterFor0006',inputParam);    
                Vue.prototype.$session.set('CurrentAID',"0005");          
              //Api call for get the news article
              this.$store.commit('situation/setIsTopPageInitialLoading', true);
              this.request_count++;
              this.$store.dispatch('communication/getNewspaperArticles', inputParam).then(() => {
                totalNewsLabel = "新聞(" + this.getTodayArticleNewsCount + "件)";
                Vue.prototype.$session.set('CurrentNewsCount',this.getTodayArticleNewsCount);
                this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
                this.$store.commit('situation/setArticleDate', this.articleDate);
                this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                this.$store.commit("situation/setThemeNewsCount", this.getTodayArticleNewsCount);
                this.request_count--;
              }).catch(()=>{
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
                totalNewsLabel = "新聞(" + this.getTodayArticleNewsCount + "件)";
                Vue.prototype.$session.set('CurrentNewsCount',this.getTodayArticleNewsCount);
                this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
                this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                this.$store.commit('situation/setArticleDate', this.articleDate);
                this.$store.commit("situation/setThemeNewsCount", this.getTodayArticleNewsCount);
              })
            
              //parameter for api AID0005
              webinputParam ={
                contract_id: this.contractId,
                data_section: 3,
                process_date_start:this.startDateResult,
                process_date_end:this.endDateResult,
                sort_date:'',
                sort_title:'',
                start_num:1,
                load_num:10
              }
              
              //Api call to get web article
              this.$store.commit('situation/setIsTopPageInitialLoading', true);
              this.request_count++;
              this.$store.dispatch('communication/getWebArticles', webinputParam).then(() => {
                webNewsLabel = "WEB(" + this.getTodayArticleWebNewsCount + "件)";
                this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
                this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                this.$store.commit('situation/setArticleDate', this.articleDate);
                this.$store.commit("situation/setThemeWebCount", this.getTodayArticleWebNewsCount);
                this.request_count--;
              }).catch(()=>{
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
                webNewsLabel = "WEB(" + this.getTodayArticleWebNewsCount + "件)";
                this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                this.$store.commit('situation/setArticleDate', this.articleDate);
                this.$store.commit("situation/setThemeWebCount", this.getTodayArticleWebNewsCount);
                this.request_count--;
              })

            let magazineinputParam ={
              contract_id: this.contractId,
              data_section: 5,
              process_date_start:this.startDateResult,
              process_date_end:this.endDateResult,
              sort_date:'',
              sort_title:'',
              start_num:1,
              load_num:10
            }
            this.$store.commit('situation/setIsTopPageInitialLoading', true);
            this.request_count++;
            this.$store.dispatch('communication/getMagazineArticles', magazineinputParam).then(() => {
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              let magazineNewsLabel = "雑誌(" + this.getTodayArticleMagazineNewsCount + "件)";
              this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
              this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
              this.$store.commit('situation/setArticleDate', this.articleDate);
              this.$store.commit("situation/setThemeMagazineCount", this.getTodayArticleMagazineNewsCount);
              this.request_count--;
            }).catch(()=>{
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              let magazineNewsLabel = "雑誌(" + this.getTodayArticleMagazineNewsCount + "件)";
              this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
              this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
              this.$store.commit('situation/setArticleDate', this.articleDate);
              this.$store.commit("situation/setThemeMagazineCount", this.getTodayArticleMagazineNewsCount);
              this.request_count--;
            })
          }
          else
          {
            //no action needed
          }
              
              this.$store.commit('situation/setSearchConditionKey', 0);
              this.$store.commit('situation/setDefaultThemeStartDate', this.startDateResult);
              this.$store.commit('situation/setDefaultThemeEndDate', this.endDateResult);

              this.$store.commit('situation/setCsvSearchDownload', 0);
            }
            else
            {
              //console.log("line no 1128 date function");
            }
            this.request_count--;
          })
          .catch(() => {
            this.fullscreenLoading = false;
            this.request_count--;
          })
        })

        }
        // 2023/04/25  #15063  END
        // 2022/08/02  #12275  END
      }
      this.$LogMethodOut("side-bar","selectDateForSearch");
    },
    //methods for reset the field in mail sent dialog box
    gototop(formName){
      this.$LogButtonEvent("side-bar","Return");
      this.$LogMethodIN("side-bar","gototop");
      this.dialogVisible=false;
      this.$refs[formName].resetFields();
      this.Dialogform.medium=[]
      this.$LogMethodOut("side-bar","gototop");
    },
    //methods for send mail for selected themes
    open(formName) {
      this.$LogButtonEvent("side-bar","RegisterMail");
      this.$LogMethodIN("side-bar","open");
      this.$refs[formName].validate(valid => {
        if(valid)
        {
          // 2021/08/02  #11641  START
          this.Buttonpressed= 1;
          // 2021/08/02  #11641  END 
          var checkWebNews=[];

          if(this.themeValueDate == "Theme") 
          {
            this.data_kbn = 1
          }
          else if(this.themeValueDate == "Theme Group") 
          {
            this.data_kbn = 2
          }
          else 
          {
            this.data_kbn = 3
          }
          
          //Check box is selected
          if(this.Dialogform.medium.length > 0)
          {
            //Check News is selected
            if(this.Dialogform.medium.indexOf("1") > -1)
            {
              checkWebNews.push(101)
            }
            //Check web News is selected
            if(this.Dialogform.medium.indexOf("3") > -1)
            {
              checkWebNews.push(3)
            }
            if(this.Dialogform.medium.indexOf("2") > -1)
            {
              checkWebNews.push(5)
            }
          }

          var credentials = {
            theme_id:(this.setMailThemeId).toString(),
            data_kbn:parseInt(this.data_kbn),
            data_section:checkWebNews,
            mail_address:this.Dialogform.Emailinput1
          };

          this.$store.dispatch('communication0003/MailDelivery',credentials)
          .then(() => {
            if(this.getStatus == 0)
            {
              this.$alert(this.getErrorMessage, json["0003_send_success_title"], {
                confirmButtonText: 'OK',
              }).then(() => {
                this.dialogVisible=false;
                this.$refs[formName].resetFields();
                this.Dialogform.medium=[]
              })
            }
            else
            {
              this.$alert(this.getErrorMessage, json["0003_send_failure_title"], {
                confirmButtonText: 'OK',
              }).then(() => {
                this.dialogVisible=true;
              })
            }
            // 2021/08/02  #11641  START
            this.Buttonpressed= 0;
            // 2021/08/02  #11641  END 
           })
           .catch((error) => {
              console.log(error);
              this.$alert(this.getErrorMessage, json["0003_send_failure_title"], {
                confirmButtonText: 'OK'
              });
              // 2021/08/02  #11641  START
              this.Buttonpressed= 0;
              // 2021/08/02  #11641  END 
            });

        }
        else
        {
          return false;
        }
      });
      this.$LogMethodOut("side-bar","open");
    },
    //method for load the article based on search condition
    articleSearch(){
      this.$LogButtonEvent("side-bar","SearchArticle");
      this.$LogMethodIN("side-bar","articleSearch");
      if(this.date){
        this.date.start = ''
        this.date.end = ''
      }
      if(this.display_today_article_link_flag)
      {
        this.$store.commit('situation/setTodayArticleFlag', true);
      }
      else
      {
        this.$store.commit('situation/setTodayArticleFlag', false);
      }

      if(this.currentPath != 1)
      {
        Vue.prototype.$session.set('searchKeywordValue', this.input1);
        Vue.prototype.$session.set('searchTitleValue', this.select_search_value);
        Vue.prototype.$session.set('searchStartDate', this.range.start);
        Vue.prototype.$session.set('searchEndDate', this.range.end);
        Vue.prototype.$session.set('defaultSearchLoadFlag', false);
        Vue.prototype.$session.set('searchmediaValue', this.form.SearchMediaName);
        Vue.prototype.$session.set('triggerSearchFunctionFlag', 1);
        router.push('/0002');
      }
      else
      {
        this.restrictDateFunction = 1;
        this.setMailThemeId = this.$session.get('themeIdAfterLogin');
        this.themeValueDate = this.$session.get('themeValueAfterLogin');
        this.flagForSetDefaultCount = 1;
        this.restrictThemeApiCall = 1;

        this.$store.dispatch('communication/resetAllArticleValues').then(() => {
          //make the selected theme value as inactive
          this.activeItem = null;
          //make the selected topics value as inactive
          this.activeItemTopics = null;
          //make the mail transition link as disable
          this.sendMailValue = 1;
          //make the today article label as inactive
          this.activeTodayArticleLabel = null;

          /*Reset the highlight of theme group selection */
          var theme_group_key = this.$refs.themegrouptree.getCurrentKey();
          if(theme_group_key != null){
            this.$refs.themegrouptree.setCurrentKey(null);
          }
          /*Reset the highlight of theme group selection */
        
          this.$store.commit('situation/setThemeIdForPdfSuccess', null);
          this.$store.commit('situation/setThemeGroupIdForPdfSuccess', null);
          this.$store.commit('situation/setTopicsIdForPdfSuccess', null);

          //get the start date from the selected date
          var startDate = this.range.start;
          var sdate = new Date(startDate),
          smnth = ("0" + (sdate.getMonth() + 1)).slice(-2),
          sday = ("0" + sdate.getDate()).slice(-2);
          //convert the date format
          var startResult = [sdate.getFullYear(), smnth, sday].join("/");
          
          //get the end date from the selected date
          var endDate = this.range.end;
          var edate = new Date(endDate),
          emnth = ("0" + (edate.getMonth() + 1)).slice(-2),
          eday = ("0" + edate.getDate()).slice(-2);
          //convert the date format
          var endResult = [edate.getFullYear(), emnth, eday].join("/");
          
          // CR-1490 
          // Removing change main calendar selected date by search calendar date.

          this.$store.commit('situation/setDefaultThemeStartDate', startResult);
          this.$store.commit('situation/setDefaultThemeEndDate', endResult);

          // CR-1490 
          // Removing Calendar move fn.

          var article_search_condition;
          if(this.select_search_value != '')//if value is selected from search dropdown
          {
            article_search_condition = {
              contract_id: this.contractId,
              user_id: this.userId,
              contract_kbn: 0,
              display_id: 'SID0002',
              process_date_from: startResult,
              process_date_to: endResult,
              theme_browsing: this.theme_browsing,
              sort_date: "",
              search_title: this.select_search_value,
              start_num: 1,
              load_num: 10,
              sort_title: ""
                
            }
          }
          else if(this.input1 != '')//if keyword textbox is not equal to empty
          {
            if(this.form.SearchMediaName != '')//if media texbox is not equal to empty
            {
              article_search_condition = {
                contract_id: this.contractId,
                user_id: this.userId,
                contract_kbn: 0,
                display_id: 'SID0002',
                process_date_from: startResult,
                process_date_to: endResult,
                theme_browsing: this.theme_browsing,
                key_word: this.input1,
                media_name: this.form.SearchMediaName,
                sort_date: "",
                start_num: 1,
                load_num: 10,
                sort_title: ""
              }
            }
            else//if media texbox is equal to empty
            {
              article_search_condition = {
                contract_id: this.contractId,
                contract_kbn: 0,
                display_id: 'SID0002',
                user_id: this.userId,
                key_word: this.input1,
                process_date_from: startResult,
                process_date_to: endResult,
                start_num: 1,
                load_num: 10,
                sort_date: "",
                sort_title: "",
                theme_browsing: this.theme_browsing
              }
            }
          }
          else//if keyword textbox is equal to empty
          {
            if(this.form.SearchMediaName != '')//if media texbox is not equal to empty
            {
              article_search_condition = {
                contract_id: this.contractId,
                user_id: this.userId,
                contract_kbn: 0,
                display_id: 'SID0002',
                process_date_from: startResult,
                process_date_to: endResult,
                theme_browsing: this.theme_browsing,
                media_name: this.form.SearchMediaName,
                sort_date: "",
                start_num: 1,
                load_num: 10,
                sort_title: ""
              }
            }
            else//if media texbox is equal to empty
            {
              article_search_condition = {
                contract_id: this.contractId,
                contract_kbn: 0,
                display_id: 'SID0002',
                user_id: this.userId,
                process_date_from: startResult,
                process_date_to: endResult,
                start_num: 1,
                load_num: 10,
                sort_date: "",
                sort_title: "",
                theme_browsing: this.theme_browsing
              }
            }
          }
        
          // CR-1490 
          // Removing calling theme function, because we are not going to change main calendar date by search calendar date. 
            this.fullscreenLoading = true;
            this.$store.commit('situation/setIsTopPageInitialLoading', true);
            //Api call for search the article by using keyword, media and search dropdown value
            Vue.prototype.$session.set('InputParameterFor0006',article_search_condition); 
            Vue.prototype.$session.set('CurrentAID',"0071");
            this.$store.dispatch('communication/getArticleUsingSearch', article_search_condition).then(() => {
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              Vue.prototype.$session.set('searchKeywordValue', '');
              Vue.prototype.$session.set('searchTitleValue', '');
              Vue.prototype.$session.set('searchStartDate', '');
              Vue.prototype.$session.set('searchEndDate', '');
              Vue.prototype.$session.set('searchmediaValue', '');
              Vue.prototype.$session.set('defaultSearchLoadFlag', true);
              this.restrictThemeApiCall = 0;
              var searchKey = 1;
              var csvDownloadKey = 1;
              var resetCheckbox = 0;
              this.articleDate = startResult + ' ' + '-' + ' ' + endResult;
              var serchResultLabel;
              let count=0;
              // if(this.news_article_flag && this.user_group_news_article_flag && this.web_news_article_flag && this.user_group_web_news_article_flag)
              // {
              //   serchResultLabel = "検索結果" + "(" + parseInt(this.getThemeNewsCount + this.getThemeWebCount) + "件)";
              // }
              // else if(this.news_article_flag && this.user_group_news_article_flag)
              // {
              //   serchResultLabel = "検索結果" + "(" + parseInt(this.getThemeNewsCount) + "件)";
              // }
              // else if(this.web_news_article_flag && this.user_group_web_news_article_flag)
              // {
              //   serchResultLabel = "検索結果" + "(" + parseInt(this.getThemeWebCount) + "件)";
              // }
              // else
              // {
              //   //no action needed
              // }
              if(this.news_article_flag && this.user_group_news_article_flag){
                count+=parseInt(this.getThemeNewsCount);
              }
              if(this.web_news_article_flag && this.user_group_web_news_article_flag){
                count+=parseInt(this.getThemeWebCount);
              }
              if(this.magazine_article_flag && this.user_group_magazine_article_flag){
                count+=parseInt(this.getThemeMagazineCount);
              }
              serchResultLabel = "検索結果" + "(" + count + "件)";
              // var serchResultLabel = "検索結果" + "(" + parseInt(this.getThemeNewsCount + this.getThemeWebCount) + "件)"
              this.$store.commit("situation/setSelectedLabel", serchResultLabel);
              this.$store.commit('situation/setArticleDate', this.articleDate);
              this.$store.commit('situation/setSearchValue', this.select_search_value);
              this.$store.commit('situation/setKeywordValue', this.input1);
              this.$store.commit('situation/setMediaValue', this.form.SearchMediaName);
              this.$store.commit('situation/setSearchStartDate', startResult);
              // this.$store.commit("situation/setThemeNewsCount", this.getTotalNewsCount);
              // this.$store.commit('situation/setThemeWebCount', this.getWebTotalNewsCount);
              this.$store.commit('situation/setSearchEndDate', endResult);
              this.$store.commit('situation/setSearchConditionKey', searchKey);
              this.$store.commit('situation/setCsvSearchDownload', csvDownloadKey)
              this.$store.commit("situation/setNewsFirstTabCheckboxValue", resetCheckbox);
              this.$store.commit("situation/setNewsSecondTabCheckboxValue", resetCheckbox);
              this.$store.commit("situation/setWebFirstTabCheckboxValue", resetCheckbox);
              this.$store.commit("situation/setWebSecondTabCheckboxValue", resetCheckbox);
              this.$store.commit("situation/setMagazineFirstTabCheckboxValue", resetCheckbox);
              this.$store.commit("situation/setMagazineSecondTabCheckboxValue", resetCheckbox);
              this.$store.commit('situation/setScRegisterFlag', true);
              this.$store.commit('situation/setWebregisterFlag', true);
              this.$store.commit('situation/setMagazineregisterFlag', true);
              this.activeItem = null;
              this.activeItemTopics = null;
              this.restrictDateFunction = 0;
              this.fullscreenLoading = false;
              // 2024/05/14  #13819  START
              var status = this.getStatus;
              var msgdetail = this.getErrorMessage;
              if(status == "1")
              {
                this.$alert(msgdetail,"確認", {  confirmButtonText: 'OK',dangerouslyUseHTMLString:true })
              }
              // 2024/05/14  #13819  END
            })
            .catch(() => {
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              this.fullscreenLoading = false;
              this.restrictDateFunction = 0;
              this.$store.commit('situation/setScRegisterFlag', true);
              this.$store.commit('situation/setWebregisterFlag', true);
              this.$store.commit('situation/setMagazineregisterFlag', true);
            })
        })
      }
      this.$LogMethodOut("side-bar","articleSearch");
    },
    //method for load the article based on search condition
    articleSearchByKeyword(){
      this.$LogButtonEvent("side-bar","SearchByKeyword");
      this.$LogMethodIN("side-bar","articleSearchByKeyword");
      this.$store.commit('situation/setTodayArticleFlag', false);

      if(this.currentPath != 1)
      {
        //get the start date from the selected date
        var startDate = this.date.start;
        var sdate = new Date(startDate),
        smnth = ("0" + (sdate.getMonth() + 1)).slice(-2),
        sday = ("0" + sdate.getDate()).slice(-2);
        //convert the date format
        var startResult = [sdate.getFullYear(), smnth, sday].join("/");
        
        //get the end date from the selected date
        var endDate = this.date.end;
        var edate = new Date(endDate),
        emnth = ("0" + (edate.getMonth() + 1)).slice(-2),
        eday = ("0" + edate.getDate()).slice(-2);
        //convert the date format
        var endResult = [edate.getFullYear(), emnth, eday].join("/");
        Vue.prototype.$session.set('searchKeywordValue', this.input1);
        Vue.prototype.$session.set('searchStartDate', startResult);
        Vue.prototype.$session.set('searchEndDate', endResult);
        Vue.prototype.$session.set('searchMonthParameter', smnth);
        Vue.prototype.$session.set('searchyearParameter', sdate.getFullYear());
        Vue.prototype.$session.set('defaultSearchLoadFlag', false);
        Vue.prototype.$session.set('triggerSearchFunctionFlag', 2);
        router.push('/0002');
      }
      else
      {
        this.setMailThemeId = this.$session.get('themeIdAfterLogin');
        this.themeValueDate = this.$session.get('themeValueAfterLogin');
        this.flagForSetDefaultCount = 1;

        this.$store.dispatch('communication/resetAllArticleValues').then(() => {

          //make the selected theme value as inactive
          this.activeItem = null;
          //make the selected topics value as inactive
          this.activeItemTopics = null;
          //make the mail transition link as disable
          this.sendMailValue = 1;
          //make the today article label as inactive
          this.activeTodayArticleLabel = null;

          this.$store.commit('situation/setThemeIdForPdfSuccess', null);
          this.$store.commit('situation/setThemeGroupIdForPdfSuccess', null);
          this.$store.commit('situation/setTopicsIdForPdfSuccess', null);

          //get the start date from the selected date
          var startDate = this.date.start;
          var sdate = new Date(startDate),
          smnth = ("0" + (sdate.getMonth() + 1)).slice(-2),
          sday = ("0" + sdate.getDate()).slice(-2);
          //convert the date format
          var startResult = [sdate.getFullYear(), smnth, sday].join("/");
          
          //get the end date from the selected date
          var endDate = this.date.end;
          var edate = new Date(endDate),
          emnth = ("0" + (edate.getMonth() + 1)).slice(-2),
          eday = ("0" + edate.getDate()).slice(-2);
          //convert the date format
          var endResult = [edate.getFullYear(), emnth, eday].join("/");

          this.startDateResult = startResult;
          this.endDateResult = endResult;

          // 2023/04/09  #14188  START
          Vue.prototype.$session.set('SelectStartDate', this.startDateResult);
          Vue.prototype.$session.set('SelectEndDate', this.endDateResult );
          // 2023/04/09  #14188  END

          this.$store.commit('situation/setDefaultThemeStartDate', startResult);
          this.$store.commit('situation/setDefaultThemeEndDate', endResult);
          
          var article_search_condition;
          if(this.input1 != '')
          {
            article_search_condition = {
              contract_id: this.contractId,
              user_id: this.userId,
              contract_kbn: 0,
              display_id: 'SID0002',
              process_date_from: startResult,
              process_date_to: endResult,
              theme_browsing: this.theme_browsing,
              sort_date: "",
              key_word: this.input1,
              start_num: 1,
              load_num: 10,
              sort_title: ""
                
            }
          }
          else
          {
            article_search_condition = {
              contract_id: this.contractId,
              user_id: this.userId,
              contract_kbn: 0,
              display_id: 'SID0002',
              process_date_from: startResult,
              process_date_to: endResult,
              theme_browsing: this.theme_browsing,
              sort_date: "",
              start_num: 1,
              load_num: 10,
              sort_title: ""
                
            }
          }
          
          this.fullscreenLoading = true;
          this.$store.commit('situation/setIsTopPageInitialLoading', true);
          //Api call for search the article by using keyword, media and search dropdown value
          Vue.prototype.$session.set('InputParameterFor0006',article_search_condition);
          Vue.prototype.$session.set('CurrentAID',"0071"); 
          this.$store.dispatch('communication/getArticleUsingSearch', article_search_condition).then(() => {
            this.$store.commit('situation/setIsTopPageInitialLoading', false);
            Vue.prototype.$session.set('searchKeywordValue', '');
            Vue.prototype.$session.set('searchStartDate', '');
            Vue.prototype.$session.set('searchEndDate', '');
            Vue.prototype.$session.set('defaultSearchLoadFlag', true);
            this.fullscreenLoading = false;
            var searchKey = 2;
            var csvDownloadKey = 1;
            var resetCheckbox = 0
            this.articleDate = startResult + ' ' + '-' + ' ' + endResult;

            var serchResultLabel = "検索結果" + "(" + parseInt(this.getTotalNewsCount + this.getWebTotalNewsCount) + "件)"
            this.$store.commit("situation/setSelectedLabel", serchResultLabel);
            this.$store.commit('situation/setArticleDate', this.articleDate);
            this.$store.commit('situation/setKeywordValue', this.input1);
            this.$store.commit('situation/setSearchStartDate', startResult);
            this.$store.commit('situation/setSearchEndDate', endResult);
            this.$store.commit('situation/setSearchConditionKey', searchKey);
            this.$store.commit('situation/setCsvSearchDownload', csvDownloadKey)
            this.$store.commit("situation/setThemeNewsCount", this.getTotalNewsCount);
            this.$store.commit('situation/setThemeWebCount', this.getWebTotalNewsCount);
            this.$store.commit('situation/setThemeMagazineCount', this.getMagazineTotalNewsCount);
            this.$store.commit("situation/setNewsFirstTabCheckboxValue", resetCheckbox);
            this.$store.commit("situation/setNewsSecondTabCheckboxValue", resetCheckbox);
            this.$store.commit("situation/setWebFirstTabCheckboxValue", resetCheckbox);
            this.$store.commit("situation/setWebSecondTabCheckboxValue", resetCheckbox);
            this.$store.commit("situation/setMagazineFirstTabCheckboxValue", resetCheckbox);
            this.$store.commit("situation/setMagazineSecondTabCheckboxValue", resetCheckbox);
            this.$store.commit('situation/setScRegisterFlag', true);
            this.$store.commit('situation/setWebregisterFlag', true);
            this.$store.commit('situation/setMagazineregisterFlag', true);
            this.activeItem = null;
            this.activeItemTopics = null;
          })
          .catch(() => {
            this.$store.commit('situation/setIsTopPageInitialLoading', false);
            this.fullscreenLoading = false;
            this.$store.commit('situation/setScRegisterFlag', true);
            this.$store.commit('situation/setWebregisterFlag', true);
            this.$store.commit('situation/setMagazineregisterFlag', true);
          })
        })
      }
      this.$LogMethodOut("side-bar","articleSearchByKeyword");
    },
    //Functions for getting value selected in search dropdown
    searchConditionChange($event){
      this.$LogButtonEvent("side-bar","ChangeCondition");
      this.$LogMethodIN("side-bar","searchConditionChange");
			for(var j=0; j<this.getsearchCondition.length;j++){
					if($event == this.getsearchCondition[j].value){
            this.select_search_value = this.getsearchCondition[j]["value"];
            this.articleMedia = 1;
					}
      }

      //if search dropdown is selected, clear and disable the keyword and media textbox
			if(this.select_search_value == '検索条件から選択'){
        this.articleMedia = 0;
        this.select_search_value = '';
			}else{
        this.input1 = '';
        this.form.SearchMediaName = '';
      }
      this.$LogMethodOut("side-bar","searchConditionChange");
    },
    //method for redirect to 0003 page
    sendTo0003Page(){
      this.$LogButtonEvent("side-bar","ThemeByMail");
      this.$LogMethodIN("side-bar","sendTo0003Page");
      if(this.sendMailValue == 0){
        // var currentUrl = window.location.pathname;
        this.dialogVisible=true;
        this.Dialogform.Emailinput1='';
        this.Dialogform.Emailinput2='';
      }
      this.$LogMethodOut("side-bar","sendTo0003Page");
    },
    //method for get the node value from selected theme group tree
    handleNodeClick(data) {
      this.$LogButtonEvent("side-bar","TreeNodeclick");
      this.$LogMethodIN("side-bar","handleNodeClick");
      var theme_group_value = data.value;
      //split the node value to check whether the value is theme or theme group
      var split_theme_group = theme_group_value.split(":");
      if(this.currentPath != 1)
      {
        var themeValueArray = [];
        if(split_theme_group[0] == "Theme")
        {
          themeValueArray = [{value: "Theme", id: data.id}];
        }
        else
        {
          themeValueArray = [{value: "Theme Group", id: data.id}];
        }
        this.$store.commit('situation/setThemeloadFlagFromOtherScreen', true);
        this.$store.commit('situation/setThemeloadFromOtherScreen', themeValueArray);
        this.$store.commit('situation/setTodayArticleFlag', false);
        Vue.prototype.$session.set('defaultSearchLoadFlag', false);
        Vue.prototype.$session.set('defaultThemeLoadFlag', false);
        router.push('/0002');
      }
      else
      {
        // If selected date in main calendar is empty, then loading previously selected value in main calendar
        if(this.date.start == '' && this.date.end == '')
        {
          this.restrictThemeApiCall = 1
          this.setPreviouslySelectedDate();
        }
        else
        {
          //no action needed
        }

        this.$store.dispatch('communication/resetAllArticleValues').then(() => {

          this.$store.commit('situation/setScRegisterFlag', data.sc_search_condition_defined_flag);
          this.$store.commit('situation/setWebregisterFlag', data.web_news_search_condition_defined_flag);
          this.$store.commit('situation/setMagazineregisterFlag', data.magazine_search_condition_defined_flag);
          //condition for sc_search_condition_defined_flag
          if(data.sc_search_condition_defined_flag == true)
          {
            this.sc_search_condition_flag = false;
          }
          else
          {
            this.sc_search_condition_flag = true;
          }
          //condition for web_news_search_condition_defined_flag
          if(data.web_news_search_condition_defined_flag == true)
          {
            this.web_news_search_condition_flag = false;
          }
          else
          {
            this.web_news_search_condition_flag = true;
          }
          if(data.magazine_search_condition_defined_flag == true){
              this.magazine_search_condition_flag = false;
            }
            else
            {
              this.magazine_search_condition_flag = true;
            }
          this.flagForSetDefaultCount = 0;
          this.restrictThemeApiCall = 0;
          //clear the selected dropdown value
          this.select_search_value = '';
          //clear the search dropdown value
          this.form.region = '';
          //clear the media textbox value
          this.form.SearchMediaName = '';
          //clear the search keyword textbox
          this.input1 = '';
          //set search keyword textbox and media textbox as undisable
          this.articleMedia = 0;
          //make the mail transition link as clickable
          this.sendMailValue = 0;
          //make the selected topics value as inactive
          this.activeItemTopics = null;
          //make the selected theme value as active
          this.activeItem = null;
          //make the today article label as inactive
          this.activeTodayArticleLabel = null;
          var theme_label = data.label;
          //commit the theme label to situation for displaying the value in top page
          this.$store.commit("situation/setSelectedLabel", theme_label);
          // var theme_group_value = data.value;
          // //split the node value to check whether the value is theme or theme group
          // var split_theme_group = theme_group_value.split(":");
          var inputParam;
          var webinputParam;
          var magazineinputParam;
          var selectedTheme = [];
          
          this.articleDate = this.startDateResult + ' ' + '-' + ' ' + this.endDateResult;
          this.$store.commit('situation/setArticleDate', this.articleDate);
          this.$store.commit('situation/setDefaultThemeStartDate', this.startDateResult);
          this.$store.commit('situation/setDefaultThemeEndDate', this.endDateResult);
          this.$store.commit('situation/setTodayArticleFlag', false);
          //if selected value is theme
          if(split_theme_group[0] == "Theme")
          {
            //set selected theme value for passing to 0003 page as query parameter
            this.setMailThemeValue = split_theme_group[1];
            //set selected theme id for passing to 0003 page as query parameter
            this.setMailThemeId = data.id;
            //set data_kbn for passing to 0003 page as query parameter
            this.data_kbn = 2;
            selectedTheme = [{value: "Theme", id: data.id}];
            this.themeValueDate = "Theme";
            //commit the selected theme to situation for sorting the article based on selected value
            this.$store.commit("situation/setSelectedTheme", selectedTheme);
            this.$store.commit('situation/setSearchConditionKey', 0);
            this.$store.commit("situation/setThemeNewsCount", data.news_article_count);
            this.$store.commit('situation/setThemeWebCount', data.web_article_count);
            this.$store.commit('situation/setThemeMagazineCount', data.magazine_article_count);
            this.$store.commit("situation/setScrollingDate", this.scroll_sort_date);
            this.$store.commit('situation/setScrollingTitle', this.scroll_sort_title);
            this.$store.commit('situation/setCsvSearchDownload', 0);
            this.$store.commit('situation/setThemeIdForPdfSuccess', data.id);
            this.$store.commit('situation/setThemeGroupIdForPdfSuccess', null);
            this.$store.commit('situation/setTopicsIdForPdfSuccess', null);
            //parameter for newspaper article with theme_id(AID0005)
            inputParam ={
              contract_id: this.contractId,
              process_date_start:this.startDateResult,
              process_date_end:this.endDateResult,
              sort_date: '',
              sort_title:'',
              start_num:1,
              load_num:10,
              theme_id: data.id
            }
            //parameter for web article with theme_id(AID0006)
            webinputParam ={
              contract_id: this.contractId,
              data_section: 3,
              process_date_start:this.startDateResult,
              process_date_end:this.endDateResult,
              sort_date:'',
              sort_title:'',
              start_num:1,
              load_num:10,
              theme_id: data.id
            }
            magazineinputParam ={
              contract_id: this.contractId,
              data_section: 5,
              process_date_start:this.startDateResult,
              process_date_end:this.endDateResult,
              sort_date:'',
              sort_title:'',
              start_num:1,
              load_num:10,
              theme_id: data.id
            }
            
          }
          else//if selected value is theme_group
          {
            //set selected theme value for passing to 0003 page as query parameter
            this.setMailThemeValue = data.value;
            //set selected theme id for passing to 0003 page as query parameter
            this.setMailThemeId = data.id;
            //set data_kbn for passing to 0003 page as query parameter
            this.data_kbn = 2;
            selectedTheme = [{value: "Theme Group", id: data.id}];
            this.themeValueDate = "Theme Group";
            //commit the selected theme to situation for sorting the article based on selected value
            this.$store.commit("situation/setSelectedTheme", selectedTheme);
            this.$store.commit('situation/setSearchConditionKey', 0);
            this.$store.commit("situation/setThemeNewsCount", data.news_article_count);
            this.$store.commit('situation/setThemeWebCount', data.web_article_count);
            this.$store.commit('situation/setThemeMagazineCount', data.magazine_article_count);
            this.$store.commit("situation/setScrollingDate", this.scroll_sort_date);
            this.$store.commit('situation/setScrollingTitle', this.scroll_sort_title);
            this.$store.commit('situation/setCsvSearchDownload', 0);
            this.$store.commit('situation/setThemeIdForPdfSuccess', null);
            this.$store.commit('situation/setThemeGroupIdForPdfSuccess', data.id);
            this.$store.commit('situation/setTopicsIdForPdfSuccess', null);
            //parameter for newspaper article with theme_group_id(AID0005)
            inputParam ={
              contract_id: this.contractId,
              process_date_start:this.startDateResult,
              process_date_end:this.endDateResult,
              sort_date: '',
              sort_title:'',
              start_num:1,
              load_num:10,
              theme_group_id: data.id
            }
            //parameter for web article with theme_group_id(AID0006)
            webinputParam ={
              contract_id: this.contractId,
              data_section: 3,
              process_date_start:this.startDateResult,
              process_date_end:this.endDateResult,
              sort_date:'',
              sort_title:'',
              start_num:1,
              load_num:10,
              theme_group_id: data.id
            }
            magazineinputParam ={
              contract_id: this.contractId,
              data_section: 5,
              process_date_start:this.startDateResult,
              process_date_end:this.endDateResult,
              sort_date:'',
              sort_title:'',
              start_num:1,
              load_num:10,
              theme_group_id: data.id
            }
          }

          var totalNewsLabel;
          var webNewsLabel;
          if(this.getThemeNewsCount != 0)
          {
            this.fullscreenLoading = true;
            this.$store.commit('situation/setIsTopPageInitialLoading', true);
            Vue.prototype.$session.set('InputParameterFor0006',inputParam);
            Vue.prototype.$session.set('CurrentAID',"0005");
            //Api call for displaying the News article based on selected theme
            this.$store.dispatch('communication/getNewspaperArticles', inputParam).then(() => {
              totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)"
              Vue.prototype.$session.set('CurrentNewsCount',this.getThemeNewsCount);
              this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
              this.$store.commit('situation/setArticleDate', this.articleDate);
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              this.fullscreenLoading = false;                                                                 
            })
            .catch(() => {
              this.fullscreenLoading = false;
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
            })
          }
          else
          {
            totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)"
            this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
            this.$store.commit('situation/setArticleDate', this.articleDate);
            this.$store.commit('situation/setIsTopPageInitialLoading', false);
          }

          if(this.getThemeWebCount != 0)
          {
            this.fullscreenLoading = true;
            this.$store.commit('situation/setIsTopPageInitialLoading', true);
            //Api call to get web article based on selected theme
            this.$store.dispatch('communication/getWebArticles', webinputParam).then(() => {
              webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
              this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              this.fullscreenLoading = false;
            })
            .catch(() => {
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              this.fullscreenLoading = false;
            })
          }
          else
          {
            webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
            this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
            this.$store.commit('situation/setIsTopPageInitialLoading', false);
          }

          if(this.getThemeMagazineCount != 0)
          {
            this.fullscreenLoading = true;
            this.$store.commit('situation/setIsTopPageInitialLoading', true);
            //Api call to get magazine article based on selected theme
            this.$store.dispatch('communication/getMagazineArticles', magazineinputParam).then(() => {
              let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
              this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              this.fullscreenLoading = false;
            })
                .catch(() => {
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  this.fullscreenLoading = false;
                })
          }
          else
          {
            let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
            this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
            this.$store.commit('situation/setIsTopPageInitialLoading', false);
          }
        })
      }
      this.$LogMethodOut("side-bar","handleNodeClick");
    },
    //method for get the value from selected theme list
    handleThemeValue(value, id, i, label, newsCount, webCount,magazineCount, scFlag, webFlag, magazineFlag){
      this.$LogButtonEvent("side-bar","SelectTheme");
      this.$LogMethodIN("side-bar","handleThemeValue");
      /*Reset the highlight of theme group selection */
      var theme_group_key = this.$refs.themegrouptree.getCurrentKey()
      if(theme_group_key != null){
        this.$refs.themegrouptree.setCurrentKey(null)
      }
      /*Reset the highlight of theme group selection */
      if(this.currentPath != 1)
      {
        var themeValueArray = [{value: "Theme", id: id}];
        this.$store.commit('situation/setThemeloadFlagFromOtherScreen', true);
        this.$store.commit('situation/setThemeloadFromOtherScreen', themeValueArray);
        this.$store.commit('situation/setTodayArticleFlag', false);
        Vue.prototype.$session.set('defaultSearchLoadFlag', false);
        Vue.prototype.$session.set('defaultThemeLoadFlag', false);
        router.push('/0002');
      }
      else
      {
        // If selected date in main calendar is empty, then loading previously selected value in main calendar
        if(this.date.start == '' && this.date.end == '')
        {
          this.restrictThemeApiCall = 1
          this.setPreviouslySelectedDate();
        }
        else
        {
          //no action needed
        }
       
        this.$store.dispatch('communication/resetAllArticleValues').then(() => {

          this.$store.commit('situation/setScRegisterFlag', scFlag);
          this.$store.commit('situation/setWebregisterFlag', webFlag);
          this.$store.commit('situation/setMagazineregisterFlag', magazineFlag);

          this.$store.commit('situation/setThemeIdForPdfSuccess', id);
          this.$store.commit('situation/setThemeGroupIdForPdfSuccess', null);
          this.$store.commit('situation/setTopicsIdForPdfSuccess', null);

          this.$store.commit('situation/setTodayArticleFlag', false);

          //condition for sc_search_condition_defined_flag
          if(scFlag == true)
          {
            this.sc_search_condition_flag = false;
          }
          else
          {
            this.sc_search_condition_flag = true;
          }
          //condition for web_news_search_condition_defined_flag
          if(webFlag == true)
          {
            this.web_news_search_condition_flag = false;
          }
          else
          {
            this.web_news_search_condition_flag = true;
          }
          if(magazineFlag == true){
            this.magazine_search_condition_flag = false;
          }
          else
          {
            this.magazine_search_condition_flag = true;
          }
          this.flagForSetDefaultCount = 0;
          this.restrictThemeApiCall = 0;
          //clear the selected dropdown value
          this.select_search_value = '';
          //clear the search dropdown value
          this.form.region = '';
          //clear the media textbox value
          this.form.SearchMediaName = '';
          //clear the search keyword textbox
          this.input1 = '';
          //set search keyword textbox and media textbox as undisable
          this.articleMedia = 0;
          //make the mail transition link as clickable
          this.sendMailValue = 0;
          //make the selected topics value as inactive
          this.activeItemTopics = null;
          //make the today article label as inactive
          this.activeTodayArticleLabel = null;
          //make the selected theme value as active
          this.activeItem = i;
          //set selected theme value for passing to 0003 page as query parameter
          this.setMailThemeValue = label;
          //set selected theme id for passing to 0003 page as query parameter
          this.setMailThemeId = id;
          //set data_kbn for passing to 0003 page as query parameter
            this.data_kbn = 1
          var theme_label = value;
          var inputParam;
          var webinputParam;
          var magazineinputParam;
          var selectedTheme = [];
          //commit the theme label to situation for displaying the value in top page
          this.$store.commit("situation/setSelectedLabel", theme_label);
          selectedTheme = [{value: "Theme", id: id}];
          this.themeValueDate = "Theme";
          //commit the selected theme to situation for sorting the article based on selected value
          this.$store.commit("situation/setSelectedTheme", selectedTheme);
          this.$store.commit('situation/setSearchConditionKey', 0);
          this.$store.commit("situation/setThemeNewsCount", newsCount);
          this.$store.commit('situation/setThemeWebCount', webCount);
          this.$store.commit('situation/setThemeMagazineCount', magazineCount);
          this.$store.commit("situation/setScrollingDate", this.scroll_sort_date);
          this.$store.commit('situation/setScrollingTitle', this.scroll_sort_title);
          this.$store.commit('situation/setCsvSearchDownload', 0);
          this.articleDate = this.startDateResult + ' ' + '-' + ' ' + this.endDateResult;
          this.$store.commit('situation/setArticleDate', this.articleDate);
          this.$store.commit('situation/setDefaultThemeStartDate', this.startDateResult);
          this.$store.commit('situation/setDefaultThemeEndDate', this.endDateResult);
          //parameter for newspaper article with theme_id(AID0005)
          inputParam ={
            contract_id: this.contractId,
            process_date_start:this.startDateResult,
            process_date_end:this.endDateResult,
            sort_date: '',
            sort_title:'',
            start_num:1,
            load_num:10,
            theme_id: id
          }
          //parameter for web article with theme_id(AID0006)
          webinputParam ={
            contract_id: this.contractId,
            data_section: 3,
            process_date_start:this.startDateResult,
            process_date_end:this.endDateResult,
            sort_date:'',
            sort_title:'',
            start_num:1,
            load_num:10,
            theme_id: id
          }
          magazineinputParam ={
            contract_id: this.contractId,
            data_section: 5,
            process_date_start:this.startDateResult,
            process_date_end:this.endDateResult,
            sort_date:'',
            sort_title:'',
            start_num:1,
            load_num:10,
            theme_id: id
          }
          var totalNewsLabel;
          var webNewsLabel;
          if(this.getThemeNewsCount != 0)
          {
            this.fullscreenLoading = true;
            this.$store.commit('situation/setIsTopPageInitialLoading', true);
            Vue.prototype.$session.set('InputParameterFor0006',inputParam);
            Vue.prototype.$session.set('CurrentAID',"0005");
            //Api call for displaying the News article based on selected theme
            this.$store.dispatch('communication/getNewspaperArticles', inputParam).then(() => {
              totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)"
              Vue.prototype.$session.set('CurrentNewsCount',this.getThemeNewsCount);
              this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
              this.$store.commit('situation/setArticleDate', this.articleDate);
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              this.fullscreenLoading = false;
            })
            .catch(() => {
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              this.fullscreenLoading = false;
            })
          }
          else
          {
            totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)";
            this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
            this.$store.commit('situation/setArticleDate', this.articleDate);
            this.$store.commit('situation/setIsTopPageInitialLoading', false);
          }

          if(this.getThemeWebCount != 0)
          {
            this.fullscreenLoading = true;
            this.$store.commit('situation/setIsTopPageInitialLoading', true);
            //Api call to get web article based on selected theme
            this.$store.dispatch('communication/getWebArticles', webinputParam).then(() => {
              webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
              this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              this.fullscreenLoading = false;
            })
            .catch(() => {
              webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
              this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              this.fullscreenLoading = false;
            })
          }
          else
          {
            webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
            this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
            this.$store.commit('situation/setIsTopPageInitialLoading', false);
          }

          if(this.getThemeMagazineCount != 0)
          {
            this.fullscreenLoading = true;
            this.$store.commit('situation/setIsTopPageInitialLoading', true);
            //Api call to get magazine article based on selected theme
            this.$store.dispatch('communication/getMagazineArticles', magazineinputParam).then(() => {
              let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
              this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              this.fullscreenLoading = false;
            })
            .catch(() => {
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              this.fullscreenLoading = false;
            })
          }
          else
          {
            let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
            this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
            this.$store.commit('situation/setIsTopPageInitialLoading', false);
          }
        })
      }
      this.$LogMethodOut("side-bar","handleThemeValue");
    },
    //method for get the value from selected topics list
    handleTopicsValue(value, id, i, label, newsCount, webCount,magazineCount, scFlag, webFlag, magazineFlag){
      this.$LogButtonEvent("side-bar","SelectTopic");
      this.$LogMethodIN("side-bar","handleTopicsValue");
      
      /*Reset the highlight of theme group selection */
      var theme_group_key = this.$refs.themegrouptree.getCurrentKey();
      if(theme_group_key != null){
        this.$refs.themegrouptree.setCurrentKey(null);
      }
      /*Reset the highlight of theme group selection */
      if(this.currentPath != 1)
      {
        var themeValueArray = [{value: "Topics", id: id}];
        this.$store.commit('situation/setThemeloadFlagFromOtherScreen', true);
        this.$store.commit('situation/setThemeloadFromOtherScreen', themeValueArray);
        this.$store.commit('situation/setTodayArticleFlag', false);
        Vue.prototype.$session.set('defaultSearchLoadFlag', false);
        Vue.prototype.$session.set('defaultThemeLoadFlag', false);
        router.push('/0002');
      }
      else
      {
        // If selected date in main calendar is empty, then loading previously selected value in main calendar
        if(this.date.start == '' && this.date.end == '')
        {
          this.restrictThemeApiCall = 1
          this.setPreviouslySelectedDate();
        }
        else
        {
          //no action needed
        }

        this.$store.dispatch('communication/resetAllArticleValues').then(() => {

          this.$store.commit('situation/setScRegisterFlag', scFlag);
          this.$store.commit('situation/setWebregisterFlag', webFlag);
          this.$store.commit('situation/setMagazineregisterFlag', magazineFlag);

          this.$store.commit('situation/setThemeIdForPdfSuccess', null);
          this.$store.commit('situation/setThemeGroupIdForPdfSuccess', null);
          this.$store.commit('situation/setTopicsIdForPdfSuccess', id);

          this.$store.commit('situation/setTodayArticleFlag', false);

          //condition for sc_search_condition_defined_flag
          if(scFlag == true)
          {
            this.sc_search_condition_flag = false;
          }
          else
          {
            this.sc_search_condition_flag = true;
          }
          //condition for web_news_search_condition_defined_flag
          if(webFlag == true)
          {
            this.web_news_search_condition_flag = false;
          }
          else
          {
            this.web_news_search_condition_flag = true;
          }
          if(magazineFlag == true){
            this.magazine_search_condition_flag = false;
          }
          else
          {
            this.magazine_search_condition_flag = true;
          }
          this.flagForSetDefaultCount = 0;
          this.restrictThemeApiCall = 0;
          //clear the selected dropdown value
          this.select_search_value = '';
          //clear the search dropdown value
          this.form.region = '';
          //clear the media textbox value
          this.form.SearchMediaName = '';
          //clear the search keyword textbox
          this.input1 = '';
          //set search keyword textbox and media textbox as undisable
          this.articleMedia = 0;
          //make the mail transition link as clickable
          this.sendMailValue = 0;
          //make the selected theme value as inactive
          this.activeItem = null;
          //make the today article label as inactive
          this.activeTodayArticleLabel = null;
          //make the selected topics value as active
          this.activeItemTopics = i;
          //set selected theme value for passing to 0003 page as query parameter
          this.setMailThemeValue = label;
          //set selected theme id for passing to 0003 page as query parameter
          this.setMailThemeId = id;
          //set data_kbn for passing to 0003 page as query parameter
          this.data_kbn = 3;
          
          var theme_label = value;
          var inputParam;
          var webinputParam;
          var magazineinputParam;
          var selectedTheme = [];

          //commit the theme label to situation for displaying the value in top page
          this.$store.commit("situation/setSelectedLabel", theme_label);
          selectedTheme = [{value: "Topics", id: id}];
          this.themeValueDate = "Topics";
          //commit the selected theme to situation for sorting the article based on selected value
          this.$store.commit("situation/setSelectedTheme", selectedTheme);
          this.$store.commit('situation/setSearchConditionKey', 0);
          this.$store.commit("situation/setThemeNewsCount", newsCount);
          Vue.prototype.$session.set('CurrentNewsCount',newsCount);
          this.$store.commit('situation/setThemeWebCount', webCount);
          this.$store.commit('situation/setThemeMagazineCount', magazineCount);
          this.$store.commit("situation/setScrollingDate", this.scroll_sort_date);
          this.$store.commit('situation/setScrollingTitle', this.scroll_sort_title);
          this.$store.commit('situation/setCsvSearchDownload', 0);
          this.articleDate = this.startDateResult + ' ' + '-' + ' ' + this.endDateResult;
          this.$store.commit('situation/setArticleDate', this.articleDate);
          this.$store.commit('situation/setDefaultThemeStartDate', this.startDateResult);
          this.$store.commit('situation/setDefaultThemeEndDate', this.endDateResult);

          //parameter for newspaper article with topics_id(AID0005)
          inputParam ={
            contract_id: this.contractId,
            process_date_start:this.startDateResult,
            process_date_end:this.endDateResult,
            sort_date: '',
            sort_title:'',
            start_num:1,
            load_num:10,
            topics_id: id
          }
          //parameter for web article with topics_id(AID0006)
          webinputParam ={
            contract_id: this.contractId,
            data_section: 3,
            process_date_start:this.startDateResult,
            process_date_end:this.endDateResult,
            sort_date:'',
            sort_title:'',
            start_num:1,
            load_num:10,
            topics_id: id
          }
          magazineinputParam ={
            contract_id: this.contractId,
            data_section: 5,
            process_date_start:this.startDateResult,
            process_date_end:this.endDateResult,
            sort_date:'',
            sort_title:'',
            start_num:1,
            load_num:10,
            topics_id: id
          }
          var totalNewsLabel;
          var webNewsLabel;
          if(this.getThemeNewsCount != 0)
          {
            this.fullscreenLoading = true;
            this.$store.commit('situation/setIsTopPageInitialLoading', true);
            Vue.prototype.$session.set('InputParameterFor0006',inputParam);
            Vue.prototype.$session.set('CurrentAID',"0005");
            //Api call for displaying the News article based on selected theme
            this.$store.dispatch('communication/getNewspaperArticles', inputParam).then(() => {
              totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)"
              //Vue.prototype.$session.set('CurrentNewsCount',this.getThemeNewsCount);
              this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
              this.$store.commit('situation/setArticleDate', this.articleDate);
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              this.fullscreenLoading = false;
            })
            .catch(() => {
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)"
              this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
              this.fullscreenLoading = false;
            })
          }
          else
          {
            totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)";
            this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
            this.$store.commit('situation/setArticleDate', this.articleDate);
            this.$store.commit('situation/setIsTopPageInitialLoading', false);
          }

          if(this.getThemeWebCount != 0)
          {
            this.fullscreenLoading = true;
            this.$store.commit('situation/setIsTopPageInitialLoading', true);
            //Api call to get web article based on selected theme
            this.$store.dispatch('communication/getWebArticles', webinputParam).then(() => {
              webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
              this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              this.fullscreenLoading = false;
            })
            .catch(() => {
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
              this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
              this.fullscreenLoading = false;
            })
          }
          else
          {
            webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
            this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
            this.$store.commit('situation/setIsTopPageInitialLoading', false);
          }

          if(this.getThemeMagazineCount != 0)
          {
            this.fullscreenLoading = true;
            this.$store.commit('situation/setIsTopPageInitialLoading', true);
            //Api call to get magazine article based on selected theme
            this.$store.dispatch('communication/getMagazineArticles', magazineinputParam).then(() => {
              let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
              this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              this.fullscreenLoading = false;
            })
            .catch(() => {
              let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
              this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
              this.$store.commit('situation/setIsTopPageInitialLoading', false);
              this.fullscreenLoading = false;
            })
          }
          else
          {
            let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
            this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
            this.$store.commit('situation/setIsTopPageInitialLoading', false);
          }
        })
      }
      this.$LogMethodOut("side-bar","handleTopicsValue");
    },
    
    //this function will set last selected date in main calendar. 
    setPreviouslySelectedDate(){
      this.date.start = new Date(this.startDateResult)
      this.date.end = new Date(this.endDateResult)
      var start_date_month = ("0" + (this.date.start.getMonth() + 1)).slice(-2)

      //call the calender move function based on given input dates
      this.calendarmove(start_date_month, this.date.start.getFullYear());       
    }
  },
  computed: {
    ...mapGetters("situation",["getthemetopics", 
                              "gettheme", 
                              "getthemegrouptopics",
                              "getDefaultMailTheme",
                              "getsearchCondition",
                              "getDefaultDate",
                              "getSelectedTheme",
                              "getThemeWebCount",
                              "getThemeMagazineCount",
                              "getThemeNewsCount",
                              "getMcArticleAvailableDate",
                              "getScArticleAvailableDate",
                              "getWebArticleAvailableDate",
                              "getMagazineArticleAvailableDate",
                              "getSortedElArticleDate",
                              "getTotalNewsCount",
                              "getWebTotalNewsCount",
                              "getMagazineTotalNewsCount",
                              "getDefaultNodeExpansion",
                              "getSelectedLabel",
                              "getSearchConditionKey",
                              "getDefaultDateLoading",
                              "getScRegisterFlag",
                              "getWebRegisterFlag",
                              "getMagazineRegisterFlag",
                              "getTodayArticleFlag",
                              "getDefaultThemeStartDate",
                              "getDefaultThemeEndDate",
                              "getloadFromMailFlag",
                              "getloadFromMailDate",
                              "getloadFromMailTheme",
                              "getTodayArticleLabel",
                              "getTodayArticleNewsCount",
                              "getTodayArticleWebNewsCount",
                              "getTodayArticleMagazineNewsCount",
                              "getThemeloadFlagFromOtherScreen",
                              "getThemeloadFromOtherScreen"
                              ]),
    ...mapGetters("situation0003",["getStatus","getErrorMessage","getMessageCode"]),
    ...mapGetters("situation0001", ["getElnetUser",
                                  "getNews_Article_Flag",
                                  "getWeb_News_Article_Flag",
                                  "getMagazine_Article_Flag",
                                  "getUserGroup_News_Article_Flag",
                                  "getUserGroup_Web_News_Article_Flag",
                                  "getUserGroup_Magazine_Article_Flag",
                                  "getUserAuthority",
                                  "getUserId",
                                  "getContractId",
                                  "getThemeBrowsing",
                                  "getTopicsCreationFlag",
                                  "getPdfUsageDisplayFlag",
                                  "getServiceLinkageInfo",
                                  "getCompanyConfigurationInfo",
                                  "getSubthemeDisplayFlag"])
    
  },
  mounted(){

    if(this.date){
      this.date.start = ''
      this.date.end = ''
    }
    /**Page Load from Mail */
    var is_loadFromMail = this.getloadFromMailFlag;

    /**Page Load from Mail */
    //get the external DB link based on the url
    this.externalDbUrl = Common.General.SetExternalDBUrlLink();

    this.$store.commit('situation/nikkieArticledata', []);
    this.$store.commit('situation/webArticleData', []);
    // 2023/04/25  #15063  START
    this.$store.commit('situation/magazineArticleData', []);
    // 2023/04/25  #15063  END
    //check user is El admin user
    this.elnet_user = this.getElnetUser;
    //get the news_article_flag from the session
    this.news_article_flag = this.getNews_Article_Flag;
    //get the web_news_article_flag from the session
    this.web_news_article_flag = this.getWeb_News_Article_Flag;
    //get the magazine_article_flag from the session
    this.magazine_article_flag = this.getMagazine_Article_Flag;

    //get the user_group_news_article_flag from the session
    this.user_group_news_article_flag = this.getUserGroup_News_Article_Flag;
    //get the user_group_web_news_article_flag from the session
    this.user_group_web_news_article_flag = this.getUserGroup_Web_News_Article_Flag;
    //get the user_group_magazine_article_flag from the session
    this.user_group_magazine_article_flag = this.getUserGroup_Magazine_Article_Flag;

    //get the defaultSearchLoadFlag value from session
    var defaultSearchLoadFlag = Vue.prototype.$session.get('defaultSearchLoadFlag');

    //get the defaultSearchLoadFlag value from session
    var loadingTodayArticle = Vue.prototype.$session.get('defaultThemeLoadFlag');

    //check whether the loading page is top page or not
    var current_display_id="SID"+(this.$router.currentRoute.path).replace(/\//g, '');

    if(current_display_id == "SID0002")
    {
      this.currentPath = 1;

      // 2023/04/09  #14188  START
      if (this.$session.get('SelectStartDate')) {
        this.startDateResult = this.$session.get('SelectStartDate');
        this.endDateResult = this.$session.get('SelectEndDate');
        this.date = {
          start: new Date(this.$session.get('SelectStartDate')),
          end: new Date(this.$session.get('SelectEndDate'))
        };
      }
      // 2023/04/09  #14188  END
    }

    //get the user authority value from session
    this.userAuthority = this.getUserAuthority;

    //get the user id value from session
    this.userId = this.getUserId;

    //get the contract_id value from session
    this.contractId = this.getContractId;

    //get the theme_browsing value from session
    this.theme_browsing = this.getThemeBrowsing;

    //get the topics_creation_flag from session
    this.topics_creation_flag = this.getTopicsCreationFlag;

    //get the pdf_usage_display_flag from session
    this.pdf_usage_display_flag = this.getPdfUsageDisplayFlag;

    //get the service linkage info value from the session
    var service_linkage = this.getServiceLinkageInfo;

    for(var l=0;l<service_linkage.length;l++)
    {
      if(service_linkage[l].data_section == 4)
      {
        this.external_link_flag = true
      }
      else if(service_linkage[l].data_section == 3)
      {
        this.web_administrator_menu_flag = true;
      }
      else if(service_linkage[l].data_section == 1 || service_linkage[l].data_section == 2)
      {
        this.news_administrator_menu_flag = true;
      }
      else if(service_linkage[l].data_section == 5)
      {
        this.magazine_administrator_menu_flag = true;
      }
    }

    //get the service linkage info value from the session
    var company_configuration_info = this.getCompanyConfigurationInfo;

    for(var s=0;s<company_configuration_info.length;s++)
    {
      if(company_configuration_info[s].configuration_key == "DISP_THEME_MAIL_LINK")
      {
        this.display_theme_mail_link_flag = company_configuration_info[s].configuration_value;
      }
      else if(company_configuration_info[s].configuration_key == "USE_INPUT_PRINT_NUM_FLAG")
      {
        this.display_multiple_print_link_flag = company_configuration_info[s].configuration_value;
      }
      else if(company_configuration_info[s].configuration_key == "DISP_TODAY_ARTICLE_LINK")
      {
        this.display_today_article_link_flag = company_configuration_info[s].configuration_value;
        if(this.display_today_article_link_flag == "1")
        {
          this.display_today_article_link_flag = true;
        }
        else
        {
          this.display_today_article_link_flag = false;
        }
      }
      else
      {
        //no action needed
      }
    }

    //api call for set-up date 
    this.$store.dispatch('communication/getArticleAvailableDate').then(() => {
      this.attributes[0].dates = this.getMcArticleAvailableDate;
      this.attributes[1].dates = this.getScArticleAvailableDate;
      this.attributes[2].dates = this.getWebArticleAvailableDate;
      this.attributes[3].dates = this.getMagazineArticleAvailableDate;
      var latestNewsDate  = this.getSortedElArticleDate[this.getSortedElArticleDate.length - 1];

      if(defaultSearchLoadFlag == undefined || defaultSearchLoadFlag == true)
      {

        //set process start date as two weeks from current date for load the article by using themes
        var sdate = new Date(latestNewsDate),
        smnth = ("0" + (sdate.getMonth() + 1)).slice(-2),
        sday = ("0" + (sdate.getDate())).slice(-2);
        //convert the date format
        this.startDateResult = [sdate.getFullYear(), smnth, sday].join("/");

        this.date = {
          start: new Date(this.startDateResult),
          end: new Date(this.startDateResult)
        }

        this.articleDate = this.startDateResult + ' ' + '-' + ' ' + this.startDateResult;
        this.$store.commit('situation/setDefaultThemeStartDate', this.startDateResult);
        this.$store.commit('situation/setDefaultThemeEndDate', this.startDateResult);

        //call the calender move function based on given input dates
        this.calendarmove(smnth, sdate.getFullYear());

        this.endDateResult = this.startDateResult;

        var themeDetails = {
          contract_id: this.contractId,
          theme_browsing: this.theme_browsing,
          user_id: this.userId,
          display_id: "SID0002",
          process_date_start: this.startDateResult,
          process_date_end: this.endDateResult
        };
        if(this.currentPath == 1 || (this.getthemetopics.length==0 && this.getthemegrouptopics.length==0 && this.gettheme.length==0)){
        this.$store.dispatch('communication/resetAllArticleValues').then(() => {
          this.fullscreenLoading = true;
          //Api call to get article theme values
          this.$store.commit('situation/setIsTopPageInitialLoading', true);
          this.request_count++;
          this.$store.dispatch('communication/getTheme', [themeDetails,"","",false]).then(() => {
            this.fullscreenLoading = false;
            this.setMailThemeValue = this.getDefaultMailTheme;
            this.setMailThemeId = this.getSelectedTheme[0].id;
            this.themeValueDate = this.getSelectedTheme[0].value;
          
            Vue.prototype.$session.set('themeValueAfterLogin', this.getSelectedTheme[0].value);
            Vue.prototype.$session.set('themeIdAfterLogin', this.getSelectedTheme[0].id);
            //condition for sc_search_condition_defined_flag
            if(this.getScRegisterFlag == true)
            {
              this.sc_search_condition_flag = false;
            }
            else
            {
              this.sc_search_condition_flag = true;
            }
            //condition for web_news_search_condition_defined_flag
            if(this.getWebRegisterFlag == true)
            {
              this.web_news_search_condition_flag = false;
            }
            else
            {
              this.web_news_search_condition_flag = true;
            }
            if(this.getMagazineRegisterFlag == true){
              this.magazine_search_condition_flag = false;
            }
            else
            {
              this.magazine_search_condition_flag = true;
            }
            if(this.currentPath == 1)
            {
              var inputParam;
              var webinputParam;
              var totalNewsLabel;
              var webNewsLabel;
              
              /*** Change by AJ for backlog Id: 1760 */
              //Remove code for load Today's Articles while page loading
              //then load article based on Topics,Theme Group and Theme
              /*** Change by AJ for backlog Id: 1760 */

                this.$store.commit('situation/setTodayArticleFlag', false);

                //display the mail link when article is load based on theme list
                this.sendMailValue = 0;
                //Highlight in side bar
                if(this.themeValueDate == "Theme")
                {
                  //Search theme index in theme group
                  var theme_index = -1;
                  var themes = this.gettheme;
                  
                  for(var i=0; i<themes.length;i++)
                  {
                    var current_theme_id = themes[i].id
                    if(this.setMailThemeId == current_theme_id)
                    {
                      theme_index = i;
                      break;
                    }
                  }

                  var theme_group_tree_key = -1;
                  if(theme_index == -1)
                  {
                    var theme_groups_themes = this.getthemegrouptopics
                    loop1:
                    for(var tgi=0; tgi<theme_groups_themes.length;tgi++)
                    {
                      var themes_children = theme_groups_themes[tgi].children;  
                      for(var j=0; j<themes_children.length;j++)
                      {
                        var current_themechildren_id = themes_children[j].id
                        if(this.setMailThemeId == current_themechildren_id)
                        {
                          
                          theme_group_tree_key = themes_children[j].tree_key;
                          break loop1;
                        }
                      }
                    }

                  }

                  if(theme_index > -1)
                  {
                    
                    //Highlight first theme
                    this.activeItem = theme_index;
                    this.$refs.themegrouptree.setCurrentKey(null)
                  }
                  else if(theme_group_tree_key > -1)
                  {
                  
                    //Highlight first theme
                    this.activeItem = null;
                    this.$refs.themegrouptree.setCurrentKey(theme_group_tree_key)
                  }
                  else
                  {
                    
                    this.activeItem = null;
                    this.$refs.themegrouptree.setCurrentKey(null)
                  }
                  
                  //Disable highlight others
                  this.activeItemTopics = null;
                }
                else if(this.themeValueDate == "Theme Group")
                {
                  //Highlight first theme
                  this.$refs.themegrouptree.setCurrentKey(0)
                  //Disable highlight others
                  this.activeItem = null;
                  this.activeItemTopics = null;
                }
                else if(this.themeValueDate == "Topics")
                {
                  //Highlight first theme
                  this.activeItemTopics = 0;
                  //Disable highlight others
                  this.$refs.themegrouptree.setCurrentKey(null)
                  this.activeItem = null;
                }
                else
                {
                  //No action required
                }
                this.restrictThemeApiCall = 0;
                  
                
                if(this.getThemeNewsCount != 0)
                {
                  if(this.themeValueDate == "Theme")
                  {
                    
                    //parameter for api AID0005
                    inputParam ={
                      contract_id: this.contractId,
                      process_date_start: this.startDateResult,
                      process_date_end: this.endDateResult,
                      sort_date: '',
                      sort_title:'',
                      start_num:1,
                      load_num:10,
                      theme_id: this.setMailThemeId
                    }

                    this.$store.commit('situation/setThemeIdForPdfSuccess', this.setMailThemeId);
                    this.$store.commit('situation/setThemeGroupIdForPdfSuccess', null);
                    this.$store.commit('situation/setTopicsIdForPdfSuccess', null);
                  }
                  else if(this.themeValueDate == "Theme Group")
                  {

                    //parameter for api AID0005
                    inputParam ={
                      contract_id: this.contractId,
                      process_date_start: this.startDateResult,
                      process_date_end: this.endDateResult,
                      sort_date: '',
                      sort_title:'',
                      start_num:1,
                      load_num:10,
                      theme_group_id: this.setMailThemeId
                    }

                    this.$store.commit('situation/setThemeIdForPdfSuccess', null);
                    this.$store.commit('situation/setThemeGroupIdForPdfSuccess', this.setMailThemeId);
                    this.$store.commit('situation/setTopicsIdForPdfSuccess', null);
                  }
                  else if(this.themeValueDate == "Topics")
                  {

                    inputParam ={
                      contract_id: this.contractId,
                      process_date_start: this.startDateResult,
                      process_date_end: this.endDateResult,
                      sort_date: '',
                      sort_title:'',
                      start_num:1,
                      load_num:10,
                      topics_id: this.setMailThemeId
                    }

                    this.$store.commit('situation/setThemeIdForPdfSuccess', null);
                    this.$store.commit('situation/setThemeGroupIdForPdfSuccess', null);
                    this.$store.commit('situation/setTopicsIdForPdfSuccess', this.setMailThemeId);
                  }
                  else
                  {
                    //console.log("No action required")
                  }
                  Vue.prototype.$session.set('InputParameterFor0006',inputParam);
                  Vue.prototype.$session.set('CurrentAID',"0005");
                  this.fullscreenLoading = true;
                  //Api call for get the news article
                  this.$store.commit('situation/setIsTopPageInitialLoading', true);
                  this.$store.dispatch('communication/getNewspaperArticles', inputParam).then(() => {
                    totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)"
                    Vue.prototype.$session.set('CurrentNewsCount',this.getThemeNewsCount);
                    this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    this.$store.commit('situation/setArticleDate', this.articleDate);
                    this.fullscreenLoading = false;
                  }).catch(()=>{
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                  })
                }
                else
                {
                  totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)"
                  this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  this.$store.commit('situation/setArticleDate', this.articleDate);
                }

                if(this.getThemeWebCount != 0)
                {

                  if(this.themeValueDate == "Theme")
                  {
                    //parameter for api AID0005
                    webinputParam ={
                      contract_id: this.contractId,
                      data_section: 3,
                      process_date_start:this.startDateResult,
                      process_date_end:this.endDateResult,
                      sort_date:'',
                      sort_title:'',
                      start_num:1,
                      load_num:10,
                      theme_id: this.setMailThemeId
                    }
                  }
                  else if(this.themeValueDate == "Theme Group")
                  {
                    //parameter for api AID0005
                    webinputParam ={
                      contract_id: this.contractId,
                      data_section: 3,
                      process_date_start:this.startDateResult,
                      process_date_end:this.endDateResult,
                      sort_date:'',
                      sort_title:'',
                      start_num:1,
                      load_num:10,
                      theme_group_id: this.setMailThemeId
                    }
                  }
                  else
                  {
                    //parameter for api AID0005
                    webinputParam ={
                      contract_id: this.contractId,
                      data_section: 3,
                      process_date_start:this.startDateResult,
                      process_date_end:this.endDateResult,
                      sort_date:'',
                      sort_title:'',
                      start_num:1,
                      load_num:10,
                      topics_id: this.setMailThemeId
                    }
                  }  

                  this.fullscreenLoading = true;
                  //Api call to get web article
                  this.$store.commit('situation/setIsTopPageInitialLoading', true);
                  this.$store.dispatch('communication/getWebArticles', webinputParam).then(() => {
                    webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                    this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                  }).catch(()=>{
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                  })
                }
                else
                {
                  webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                  this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                }

              if(this.getThemeMagazineCount != 0)
              {
                let magazineinputParam;
                if(this.themeValueDate == "Theme")
                {
                  magazineinputParam ={
                    contract_id: this.contractId,
                    data_section: 5,
                    process_date_start:this.startDateResult,
                    process_date_end:this.endDateResult,
                    sort_date:'',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    theme_id: this.setMailThemeId
                  }
                }
                else if(this.themeValueDate == "Theme Group")
                {
                  magazineinputParam ={
                    contract_id: this.contractId,
                    data_section: 5,
                    process_date_start:this.startDateResult,
                    process_date_end:this.endDateResult,
                    sort_date:'',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    theme_group_id: this.setMailThemeId
                  }
                }
                else
                {
                  magazineinputParam ={
                    contract_id: this.contractId,
                    data_section: 5,
                    process_date_start:this.startDateResult,
                    process_date_end:this.endDateResult,
                    sort_date:'',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    topics_id: this.setMailThemeId
                  }
                }

                this.fullscreenLoading = true;
                //Api call to get magazine article
                this.$store.commit('situation/setIsTopPageInitialLoading', true);
                this.$store.dispatch('communication/getMagazineArticles', magazineinputParam).then(() => {
                  let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                  this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  this.fullscreenLoading = false;
                }).catch(()=>{
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  this.fullscreenLoading = false;
                })
              }
              else
              {
                let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
              }
            }
            this.request_count--;
          })
          .catch(()=>{
            this.$store.commit('situation/setIsTopPageInitialLoading', false);
            this.fullscreenLoading = false;
            this.request_count--;
          })
        })
        }
      }
      else
      {
        if(this.$session.get('triggerSearchFunctionFlag') == 1)//if search is based on keyword, media name and search title
        {
          // 2023/04/09  #14188  START
          Vue.prototype.$session.set('triggerSearchFunctionFlag', 0);
          // 2023/04/09  #14188  END

          Vue.prototype.$session.set('defaultSearchLoadFlag', true);
          this.range = {
            start: new Date(this.$session.get('searchStartDate')),
            end: new Date(this.$session.get('searchEndDate'))
          };
          // 2023/03/03  #14143  START
          //this.searcselect_search_value = this.$session.get('searchTitleValue');
          this.select_search_value = this.$session.get('searchTitleValue');
          // 2023/03/03  #14143  END
          this.form.SearchMediaName = this.$session.get('searchmediaValue');
          this.input1 = this.$session.get('searchKeywordValue');
          this.form.region = this.$session.get('searchTitleValue');
          this.setMailThemeValue = this.getDefaultMailTheme;
          //condition for sc_news_search_condition_defined_flag
          if(this.getScRegisterFlag == true)
          {
            this.sc_search_condition_flag = false;
          }
          else
          {
            this.sc_search_condition_flag = true;
          }
          //condition for web_news_search_condition_defined_flag
          if(this.getWebRegisterFlag == true)
          {
            this.web_news_search_condition_flag = false;
          }
          else
          {
            this.web_news_search_condition_flag = true;
          }
          if(this.getMagazineRegisterFlag == true){
            this.magazine_search_condition_flag = false;
          }
          else
          {
            this.magazine_search_condition_flag = true;
          }
          // 2023/03/03  #14143  START
          if(this.select_search_value != '')
          {
            this.articleMedia = 1;
          }
          // 2023/03/03  #14143  END
          this.articleSearch();
        }
        else if(this.$session.get('triggerSearchFunctionFlag') == 2)//if search is based on keyword only
        {
          // 2023/04/09  #14188  START
          Vue.prototype.$session.set('triggerSearchFunctionFlag', 0);
          // 2023/04/09  #14188  END

          this.restrictThemeApiCall = 1;
          this.input1 = this.$session.get('searchKeywordValue');
          this.setMailThemeValue = this.getDefaultMailTheme;
          //highlight the selected date in calender
          this.date = {
            start: new Date(this.$session.get('searchStartDate')),
            end: new Date(this.$session.get('searchEndDate'))
          };
          //condition for sc_news_search_condition_defined_flag
          if(this.getScRegisterFlag == true)
          {
            this.sc_search_condition_flag = false;
          }
          else
          {
            this.sc_search_condition_flag = true;
          }
          //condition for web_news_search_condition_defined_flag
          if(this.getWebRegisterFlag == true)
          {
            this.web_news_search_condition_flag = false;
          }
          else
          {
            this.web_news_search_condition_flag = true;
          }
          if(this.getMagazineRegisterFlag == true){
            this.magazine_search_condition_flag = false;
          }
          else
          {
            this.magazine_search_condition_flag = true;
          }
          //call the calender move function based on given input dates
          this.calendarmove(this.$session.get('searchMonthParameter'), this.$session.get('searchyearParameter'));

          var themeDetailsForKeyword = {
            contract_id: this.contractId,
            theme_browsing: this.theme_browsing,
            user_id: this.userId,
            display_id: "SID0002",
            process_date_start: this.$session.get('searchStartDate'),
            process_date_end: this.$session.get('searchEndDate')
          };

          var existingArticleDetails = [];

          existingArticleDetails = [...existingArticleDetails, themeDetailsForKeyword, this.themeValueDate, this.setMailThemeId]
          this.fullscreenLoading = true;
          //Api call to get article theme values
          this.$store.dispatch('communication/getTheme', existingArticleDetails).then(() => {
            this.restrictThemeApiCall = 0;
            this.fullscreenLoading = false;
            this.articleSearchByKeyword();
          }).catch(() => {
            this.fullscreenLoading = false;
          })
        }
        else if(is_loadFromMail)
        {
          //For Mail url redirect
          Vue.prototype.$session.set('defaultSearchLoadFlag', true);
          this.$store.commit('situation/setloadFromMailFlag', false, { root: true })
          this.restrictThemeApiCall = 1;
          var mail_loadDate = this.getloadFromMailDate
          var mail_theme = this.getloadFromMailTheme
          var process_date = new Date(mail_loadDate)
          var process_date_month = ("0" + (process_date.getMonth() + 1)).slice(-2)
          //highlight the selected date in calender
          this.date = {
            start: process_date,
            end: process_date
          };

          //call the calender move function based on given input dates
          this.calendarmove(process_date_month, process_date.getFullYear());
          this.startDateResult = mail_loadDate;
          this.endDateResult = mail_loadDate;

          // 2023/04/09  #14188  START
          Vue.prototype.$session.set('SelectStartDate', this.startDateResult);
          Vue.prototype.$session.set('SelectEndDate', this.endDateResult );
          // 2023/04/09  #14188  END

          this.articleDate = this.startDateResult + ' ' + '-' + ' ' + this.startDateResult;
          this.$store.commit('situation/setDefaultThemeStartDate', this.startDateResult);
          this.$store.commit('situation/setDefaultThemeEndDate', this.startDateResult);

          var mailthemeDetails = {
            contract_id: this.contractId,
            theme_browsing: this.theme_browsing,
            user_id: this.userId,
            display_id: "SID0002",
            process_date_start: this.startDateResult,
            process_date_end: this.endDateResult
          };
          var mailexistingArticleDetails = [];
          
          
          this.setMailThemeId = mail_theme[0].id;
          this.themeValueDate = mail_theme[0].value;
          this.$store.commit("situation/setSelectedTheme", mail_theme);
          mailexistingArticleDetails = [...mailexistingArticleDetails, mailthemeDetails, this.themeValueDate, this.setMailThemeId]
          this.fullscreenLoading = true;
          //Api call to get article theme values
          this.$store.commit('situation/setIsTopPageInitialLoading', true);
          this.$store.dispatch('communication/getTheme', mailexistingArticleDetails).then(() => {
            this.fullscreenLoading = false;
            this.setMailThemeValue = this.getDefaultMailTheme;
            this.setMailThemeId = this.getSelectedTheme[0].id;
            this.themeValueDate = this.getSelectedTheme[0].value;             
            Vue.prototype.$session.set('themeValueAfterLogin', this.getSelectedTheme[0].value);
            Vue.prototype.$session.set('themeIdAfterLogin', this.getSelectedTheme[0].id);
            //condition for sc_search_condition_defined_flag
            if(this.getScRegisterFlag == true)
            {
              this.sc_search_condition_flag = false;
            }
            else
            {
              this.sc_search_condition_flag = true;
            }
            //condition for web_news_search_condition_defined_flag
            if(this.getWebRegisterFlag == true)
            {
              this.web_news_search_condition_flag = false;
            }
            else
            {
              this.web_news_search_condition_flag = true;
            }
            if(this.getMagazineRegisterFlag == true){
              this.magazine_search_condition_flag = false;
            }
            else
            {
              this.magazine_search_condition_flag = true;
            }
            var inputParam;
            var webinputParam;
            var totalNewsLabel;
            var webNewsLabel;
            
            //display the mail link when article is load based on theme list
            this.sendMailValue = 0;
            //Highlight in side bar
            if(this.themeValueDate == "Theme")
            {
              //Search theme index in theme group
              var theme_index = -1;
              var themes = this.gettheme;
              
              for(var i=0; i<themes.length;i++)
              {
                var current_theme_id = themes[i].id
                if(this.setMailThemeId == current_theme_id)
                {
                  theme_index = i;
                  break;
                }
              }

              var theme_group_tree_key = -1;
              if(theme_index == -1)
              {
                var theme_groups_themes = this.getthemegrouptopics
                loop1:
                for(var tgi=0; tgi<theme_groups_themes.length;tgi++)
                {
                  var themes_children = theme_groups_themes[tgi].children;  
                  for(var j=0; j<themes_children.length;j++)
                  {
                    var current_themechildren_id = themes_children[j].id
                    if(this.setMailThemeId == current_themechildren_id)
                    {
                      
                      theme_group_tree_key = themes_children[j].tree_key;
                      break loop1;
                    }
                  }
                }

              }

              if(theme_index > -1)
              {
                
                //Highlight first theme
                this.activeItem = theme_index;
                this.$refs.themegrouptree.setCurrentKey(null)
              }
              else if(theme_group_tree_key > -1)
              {
               
                //Highlight first theme
                this.activeItem = null;
                this.$refs.themegrouptree.setCurrentKey(theme_group_tree_key)
              }
              else
              {
                
                this.activeItem = null;
                this.$refs.themegrouptree.setCurrentKey(null)
              }
              
              //Disable highlight others
              this.activeItemTopics = null;
              
            }
            else if(this.themeValueDate == "Theme Group")
            {
              var theme_group_index = -1
              var theme_groups = this.getthemegrouptopics
              for(var k=0; k<theme_groups.length;k++)
              {
               
                var current_themegroup_id = theme_groups[k].id
                if(this.setMailThemeId == current_themegroup_id)
                {
                  theme_group_index = theme_groups[k].tree_key;
                  break;
                }
              }
              if(theme_group_index == -1)
              {
               
                this.$refs.themegrouptree.setCurrentKey(null)
              }
              else
              {
                //Highlight  theme group
                this.$refs.themegrouptree.setCurrentKey(theme_group_index)
              }
              
              //Disable highlight others
              this.activeItem = null;
              this.activeItemTopics = null;
            }
            else if(this.themeValueDate == "Topics")
            {
              var topics_index = -1
              var topics = this.getthemetopics
              for(var l=0; l<topics.length;l++)
              {
               
                var current_topics_id = topics[l].id
                if(this.setMailThemeId == current_topics_id)
                {
                  topics_index = l;
                  break;
                }
              }
              if(topics_index == -1)
              {
                this.activeItemTopics = null;
                
              }
              else
              {
                //Highlight  topics
                this.activeItemTopics = topics_index;
              }
              
              //Disable highlight others
              this.$refs.themegrouptree.setCurrentKey(null)
              this.activeItem = null;
            }
            else
            {
              //No action required
            }
            this.restrictThemeApiCall = 0;

            if(this.currentPath == 1)
            {
              if(this.getThemeNewsCount != 0)
              {
                if(this.themeValueDate == "Theme")
                {
                  //parameter for api AID0005
                  inputParam ={
                    contract_id: this.contractId,
                    process_date_start: this.startDateResult,
                    process_date_end: this.endDateResult,
                    sort_date: '',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    theme_id: this.setMailThemeId
                  }

                  this.$store.commit('situation/setThemeIdForPdfSuccess', this.setMailThemeId);
                  this.$store.commit('situation/setThemeGroupIdForPdfSuccess', null);
                  this.$store.commit('situation/setTopicsIdForPdfSuccess', null);
                }
                else if(this.themeValueDate == "Theme Group")
                {
                  //parameter for api AID0005
                  inputParam ={
                    contract_id: this.contractId,
                    process_date_start: this.startDateResult,
                    process_date_end: this.endDateResult,
                    sort_date: '',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    theme_group_id: this.setMailThemeId
                  }

                  this.$store.commit('situation/setThemeIdForPdfSuccess', null);
                  this.$store.commit('situation/setThemeGroupIdForPdfSuccess', this.setMailThemeId);
                  this.$store.commit('situation/setTopicsIdForPdfSuccess', null);
                }
                else
                {
                
                  inputParam ={
                    contract_id: this.contractId,
                    process_date_start: this.startDateResult,
                    process_date_end: this.endDateResult,
                    sort_date: '',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    topics_id: this.setMailThemeId
                  }

                  this.$store.commit('situation/setThemeIdForPdfSuccess', null);
                  this.$store.commit('situation/setThemeGroupIdForPdfSuccess', null);
                  this.$store.commit('situation/setTopicsIdForPdfSuccess', this.setMailThemeId);
                }
                Vue.prototype.$session.set('InputParameterFor0006',inputParam);
                Vue.prototype.$session.set('CurrentAID',"0005");
                this.fullscreenLoading = true;
                //Api call for get the news article
                this.$store.commit('situation/setIsTopPageInitialLoading', true);
                this.$store.dispatch('communication/getNewspaperArticles', inputParam).then(() => {
                  totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)"
                  Vue.prototype.$session.set('CurrentNewsCount',this.getThemeNewsCount);
                  this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  this.$store.commit('situation/setArticleDate', this.articleDate);
                  this.fullscreenLoading = false;
                }).catch(()=>{
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  this.fullscreenLoading = false;
                })
              }
              else
              {
                totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)";
                this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
                this.$store.commit('situation/setArticleDate', this.articleDate);
              }

              if(this.getThemeWebCount != 0)
              {

                if(this.themeValueDate == "Theme")
                {
                  //parameter for api AID0005
                  webinputParam ={
                    contract_id: this.contractId,
                    data_section: 3,
                    process_date_start:this.startDateResult,
                    process_date_end:this.endDateResult,
                    sort_date:'',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    theme_id: this.setMailThemeId
                  }
                }
                else if(this.themeValueDate == "Theme Group")
                {
                  //parameter for api AID0005
                  webinputParam ={
                    contract_id: this.contractId,
                    data_section: 3,
                    process_date_start:this.startDateResult,
                    process_date_end:this.endDateResult,
                    sort_date:'',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    theme_group_id: this.setMailThemeId
                  }
                }
                else
                {
                  //parameter for api AID0005
                  webinputParam ={
                    contract_id: this.contractId,
                    data_section: 3,
                    process_date_start:this.startDateResult,
                    process_date_end:this.endDateResult,
                    sort_date:'',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    topics_id: this.setMailThemeId
                  }
                }  

                this.fullscreenLoading = true;
                //Api call to get web article
                this.$store.commit('situation/setIsTopPageInitialLoading', true);
                this.$store.dispatch('communication/getWebArticles', webinputParam).then(() => {
                  webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                  this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  this.fullscreenLoading = false;
                }).catch(()=>{
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  this.fullscreenLoading = false;
                })
              }
              else
              {
                webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
              }

              if(this.getThemeMagazineCount != 0)
              {
                let magazineinputParam;
                if(this.themeValueDate == "Theme")
                {
                  //parameter for api AID0005
                  magazineinputParam ={
                    contract_id: this.contractId,
                    data_section: 5,
                    process_date_start:this.startDateResult,
                    process_date_end:this.endDateResult,
                    sort_date:'',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    theme_id: this.setMailThemeId
                  }
                }
                else if(this.themeValueDate == "Theme Group")
                {
                  //parameter for api AID0005
                  magazineinputParam ={
                    contract_id: this.contractId,
                    data_section: 5,
                    process_date_start:this.startDateResult,
                    process_date_end:this.endDateResult,
                    sort_date:'',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    theme_group_id: this.setMailThemeId
                  }
                }
                else
                {
                  //parameter for api AID0005
                  magazineinputParam ={
                    contract_id: this.contractId,
                    data_section: 5,
                    process_date_start:this.startDateResult,
                    process_date_end:this.endDateResult,
                    sort_date:'',
                    sort_title:'',
                    start_num:1,
                    load_num:10,
                    topics_id: this.setMailThemeId
                  }
                }

                this.fullscreenLoading = true;
                //Api call to get magazine article
                this.$store.commit('situation/setIsTopPageInitialLoading', true);
                this.$store.dispatch('communication/getMagazineArticles', magazineinputParam).then(() => {
                  let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                  this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  this.fullscreenLoading = false;
                }).catch(()=>{
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  this.fullscreenLoading = false;
                })
              }
              else
              {
                let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                this.$store.commit('situation/setIsTopPageInitialLoading', false);
              }
            }
            
          }).catch(()=>{
            this.$store.commit('situation/setIsTopPageInitialLoading', false);
            this.fullscreenLoading = false;
          })


          
        }
        else if(this.getThemeloadFlagFromOtherScreen)
        {
          //For load the theme from other screens
          Vue.prototype.$session.set('defaultSearchLoadFlag', true);
          this.$store.commit('situation/setThemeloadFlagFromOtherScreen', false, { root: true });
          this.restrictThemeApiCall = 1;
          var other_screen_theme = this.getThemeloadFromOtherScreen;
          // 2023/04/09  #14188  START
          // //set process start date as two weeks from current date for load the article by using themes
          // var themesdate = new Date(latestNewsDate),
          //     themesmnth = ("0" + (themesdate.getMonth() + 1)).slice(-2),
          //     themesday = ("0" + (themesdate.getDate())).slice(-2);
          // //convert the date format
          // this.startDateResult = [themesdate.getFullYear(), themesmnth, themesday].join("/");
          //
          // this.date = {
          //   start: new Date(this.startDateResult),
          //   end: new Date(this.startDateResult)
          // }
          //
          // this.articleDate = this.startDateResult + ' ' + '-' + ' ' + this.startDateResult;
          // this.$store.commit('situation/setDefaultThemeStartDate', this.startDateResult);
          // this.$store.commit('situation/setDefaultThemeEndDate', this.startDateResult);
          //
          // //call the calender move function based on given input dates
          // this.calendarmove(themesmnth, themesdate.getFullYear());
          // this.endDateResult = this.startDateResult;
          if (this.startDateResult == ""){
            //set process start date as two weeks from current date for load the article by using themes
            var themesdate = new Date(latestNewsDate),
                themesmnth = ("0" + (themesdate.getMonth() + 1)).slice(-2),
                themesday = ("0" + (themesdate.getDate())).slice(-2);
            //convert the date format
            this.startDateResult = [themesdate.getFullYear(), themesmnth, themesday].join("/");

            this.date = {
              start: new Date(this.startDateResult),
              end: new Date(this.startDateResult)
            }

            this.articleDate = this.startDateResult + ' ' + '-' + ' ' + this.startDateResult;
            this.$store.commit('situation/setDefaultThemeStartDate', this.startDateResult);
            this.$store.commit('situation/setDefaultThemeEndDate', this.startDateResult);

            //call the calender move function based on given input dates
            this.calendarmove(themesmnth, themesdate.getFullYear());
            this.endDateResult = this.startDateResult;

            Vue.prototype.$session.set('SelectStartDate', this.startDateResult);
            Vue.prototype.$session.set('SelectEndDate', this.endDateResult );
          }
          else{
            this.date = {
              start: new Date(this.startDateResult),
              end: new Date(this.endDateResult)
            }
            this.articleDate = this.startDateResult + ' ' + '-' + ' ' + this.endDateResult;
            this.$store.commit('situation/setDefaultThemeStartDate', this.startDateResult);
            this.$store.commit('situation/setDefaultThemeEndDate', this.endDateResult);

            var themesmnth2 = ("0" + (this.date.start.getMonth() + 1)).slice(-2);
            //call the calender move function based on given input dates
            this.calendarmove(themesmnth2, this.date.start.getFullYear());
          }
          // 2023/04/09  #14188  END

          var otherscreenthemeDetails = {
            contract_id: this.contractId,
            theme_browsing: this.theme_browsing,
            user_id: this.userId,
            display_id: "SID0002",
            process_date_start: this.startDateResult,
            process_date_end: this.endDateResult
          };
          var otherscreenexistingArticleDetails = [];
          
          if(other_screen_theme.length > 0)
          {
            this.setMailThemeId = other_screen_theme[0].id;
            this.themeValueDate = other_screen_theme[0].value;
          }
          else
          {
            this.setMailThemeId = "";
            this.themeValueDate = "";
          }
          this.$store.commit("situation/setSelectedTheme", other_screen_theme);
          otherscreenexistingArticleDetails = [...otherscreenexistingArticleDetails, otherscreenthemeDetails, this.themeValueDate, this.setMailThemeId];
          this.fullscreenLoading = true;
          //Api call to get article theme values
          this.$store.commit('situation/setIsTopPageInitialLoading', true);
          this.$store.dispatch('communication/getTheme', otherscreenexistingArticleDetails).then(() => {
            this.fullscreenLoading = false;
            this.setMailThemeValue = this.getDefaultMailTheme;
            // 2023/04/09  #14188  START
            if(other_screen_theme.length > 0)
            {
              this.$store.commit('situation/setSelectedTheme', other_screen_theme, { root: true });
            }
            // 2023/04/09  #14188  END
            this.setMailThemeId = this.getSelectedTheme[0].id;
            this.themeValueDate = this.getSelectedTheme[0].value;             
            Vue.prototype.$session.set('themeValueAfterLogin', this.getSelectedTheme[0].value);
            Vue.prototype.$session.set('themeIdAfterLogin', this.getSelectedTheme[0].id);
            //condition for sc_search_condition_defined_flag
            if(this.getScRegisterFlag == true)
            {
              this.sc_search_condition_flag = false;
            }
            else
            {
              this.sc_search_condition_flag = true;
            }
            //condition for web_news_search_condition_defined_flag
            if(this.getWebRegisterFlag == true)
            {
              this.web_news_search_condition_flag = false;
            }
            else
            {
              this.web_news_search_condition_flag = true;
            }
            if(this.getMagazineRegisterFlag == true){
              this.magazine_search_condition_flag = false;
            }
            else
            {
              this.magazine_search_condition_flag = true;
            }
            var inputParam;
            var webinputParam;
            var totalNewsLabel;
            var webNewsLabel;

            if(this.currentPath == 1)
            {
              if(loadingTodayArticle)
              {
                this.$store.commit('situation/setScRegisterFlag', true);
                this.$store.commit('situation/setWebregisterFlag', true);
                this.$store.commit('situation/setMagazineregisterFlag', true);
                this.$store.commit('situation/setThemeIdForPdfSuccess', null);
                this.$store.commit('situation/setThemeGroupIdForPdfSuccess', null);
                this.$store.commit('situation/setTopicsIdForPdfSuccess', null);
                this.restrictDateFunction = 0;
                this.restrictThemeApiCall = 0;
                //hide the mail link when today article link is displayed
                this.sendMailValue = 1;
                //Highlight the today article label
                this.activeTodayArticleLabel = 0;

                //parameter for api AID0005
                inputParam ={
                  contract_id: this.contractId,
                  process_date_start: this.startDateResult,
                  process_date_end: this.endDateResult,
                  sort_date: '',
                  sort_title:'',
                  start_num:1,
                  load_num:10
                }
                Vue.prototype.$session.set('InputParameterFor0006',inputParam);
                Vue.prototype.$session.set('CurrentAID',"0005");
                this.fullscreenLoading = true;
                //Api call for get the news article
                this.$store.commit('situation/setIsTopPageInitialLoading', true);
                this.$store.dispatch('communication/getNewspaperArticles', inputParam).then(() => {
                  this.$store.commit("situation/setThemeNewsCount", this.getTodayArticleNewsCount);
                  totalNewsLabel = "新聞(" + this.getTodayArticleNewsCount + "件)";
                  Vue.prototype.$session.set('CurrentNewsCount',this.getTodayArticleNewsCount);
                  this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
                  this.$store.commit('situation/setArticleDate', this.articleDate);
                  this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                  this.$store.commit('situation/setSearchConditionKey', 0);
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  this.fullscreenLoading = false;
                }).catch(()=>{
                  totalNewsLabel = "新聞(" + this.getTodayArticleNewsCount + "件)";
                  this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
                  this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                  this.$store.commit('situation/setArticleDate', this.articleDate);
                  this.$store.commit('situation/setSearchConditionKey', 0);
                  this.$store.commit("situation/setThemeNewsCount", this.getTodayArticleNewsCount);
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  this.fullscreenLoading = false;
                })
              
                //parameter for api AID0005
                webinputParam ={
                  contract_id: this.contractId,
                  data_section: 3,
                  process_date_start:this.startDateResult,
                  process_date_end:this.endDateResult,
                  sort_date:'',
                  sort_title:'',
                  start_num:1,
                  load_num:10
                }
                
                this.fullscreenLoading = true;
                //Api call to get web article
                this.$store.commit('situation/setIsTopPageInitialLoading', true);
                this.$store.dispatch('communication/getWebArticles', webinputParam).then(() => {
                  this.$store.commit("situation/setThemeWebCount", this.getTodayArticleWebNewsCount);
                  webNewsLabel = "WEB(" + this.getTodayArticleWebNewsCount + "件)";
                  this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                  this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                  this.$store.commit('situation/setArticleDate', this.articleDate);
                  this.$store.commit('situation/setSearchConditionKey', 0);
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  this.fullscreenLoading = false;
                }).catch(()=>{
                  webNewsLabel = "WEB(" + this.getTodayArticleWebNewsCount + "件)";
                  this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                  this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                  this.$store.commit('situation/setArticleDate', this.articleDate);
                  this.$store.commit('situation/setSearchConditionKey', 0);
                  this.$store.commit("situation/setThemeWebCount", this.getTodayArticleWebNewsCount);
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  this.fullscreenLoading = false;
                })

                let magazineinputParam ={
                  contract_id: this.contractId,
                  data_section: 5,
                  process_date_start:this.startDateResult,
                  process_date_end:this.endDateResult,
                  sort_date:'',
                  sort_title:'',
                  start_num:1,
                  load_num:10
                }

                this.fullscreenLoading = true;
                //Api call to get magazine article
                this.$store.commit('situation/setIsTopPageInitialLoading', true);
                this.$store.dispatch('communication/getMagazineArticles', magazineinputParam).then(() => {
                  this.$store.commit("situation/setThemeMagazineCount", this.getTodayArticleMagazineNewsCount);
                  let magazineNewsLabel = "雑誌(" + this.getTodayArticleMagazineNewsCount + "件)";
                  this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                  this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                  this.$store.commit('situation/setArticleDate', this.articleDate);
                  this.$store.commit('situation/setSearchConditionKey', 0);
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  this.fullscreenLoading = false;
                }).catch(()=>{
                  let magazineNewsLabel = "雑誌(" + this.getTodayArticleMagazineNewsCount + "件)";
                  this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                  this.$store.commit("situation/setSelectedLabel", this.getTodayArticleLabel);
                  this.$store.commit('situation/setArticleDate', this.articleDate);
                  this.$store.commit('situation/setSearchConditionKey', 0);
                  this.$store.commit("situation/setThemeMagazineCount", this.getTodayArticleMagazineNewsCount);
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  this.fullscreenLoading = false;
                })
              }
              else
              {
                //display the mail link when article is load based on theme list
                this.sendMailValue = 0;
                //Highlight in side bar
                if(this.themeValueDate == "Theme")
                {
                  //Search theme index in theme group
                  var theme_index = -1;
                  var themes = this.gettheme;
                  
                  for(var i=0; i<themes.length;i++)
                  {
                    var current_theme_id = themes[i].id
                    if(this.setMailThemeId == current_theme_id)
                    {
                      theme_index = i;
                      break;
                    }
                  }

                  var theme_group_tree_key = -1;
                  if(theme_index == -1)
                  {
                    var theme_groups_themes = this.getthemegrouptopics
                    loop1:
                    for(var tgi=0; tgi<theme_groups_themes.length;tgi++)
                    {
                      var themes_children = theme_groups_themes[tgi].children;  
                      for(var j=0; j<themes_children.length;j++)
                      {
                        var current_themechildren_id = themes_children[j].id
                        if(this.setMailThemeId == current_themechildren_id)
                        {
                          
                          theme_group_tree_key = themes_children[j].tree_key;
                          break loop1;
                        }
                      }
                    }

                  }

                  if(theme_index > -1)
                  {
                    
                    //Highlight first theme
                    this.activeItem = theme_index;
                    this.$refs.themegrouptree.setCurrentKey(null)
                  }
                  else if(theme_group_tree_key > -1)
                  {
                  
                    //Highlight first theme
                    this.activeItem = null;
                    this.$refs.themegrouptree.setCurrentKey(theme_group_tree_key)
                  }
                  else
                  {
                    
                    this.activeItem = null;
                    this.$refs.themegrouptree.setCurrentKey(null)
                  }
                  
                  //Disable highlight others
                  this.activeItemTopics = null;
                  
                }
                else if(this.themeValueDate == "Theme Group")
                {
                  var theme_group_index = -1
                  var theme_groups = this.getthemegrouptopics
                  for(var k=0; k<theme_groups.length;k++)
                  {
                  
                    var current_themegroup_id = theme_groups[k].id
                    if(this.setMailThemeId == current_themegroup_id)
                    {
                      theme_group_index = theme_groups[k].tree_key;
                      break;
                    }
                  }
                  if(theme_group_index == -1)
                  {
                  
                    this.$refs.themegrouptree.setCurrentKey(null)
                  }
                  else
                  {
                    //Highlight  theme group
                    this.$refs.themegrouptree.setCurrentKey(theme_group_index)
                  }
                  
                  //Disable highlight others
                  this.activeItem = null;
                  this.activeItemTopics = null;
                }
                else if(this.themeValueDate == "Topics")
                {
                  var topics_index = -1
                  var topics = this.getthemetopics
                  for(var l=0; l<topics.length;l++)
                  {
                  
                    var current_topics_id = topics[l].id
                    if(this.setMailThemeId == current_topics_id)
                    {
                      topics_index = l;
                      break;
                    }
                  }
                  if(topics_index == -1)
                  {
                    this.activeItemTopics = null;
                    
                  }
                  else
                  {
                    //Highlight  topics
                    this.activeItemTopics = topics_index;
                  }
                  
                  //Disable highlight others
                  this.$refs.themegrouptree.setCurrentKey(null)
                  this.activeItem = null;
                }
                else
                {
                  //No action required
                }
                this.restrictThemeApiCall = 0;

                
                if(this.getThemeNewsCount != 0)
                {
                  if(this.themeValueDate == "Theme")
                  {
                    //parameter for api AID0005
                    inputParam ={
                      contract_id: this.contractId,
                      process_date_start: this.startDateResult,
                      process_date_end: this.endDateResult,
                      sort_date: '',
                      sort_title:'',
                      start_num:1,
                      load_num:10,
                      theme_id: this.setMailThemeId
                    }

                    this.$store.commit('situation/setThemeIdForPdfSuccess', this.setMailThemeId);
                    this.$store.commit('situation/setThemeGroupIdForPdfSuccess', null);
                    this.$store.commit('situation/setTopicsIdForPdfSuccess', null);
                  }
                  else if(this.themeValueDate == "Theme Group")
                  {
                    //parameter for api AID0005
                    inputParam ={
                      contract_id: this.contractId,
                      process_date_start: this.startDateResult,
                      process_date_end: this.endDateResult,
                      sort_date: '',
                      sort_title:'',
                      start_num:1,
                      load_num:10,
                      theme_group_id: this.setMailThemeId
                    }

                    this.$store.commit('situation/setThemeIdForPdfSuccess', null);
                    this.$store.commit('situation/setThemeGroupIdForPdfSuccess', this.setMailThemeId);
                    this.$store.commit('situation/setTopicsIdForPdfSuccess', null);
                  }
                  else
                  {
                  
                    inputParam ={
                      contract_id: this.contractId,
                      process_date_start: this.startDateResult,
                      process_date_end: this.endDateResult,
                      sort_date: '',
                      sort_title:'',
                      start_num:1,
                      load_num:10,
                      topics_id: this.setMailThemeId
                    }

                    this.$store.commit('situation/setThemeIdForPdfSuccess', null);
                    this.$store.commit('situation/setThemeGroupIdForPdfSuccess', null);
                    this.$store.commit('situation/setTopicsIdForPdfSuccess', this.setMailThemeId);
                  }
                  Vue.prototype.$session.set('InputParameterFor0006',inputParam);
                  Vue.prototype.$session.set('CurrentAID',"0005");
                  this.fullscreenLoading = true;
                  //Api call for get the news article
                  this.$store.commit('situation/setIsTopPageInitialLoading', true);
                  this.$store.dispatch('communication/getNewspaperArticles', inputParam).then(() => {
                    totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)"
                    Vue.prototype.$session.set('CurrentNewsCount',this.getThemeNewsCount);
                    this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    this.$store.commit('situation/setArticleDate', this.articleDate);
                    this.fullscreenLoading = false;
                  }).catch(()=>{
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                  })
                }
                else
                {
                  totalNewsLabel = "新聞(" + this.getThemeNewsCount + "件)";
                  this.$store.commit('situation/setTotalNewsLabel', totalNewsLabel);
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                  this.$store.commit('situation/setArticleDate', this.articleDate);
                }

                if(this.getThemeWebCount != 0)
                {

                  if(this.themeValueDate == "Theme")
                  {
                    //parameter for api AID0005
                    webinputParam ={
                      contract_id: this.contractId,
                      data_section: 3,
                      process_date_start:this.startDateResult,
                      process_date_end:this.endDateResult,
                      sort_date:'',
                      sort_title:'',
                      start_num:1,
                      load_num:10,
                      theme_id: this.setMailThemeId
                    }
                  }
                  else if(this.themeValueDate == "Theme Group")
                  {
                    //parameter for api AID0005
                    webinputParam ={
                      contract_id: this.contractId,
                      data_section: 3,
                      process_date_start:this.startDateResult,
                      process_date_end:this.endDateResult,
                      sort_date:'',
                      sort_title:'',
                      start_num:1,
                      load_num:10,
                      theme_group_id: this.setMailThemeId
                    }
                  }
                  else
                  {
                    //parameter for api AID0005
                    webinputParam ={
                      contract_id: this.contractId,
                      data_section: 3,
                      process_date_start:this.startDateResult,
                      process_date_end:this.endDateResult,
                      sort_date:'',
                      sort_title:'',
                      start_num:1,
                      load_num:10,
                      topics_id: this.setMailThemeId
                    }
                  }  

                  this.fullscreenLoading = true;
                  //Api call to get web article
                  this.$store.commit('situation/setIsTopPageInitialLoading', true);
                  this.$store.dispatch('communication/getWebArticles', webinputParam).then(() => {
                    webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                    this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                  }).catch(()=>{
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                  })
                }
                else
                {
                  webNewsLabel = "WEB(" + this.getThemeWebCount + "件)";
                  this.$store.commit('situation/setWebTotalLabel', webNewsLabel);
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                }

                if(this.getThemeMagazineCount != 0)
                {
                  let magazineinputParam;
                  if(this.themeValueDate == "Theme")
                  {
                    //parameter for api AID0005
                    magazineinputParam ={
                      contract_id: this.contractId,
                      data_section: 5,
                      process_date_start:this.startDateResult,
                      process_date_end:this.endDateResult,
                      sort_date:'',
                      sort_title:'',
                      start_num:1,
                      load_num:10,
                      theme_id: this.setMailThemeId
                    }
                  }
                  else if(this.themeValueDate == "Theme Group")
                  {
                    //parameter for api AID0005
                    magazineinputParam ={
                      contract_id: this.contractId,
                      data_section: 5,
                      process_date_start:this.startDateResult,
                      process_date_end:this.endDateResult,
                      sort_date:'',
                      sort_title:'',
                      start_num:1,
                      load_num:10,
                      theme_group_id: this.setMailThemeId
                    }
                  }
                  else
                  {
                    //parameter for api AID0005
                    magazineinputParam ={
                      contract_id: this.contractId,
                      data_section: 5,
                      process_date_start:this.startDateResult,
                      process_date_end:this.endDateResult,
                      sort_date:'',
                      sort_title:'',
                      start_num:1,
                      load_num:10,
                      topics_id: this.setMailThemeId
                    }
                  }

                  this.fullscreenLoading = true;
                  //Api call to get magazine article
                  this.$store.commit('situation/setIsTopPageInitialLoading', true);
                  this.$store.dispatch('communication/getMagazineArticles', magazineinputParam).then(() => {
                    let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                    this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                  }).catch(()=>{
                    this.$store.commit('situation/setIsTopPageInitialLoading', false);
                    this.fullscreenLoading = false;
                  })
                }
                else
                {
                  let magazineNewsLabel = "雑誌(" + this.getThemeMagazineCount + "件)";
                  this.$store.commit('situation/setMagazineTotalLabel', magazineNewsLabel);
                  this.$store.commit('situation/setIsTopPageInitialLoading', false);
                }
              }
            }
            
          })
          .catch(()=>{
            this.$store.commit('situation/setIsTopPageInitialLoading', false);
            this.fullscreenLoading = false;
          })
        }
        else
        {
          //no action needed
        }
      }
    })

    var credentials = {
      contract_id:this.contractId,
      user_id:this.userId
    };

    //Api call for get search dropdown data
    this.$store.dispatch('communication/getArticleSearch', credentials);

  },
  created(){
    //get the subtheme_display_flag from session
    this.defaultNodeExpansion = this.getSubthemeDisplayFlag;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
@import "../../assets/css/style.css";
.sideBar .custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.sideBar .secondCondition {
  margin-top: 85px !important;
  width: 100%;
}

.sideBar .searchSelect {
  width: 100% !important;
  margin-left: 30px;
  margin-bottom: 10px;
}

.sideBar .inputKeyword {
  width: 100% !important;
  margin-left: 17px;
  margin-bottom: 10px;
}

.sideBar .secondCondition div:last-child {
  width: 100%;
}

.sideBar .searchMediaName {
  width: 100% !important;
  margin-left: 4px;
  margin-bottom: 10px;
}

.sideBar .conditionLable {
  float: left;
  font-size: 9.6pt !important;
  padding-top: 5px;
}

.sideBar .articleDurationLable {
  padding-right: 17px;
}

.sideBar .searchConditionButton {
  padding: 5px 10px !important;
  background: #409eff !important;
  color: #fff !important;
  float: right;
  font-size: 9.6pt;
}

.sideBar .articleDuration /deep/ {
  width: 100% !important;
  margin-left: 15px;
  margin-bottom: 10px;
}

.sideBar .conditionSearch .el-form-item__label {
  width: 0px !important;
}

.sideBar .searchBox {
  position: relative;
  list-style: none;
}

.sideBar .searchIcon {
  position: absolute;
  width: 15px;
  height: 15px;
  right: 6px;
  top: 7px;
}

.sideBar .otherSpan {
  display: flex !important;
}

.sideBar .otherSpan a {
  color: var(--grayDark);
  text-decoration: none!important;
}

.sideBar .ico_link_up {
  background: url("../../assets/image/ico_link_up.svg") no-repeat;
  width: 15px;
  height: 15px;
  margin-left: -5px;
  margin-top: 5px;
}

.sideBar .ico_link_up:hover {
  background: url("../../assets/image/ico_link_over.svg");
}

.sideBar .ico_link_up:focus {
  background: url("../../assets/image/ico_link_down.svg");
  outline: none;
}

.sideBar .ico_mail_up {
  background: url("../../assets/image/ico_mail_up.svg") no-repeat;
  width: 17.07px;
  height: 16px;
  margin-right: 4px;
  margin-top: 5px;
  margin-left: 2px;
}

.sideBar .ico_mail_up_disable {
  background: url("../../assets/image/ico_mail_up.svg") no-repeat;
  width: 17.07px;
  height: 16px;
  margin-right: 4px;
  margin-top: 5px;
  margin-left: 2px;
  opacity: 0.2;
}

.sideBar .ico_mail_up:hover {
  background: url("../../assets/image/ico_mail_over.svg") no-repeat;
}

.sideBar .ico_mail_up:focus {
  background: url("../../assets/image/ico_mail_down.svg") no-repeat;
  outline: none;
}

.sideBar .vc-arrows-container {
  padding-top: 0px !important;
}

.sideBar .custom-calender {
  width: 235px;
  padding-left: 0px !important;
}

.sideBar .el-footer {
  width: 235px;
  padding: 0px 0px 0px 3px !important;
  height: 260px !important;
  margin: 0 auto;
}

.sideBar .buttonDiv {
  position: relative;
  margin-bottom: 8px;
  margin-top: 8px;
  height: 25px;
}

.sideBar .cal-top-btn {
  right: 3px;
  height: 25px;
  padding: 0px 10px !important;
  position: absolute !important;
  z-index: 9;
  left: auto !important;
  font-size: 9.6pt;
}

.sideBar .attachLink {
  margin-left: 4px;
}

.sideBar .searchBox .el-input .el-input__inner {
  height: 26px !important;
}

.sideBar .fa-envelope-open {
  margin-right: 4px;
}

.sideBar .el-button--primary:focus {
  background: #3282ce !important;
  color: #fff !important;
  border: 1px solid #3282ce !important;
}

.sideBar .side-menu-middle ul li:first-child {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.sideBar .searchBox .el-input__inner {
  height: 27px;
  padding: 6px;
}

.sideBar .el-header {
  height: 35px !important;
  padding: 0px !important;
}

.sideBar .custom-calender {
  padding-left: 15px;
}

.sideBar .lbl-top {
  background-color: var(--primary);
  color: var(--white);
  height: 30px;
  text-align: center !important;
  font-weight: bold;
  font-size: 9.6pt;
  margin-bottom: 2px;
  padding: 0px 10px;
  border-radius: 4px;
}

.sideBar .lbl-top span {
  padding-top: 5px;
  display: block;
}

.sideBar .otherSpan span {
  padding-top: 3px;
  display: block;
  line-height: 2;
  display: block;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}

.sideBar .lbl-middle span {
  padding-top: 5px;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.sideBar .lbl-bottom span {
  padding-top: 2px;
  display: block;
}

.sideBar .lbl-middle {
  background-color: var(--secondary);
  color: var(--white);
  height: 30px;
  text-align: center !important;
  font-weight: bold;
  font-size: 9.6pt;
  padding: 0px 10px;
  border-radius: 4px;
}

.sideBar .lbl-bottom {
  background-color: var(--primary);
  color: var(--white) !important;
  height: 30px !important;
  text-align: center !important;
  font-weight: bold;
  font-size: 9.6pt;
  margin-bottom: 2px;
  padding: 0px 10px;
  border-radius: 4px;
}

.sideBar .side-menu-top ul {
  padding: 0px;
  margin: 5px 0px;
  margin-bottom: 0px !important;
}

.sideBar .side-menu-top ul li {
  list-style: none;
  text-align: left;
  
}
.sideBar .side-menu-bottom ul {
  padding: 0px;
  margin: 5px 0px;
  margin-bottom: 0px !important;
}

.sideBar .side-menu-bottom ul li {
  list-style: none!important;
  text-align: left;
  margin-bottom: 10px;
  font-size: 9.6pt;
  color: var(--grayDark);
  padding-left: 27px;
  /* 2021/02/08 #10495 START */
  height: 17px;
  /* 2021/02/08 #10495 END */
}

.sideBar .side-menu-bottom ul li a {
  color: var(--grayDark);
  text-decoration: none!important;
}

.sideBar .nested-list {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.sideBar .el-tree-node__expand-icon.is-leaf {
  margin-right: 15px !important;
}

.sideBar .nested-list li div .el-tree .el-tree-node .el-tree-node__content {
  height: 27px !important;
}

.sideBar .nested-list li {
  font-size: 9.6pt;
  color: var(--grayDark);
}

.sideBar .nested-list li {
  padding-left: 27px;
  font-size: 9.6pt;
  line-height: 2.5;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  cursor: pointer;
}



.sideBar .el-tree {
  color: var(--grayDark);
  font-size: 9.6pt;
}

.sideBar .side-menu-middle,
.el-divider--horizontal:nth-child(2) {
  margin-bottom: 16px;
}

.sideBar .side-menu-middle,
.el-divider--horizontal:nth-child(1) {
  margin-bottom: 16px;
  margin-top: 0px !important;
}

.sideBar .sidebar-divider {
  background-color: var(--grayLight);
  margin-top: 8px;
  margin-bottom: 8px;
}

.sideBar .side-menu-middle ul {
  padding: 0px;
  margin: 16px 0px 0px;
  color: var(--grayDark);
  font-size: 9.6pt;
}

.sideBar .side-menu-middle ul li {
  list-style: none;
  text-align: left;
  color: var(--grayDark);
  font-size: 9.6pt;
  height: 27px;
  line-height: 2;
}

.sideBar .side-menu-middle li {
  margin: 13px 0px 15px 0px !important;
}

.sideBar .side-menu-middle li:nth-child(2) {
  color: var(--grayDark);
  padding-left: 0px;
  font-size: 9.6pt;
  margin: 10px 0px;
  display: block;
}

.sideBar .side-menu-middle li.otherSpan {
  color: var(--grayDark);
  padding-left: 27px;
  font-size: 9.6pt;
  margin: 10px 0px;
}

.sideBar .side-menu-middle li:nth-child(5) {
  color: var(--grayDark);
  padding-left: 27px;
  font-size: 9.6pt;
  margin: 10px 0px;
}

.sideBar .side-menu-middle li:nth-child(6) {
  color: var(--grayDark);
  padding-left: 27px;
  font-size: 9.6pt;
  margin: 10px 0px;
  line-height: 2.2;
}

.sideBar .el-side-bar {
  padding: 0px !important;
  margin-left: 11px;
  margin-top: -12px;
}

.sideBar .dataBase {
  display: block;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
  width: 86px;
}

.sideBar .calenderDiv {
  margin-top: -6px;
  width: 235px;
  margin-left: 2px;
}

.sideBar .rightDiv span input {
  border: 1px solid #dedede !important;
  box-shadow: none;
  height: 30px;
  padding: 0px 5px;
  font-size: 9pt;
}

.sideBar .treeFirstChild {
  width: 100%;
}

.sideBar .searchConditionForm {
  margin-top: 45px;
}

.sideBar .selectDivFirst {
  width: 100%;
  display: block;
  margin-bottom: 15px;
}

.sideBar .selectDivSecond {
  width: 100%;
  display: block;
  margin-bottom: 15px;
}

.sideBar .selectDivThred {
  width: 100%;
  display: block;
  margin-bottom: 15px;
}

.sideBar .selectDivFour {
  width: 100%;
  display: block;
  margin-bottom: 15px;
  margin-top: 15px;
}

.sideBar .leftDiv {
  margin-left: -34px;
  padding-top: 6px;
  padding-right: 5px;
  font-size: 9.6pt;
  float: left;
  width: 85px;
  text-align: left;
}
.sideBar .rightDiv {
  margin-bottom: 10px;
  display: flex;
}

.sideBar .vc-reset,
.vc-reset * input {
  width: 100% !important;
}

.sideBar .customDivNode {
  width: 100%;
}
.sideBar .rightDiv .el-select {
  width: 100% !important;
}

#RightSideBar >>> #SearchBoxInput {
  height: 27px;
}

#RightSideBar >>> .el-input__inner {
  height: 27px !important;
}

.sideBar .vc-popover-content-wrapper {
  transform: translate3d(0px, 127px, 50px) !important;
}

.sideBar .el-input__inner {
  height: 27px !important;
}

.sideBar .side-menu-middle .el-tree-node__children .el-tree-node__content {
  height: auto !important;
  margin-top: 20px;
}

.sideBar .iconMailEnvalop {
  float: left;
}

.sideBar .ReceiveEmailTheme {
  padding-left: 4px;
  line-height: 2.4;
  cursor: pointer;
}

.sideBar .ReceiveEmailTheme__Disable {
  padding-left: 4px;
  line-height: 2.4;
  pointer-events:none;
  opacity:0.4;
}

.sideBar .customTree .el-icon-caret-right {
  color: var(--grayDark2) !important;
}

.sideBar .topTree .el-icon-caret-right {
  color: var(--grayDark2) !important;
}

.sideBar .el-tree-node__expand-icon.is-leaf {
  visibility: hidden;
}

.vc-weeks .vc-grid-cell-row--7:first-child  .vc-weekday
{
  color:red;
}
.vc-weeks .vc-grid-cell-col--7 .vc-day .vc-day-content
{
  color:red !important;
}
.vc-weeks .vc-grid-cell-row--7:nth-child(7)  .vc-weekday
{
  color:blue;
}
.vc-weeks .vc-grid-cell-col--1  .vc-day  .vc-day-content
{
  color:blue !important;
}

.sideBar .customTree .el-tree-node__children {
  height: auto;
}

.sideBar  .side-menu-new {
  border-right: none !important;
}

.sideBar .side-menu-new .el-menu-item {
  text-align: left;
  height: 35px;
  line-height: 32px;
}
.ReceiveEmailTheme a {
  text-decoration: none;
      color: inherit;
}

/* 2020-06-23 RS */
.el-tree-list {
  padding-left: 0px !important;
}

.activeList  {
  color: var(--white) !important;
  background: var(--secondary) !important;
  font-size: 9.6pt;
  line-height: 2.5;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  cursor: pointer;
}
.el-tree-node__content:focus {
  background: var(--secondary) !important;
  color: var(--white) !important;
}

/** SID0003 Style newly added ************************/



.SID0003__emailsecurity .SID0003__Container .el-select .el-input {
    width: 100% !important;
}
.SID0003__emailsecurity .SID0003__Container  .buttonSpan {
    color: red;
    padding-left: 22px;
}
.parentDiv {
	padding-top: 12px;
	width: 100%;
	overflow: hidden;
	min-width: 1000px;
  }
.SideBarRight,
.SideBarRight SideBar {
	width: 250px;
}
.sideBar .el-side-bar {
	display: block;
	overflow: hidden;
  }
.SideBarLeft {
	overflow: hidden !important;
	min-width: 750px;
}
.el-divider {
	background-color: var(--grayLight);
}

.SID0003__emailsecurity .emailform0003{
 margin-bottom: 20px !important;
  
}
.SID0003__emailsecurity .formheight .el-input__inner{
  height: 40px !important;
}
.SID0003__emailsecurity .label-emailform0003{
   margin-bottom: 20px !important;
}
.SID0003__emailsecurity .SID0003__Container .el-table th {
	text-align: center !important;
}
.SID0003__emailsecurity .SID0003__Container .div-form .el-form-item__label {
	padding-right: 15px !important;
	font-weight: bold;
}
.SID0003__emailsecurity .SID0003__Container .formMailVaidate{
	width: 100%;
}
.SID0003__emailsecurity .SID0003__Container .div-form #label-left-align label{
	text-align: left !important;	
}
.SID0003__emailsecurity .SID0003__Container .div-form #label-left-align .el-form-item__label-wrap{
	margin-left: 0px !important;	
}

.inputSwitch{
    padding-top: 10px !important;
}
.inputSelect
{
	width: 60% !important;
}
.inputGroupSelect
{
	width: 36% !important;
}

/* Split pane style */
.splitpanes__pane {
	box-shadow: 0 0 1px rgba(0, 0, 0, 0.2) inset;
	justify-content: center;
	align-items: center;
	display: flex;
}
.default-theme.defaultStyle .splitpanes__splitter {
	border-left: 3px solid #DEE2E8 !important;
}

.defaultStyle {
	width: 100%;
	margin: 0px auto;
}

p {
	position: absolute;
	bottom: 5px;
	right: 5px;
	color: #666;
	z-index: 10;
	font-size: 12px;
}

p a {
	color: inherit;
}

.custom-splite {
	margin-bottom: 50px;
}
.SID0003__emailsecurity .SID0003__Container .resultDiv  {
	width: 700px;
}
.SID0003__emailsecurity .SID0003__Container .result-main-divider {
	margin: 0px !important;
	background: var(--grayLight) !important;
	width: 100%;
	margin-bottom: 14px !important;
}
.SID0003__Container {
	color: #333333;
	text-align: left;
}
.SID0003__Container div .Inquiry__Title {
	margin-top: 15px;
	margin-bottom: 18px;
	display: block;
}
.SID0003__Container  div .Inquiry__condition {
	margin-bottom: 10px;
	display: block;
}
.SID0003__Container .ButtonSubmit {
	margin-top: 24px;
	padding-bottom: 20px !important;
}

.SID0003__Container .ButtonDiv {
	margin-top: 24px;
	text-align: center;
}
.SID0003__Container
	.el-table
	table
	.is-group.has-gutter
	tr
	th {
	color: var(--tableFont);
	background: transparent !important;
	font-weight: 700;
	text-align: center;
}
.SID0003__Container
	.el-table
	.el-table__body-wrapper.is-scrolling-none
	table
	tbody
	tr
	td {
	text-align: right;	
}
.SID0003__Container
	.el-table
	{
	width: 100% !important;
    border: 1px solid #EBEEF5 !important;	
	}
.SID0003__Container
	.el-table
	.el-table__body-wrapper.is-scrolling-none
	table
	tbody
	tr:last-child
	td:nth-child(1) {
	text-align: center;
	font-weight: 700;
}
.SID0003__Container
	.el-table
	.el-table__body-wrapper.is-scrolling-none
	table {
	color: var(--tableFont);
	table-layout: auto;
}
.SID0003__Container .el-table th>.cell {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.SID0003__emailsecurity .SID0003__Container .el-breadcrumb {
  text-align: left;
  text-decoration: none;
  font-style: normal;
  font-weight: 400;
  line-height: 1  ;
  margin-bottom: 20px;
}
.el-breadcrumb__inner a,
.el-breadcrumb__inner.is-link {
  font-weight: 400 !important;
}
.SID0003__emailsecurity.SID0003__Container .el-breadcrumb .el-breadcrumb__item .el-breadcrumb__inner.is-link  {
  font-weight: 400;
}
 .SID0003__Container .el-table .cell {
	overflow: hidden !important;
    white-space: nowrap !important;
    text-overflow: ellipsis !important;
}
.SID0003__Container {
	width: 85%;
	margin: 0px auto;
}

.SID0003__emailsecurity 
.SID0003__Container 
.el-container 
.resultDiv 
.el-form.div-result 
.el-form-item 
.el-form-item__label {
    padding: 0 25px 0 0;
}
.SID0003__Container .el-table .el-table__body-wrapper.is-scrolling-none table tbody tr td:nth-child(1) {
	text-align: left;
}

.SID0003__Container .el-table .el-table__body-wrapper.is-scrolling-none table tbody tr td:nth-child(2) {
	text-align: left;
}
.SID0003__Container .el-table .el-table__body-wrapper.is-scrolling-none table  tbody  tr td {
	text-align: left;
}

.SID0003__Container .el-table .el-table__body-wrapper.is-scrolling-none table tbody tr:last-child td:nth-child(2){
	text-align: left;
}
.SID0003__Container .el-tooltip__popper
{
	display:none !important;
}
 .SID0003__Container .el-table .cell.el-tooltip
{
	white-space: nowrap !important;
	min-width: auto !important;
}
.SID0003__Container .el-table th
{
	color:#333333;
}
.SID0003__emailsecurity .emailsecurity0003{
    color: #CF142B;
}
.SID0003__emailsecurity .checkbox0003{
 margin-right: 25px !important;
}
.sideBar .el-side-bar {
	display: block;
	overflow: hidden;
  }
.SID0003_Container .el-dialog__header {
    display: none;
}
.sideBar .side-menu-middle, .el-divider--horizontal:nth-child(1) {
    margin-bottom: 16px;
    margin-top: 0px !important;
}
.sideBar .sidebar-divider {
	margin-bottom: 0px;
}
.Nullhandle .el-tree__empty-block .el-tree__empty-text{
  display: none;
  
}
.Nullhandle .el-tree__empty-block {
  min-height: auto !important;
}

.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
  color: var(--white) !important;
  background: var(--secondary) !important;
}
</style>
